// src/frontend/fr.json
var setting = {
  preference: {
    notification: {
      sub: "Activer la notification contextuelle n\xE9cessaire.",
      title: "Pr\xE9f\xE9rence de notification popup",
      unsaved_screen: {
        sub: "Recevez une notification lorsque vous avez une vue non enregistr\xE9e.",
        title: "Activer la notification de vue non enregistr\xE9e"
      }
    },
    language: {
      subtitle: "S\xE9lectionnez votre langue pr\xE9f\xE9r\xE9e.",
      success_message: "La pr\xE9f\xE9rence de langue a \xE9t\xE9 enregistr\xE9e.",
      title: "Langue"
    },
    unsaved_screen_notification: {
      title: "Ne plus me montrer cette notification",
      sub: "Si vous cochez cette case, vous ne recevrez plus cette notification. Vous pouvez modifier cette pr\xE9f\xE9rence sur la page des param\xE8tres."
    },
    save_changes: "Enregistrer les modifications"
  },
  profile: {
    picture: {
      format_error: "Format ou taille probablement incorrects.",
      error: "L'image n'a pas pu \xEAtre t\xE9l\xE9charg\xE9e"
    },
    profile_picture_title: "Photo de profil",
    confirm_delete_pp: {
      cancel_button: "Annuler",
      delete_button: "Supprimer le compte",
      modal_title: "Confirmer la suppression",
      msg: "Pour confirmer que vous souhaitez supprimer votre compte, veuillez saisir votre Pr\xE9nom ci-dessous et cliquer sur le bouton Supprimer le compte."
    },
    notification: {
      error: "Quelque chose s'est produit",
      success: "R\xE9ussi",
      send_email_duplicated_msg: "Un e-mail de v\xE9rification a \xE9t\xE9 envoy\xE9 dans l'une minute, veuillez v\xE9rifier votre bo\xEEte aux lettres.",
      send_email_success_msg: "Un email de v\xE9rification a \xE9t\xE9 envoy\xE9, veuillez v\xE9rifier votre adresse email.",
      wrong_first_name_msg: "Veuillez saisir votre pr\xE9nom correct.",
      change_pp_success_msg: "Votre photo de profil a \xE9t\xE9 chang\xE9e avec succ\xE8s."
    },
    email_preferences: {
      marketing: {
        title: "Emails de marketing",
        sub: "Recevez des nouvelles concernant la soci\xE9t\xE9"
      },
      sub: "Modifiez vos pr\xE9f\xE9rences d'email",
      title: "Pr\xE9f\xE9rences d'email",
      technical: {
        sub: "Recevez les journaux1 de modifications lorsque l'application a de nouvelles fonctionnalit\xE9s",
        title: "Emails techniques"
      }
    },
    email_verification_note: {
      button: "Renvoyer le code de v\xE9rification",
      msg: "Veuillez v\xE9rifier votre adresse email avant d'utiliser la plateforme.",
      title: "V\xE9rifiez votre adresse email"
    },
    profile_picture_title_sub: "T\xE9l\xE9chargez votre photo de profil.",
    delete_my_account_title: "Supprimer mon compte",
    personal_info_title: "Informations personnelles",
    delete_my_account_title_sub: "Il n'y a pas de retour possible.",
    save_changes: "Enregistrer les modifications",
    confirm_crop: "Confirmer",
    personal_info_title_sub: "Mettez \xE0 jour vos donn\xE9es personnelles.",
    click_to_upload: "Cliquez pour t\xE9l\xE9charger la photo de profil",
    click_to_upload_file_constraints: "ou faites glisser et d\xE9posez un fichier PNG, JPEG ou JPG"
  },
  seats: {
    am_table: {
      col_name: {
        email: "Adresse email du responsable de compte",
        phone: "Num\xE9ro de t\xE9l\xE9phone du responsable de compte",
        name: "Responsables de compte"
      }
    },
    payment_warning: {
      msg: {
        owner: "Veuillez contacter votre responsable de compte.",
        user: "Veuillez contacter ce responsable d'entreprise.",
        unpaid: "Votre entreprise est au-del\xE0 de la date d'\xE9ch\xE9ance de paiement. Votre abonnement doit \xEAtre r\xE9gularis\xE9.",
        ended: "Votre contrat est termin\xE9. Avez-vous profit\xE9 de tous les avantages de nos services ?",
        no_slot: "Vous n'\xEAtes assign\xE9 \xE0 aucune licence. Veuillez vous attribuer la licence correspondante.",
        end_trial: "Votre p\xE9riode d'essai est termin\xE9e. Avez-vous profit\xE9 de tous les avantages de nos services ?"
      },
      button: "Contactez le service client",
      title: "Il y a eu un probl\xE8me avec votre paiement"
    },
    plan_card: {
      info: "{{used}} sur {{total}} licences utilis\xE9es"
    },
    member_table: {
      col_name: {
        role: "R\xF4le",
        name: "Nom",
        right: "Droits",
        last_activity_date: "Actif depuis"
      }
    },
    delete_user: {
      multiple: {
        confirm_msg: "\xCAtes-vous s\xFBr de vouloir supprimer ces {{number}} utilisateurs ?"
      },
      success_msg: "L'utilisateur a \xE9t\xE9 supprim\xE9.",
      confirm_msg: "\xCAtes-vous s\xFBr de vouloir supprimer cet utilisateur {{firstName}} {{lastName}} ?"
    },
    investor: {
      name: "Investisseur"
    },
    institutional: {
      name: "Institutionnel"
    },
    no_slot_warning: {
      title: "Vous n'avez pas d'abonnement"
    },
    consumer: {
      name: "Consommateur"
    }
  },
  security: {
    link_device: {
      notice: "Nous allons dissocier votre appareil actuel de votre compte afin que vous puissiez lier votre compte \xE0 un nouvel appareil. Vous serez d\xE9connect\xE9 pour pouvoir lier le nouvel appareil. Le TOTP pr\xE9c\xE9dent ne fonctionnera plus. Veuillez confirmer si vous souhaitez proc\xE9der \xE0 l'op\xE9ration.",
      title: "Connecter \xE0 un nouvel appareil",
      subtitle: "Liez votre compte \xE0 un nouvel appareil si vous n'avez plus acc\xE8s \xE0 l'appareil actuellement li\xE9."
    },
    warning_note: {
      content: "Il est recommand\xE9 de r\xE9g\xE9n\xE9rer vos codes de r\xE9cup\xE9ration p\xE9riodiquement. Proc\xE9dez \xE0 l'op\xE9ration avec le bouton ci-dessous.",
      title: "R\xE9g\xE9n\xE9rez vos codes de r\xE9cup\xE9ration"
    },
    password: {
      title: "Mot de passe",
      error_message: "Les mots de passe doivent \xEAtre identiques",
      disclaimer: "Le mot de passe doit contenir au moins 8 caract\xE8res.",
      save_changes: "Enregistrer les modifications",
      subtitle: "Changez votre mot de passe",
      confirm: "Confirmer le nouveau mot de passe",
      success_message: "Mot de passe mis \xE0 jour avec succ\xE8s !"
    },
    renegerate_code: {
      subtitle: "Vos anciens codes de r\xE9cup\xE9ration ne fonctionneront plus.",
      success: "Nouveaux codes de r\xE9cup\xE9ration enregistr\xE9s avec succ\xE8s.",
      title: "R\xE9g\xE9n\xE9rer les codes de r\xE9cup\xE9ration"
    }
  },
  organization: {
    details: {
      zip: "Code postal",
      city: "Ville",
      name: "Nom de l'entreprise",
      no_contact_name: "Aucun utilisateur de contact assign\xE9",
      title: "Informations sur l'entreprise",
      phone: "Num\xE9ro de t\xE9l\xE9phone",
      subtitle: "Mettez \xE0 jour les d\xE9tails de votre entreprise.",
      contact_subtitle: "Utilisateur de r\xE9f\xE9rence pour les communications",
      address: "Adresse",
      country: "Pays",
      contact_name: "Personne de contact",
      email: "Adresse e-mail"
    },
    notification: {
      update_success: "Les mises \xE0 jour ont \xE9t\xE9 appliqu\xE9es avec succ\xE8s."
    },
    logo: {
      title: "Logo de l'entreprise",
      subtitle: "Mettez \xE0 jour le logo de votre entreprise."
    }
  },
  connections: {
    options: {
      day: "{{ number }} Jour",
      months: "{{ number }} Mois",
      year: "{{ number }} An",
      days: "{{ number }} Jours"
    },
    modal: {
      delete: {
        title: "Supprimer {{ count }} cl\xE9s",
        subtitle: "\xCAtes-vous s\xFBr de vouloir supprimer ces cl\xE9s ? Cette action ne peut pas \xEAtre annul\xE9e."
      },
      name: {
        placeholder: "Exemple de nom",
        label: "Nom cl\xE9"
      },
      warning: {
        title: "Valeurs manquantes",
        fill: "Veuillez remplir tous les champs"
      },
      delete_confirm: "Supprimer",
      button_copy: "Copier et fermer",
      copied: "La cl\xE9 a \xE9t\xE9 copi\xE9e dans le presse-papiers.",
      create: {
        title: "Cr\xE9er une cl\xE9 API",
        subtitle: "Une fois cr\xE9\xE9e, cette cl\xE9 ne sera plus jamais visible. Si elle est compromise, la cl\xE9 doit \xEAtre supprim\xE9e et une nouvelle cl\xE9 doit \xEAtre cr\xE9\xE9e."
      },
      expiration: {
        label: "Dur\xE9e de validit\xE9",
        placeholder: "Choisissez une dur\xE9e"
      },
      button_create: "Cr\xE9er une cl\xE9",
      delete_cancel: "Annuler",
      copy_error: "Erreur lors de la copie. Veuillez copier manuellement."
    },
    name: {
      error: "Le nom est trop court"
    },
    tokens_table: {
      col_name: {
        expires_at: "Date d'expiration",
        name: "Nom cl\xE9",
        enterprise: "Entreprise",
        user: "Utilisateur",
        created_at: "Date de cr\xE9ation"
      }
    },
    table_name: {
      personnal: "Cl\xE9s personnelles",
      app: "Cl\xE9s d'application"
    },
    days: {
      error: "Les jours d'expiration sont requis"
    }
  },
  collaborator: {
    table_name: "Membres de l'\xE9quipe",
    reinvite_user: "Un e-mail d'invitation a \xE9t\xE9 envoy\xE9 avec succ\xE8s.",
    modal: {
      link_companies: {
        success_msg: "Les entreprises g\xE9r\xE9es par {{name}} ont \xE9t\xE9 mises \xE0 jour avec succ\xE8s.",
        subtitle: "Entreprise",
        title: "Entreprises"
      }
    },
    col: {
      companies: "Entreprises",
      invitation_process: "Processus d'invitation"
    }
  },
  companies: {
    table_name: "Membres de l'entreprise"
  },
  company: {
    set_contact_user: {
      success: "L'utilisateur a \xE9t\xE9 d\xE9fini comme personne de contact avec succ\xE8s."
    }
  }
};
var units = {
  official_installed_solar_power: "kW",
  computed_weighted_average_cost_of_debt: "%",
  energy_intensity: "kWh/m\xB2/an",
  total_area: "m\xB2",
  transport_accessibility: "pts",
  r_revenue_from_postal_and_bank_accounts: "CHF",
  r_estimated_liquidation_taxes: "CHF",
  total_expense_ratio_ref_gav: "%",
  r_resiential_net_rent: "CHF",
  one_month_return: "%",
  idc: "kWh/an",
  stock_volume: "Unit\xE9s",
  c_market_value: "CHF",
  roi: "%",
  canton_rent: "CHF",
  total_expense_ratio_ref_nav: "%",
  r_plots_net_rent: "CHF",
  distribution_yield: "%",
  r_construction_and_works_fees: "%",
  r_tna_after_distribution: "CHF",
  r_net_assets_at_end_of_the_financial_year: "CHF",
  c_commercial_market_value: "CHF",
  computed_loan_to_value: "%",
  commercial_net_rent_m2: "CHF/m\xB2",
  r_ebit: "CHF",
  c_five_years_total_return: "%",
  r_commercial_cost_price: "CHF",
  target_rent: "CHF",
  reported_market_value: "CHF",
  computed_total_cash_per_share: "CHF",
  rent_per_m2: "CHF/m\xB2",
  beta: "%",
  reported_performance: "%",
  total_tenant_charges: "CHF",
  r_share_buyback_commissions: "%",
  r_nav_before_distribution: "CHF",
  c_nav_after_distribution: "CHF",
  computed_earnings_per_share: "CHF",
  price_per_m2: "CHF/m\xB2",
  r_commercial_spaces_area: "m\xB2",
  r_other_expenses: "CHF",
  potential_charges_per_m2: "CHF",
  r_cost_price_per_m2: "CHF/m\xB2",
  r_roi: "%",
  reported_real_rent: "CHF",
  income_per_taxpayer: "CHF",
  portfolios: {
    floods_50_years: "%",
    hail_hazard_10_years_average: "%",
    avalanches: "%",
    landslides: "%",
    distribution: "%",
    accessibility: "m",
    overbank_sedimentation: "%",
    rockfalls: "%",
    distribution_area: "m\xB2",
    debris_flow: "%"
  },
  climate_risk_index: "%",
  c_three_years_total_return: "%",
  c_nav_compounded: "CHF",
  funds: {
    floods_50_years: "%",
    transactions: {
      value: "CHF"
    },
    sia261: "%",
    landslides: "%",
    rockfalls: "%",
    avalanches: "%",
    overbank_sedimentation: "%",
    debris_flow: "%",
    hail_hazard_10_years: "%"
  },
  five_years_return: "%",
  six_months_return: "%",
  r_valuation_and_auditing_expenses: "CHF",
  r_valuation_expenses: "CHF",
  official_area: "m\xB2",
  c_earnings_per_share: "CHF",
  c_total_market_value: "CHF",
  c_current_agio_after_distribution: "%",
  net_initial_yield: "%",
  c_tna_compounded: "CHF",
  return_on_invested_capital: "%",
  total_idc: "kWh/an",
  total_co2: "kg/m\xB2/an",
  press_score: "/10",
  r_profit_and_capital_taxes: "CHF",
  c_median_cost_of_debt: "%",
  r_taxes: "CHF",
  r_roa: "%",
  real_charges_monthly: "CHF",
  r_net_rent_q1: "CHF/m\xB2",
  ter_nav: "%",
  solar_existing_per_m2: "kWh/m\xB2",
  market_dividend: "CHF",
  solar_potential: "kWh/an",
  c_median_maturity: "an",
  c_resiential_net_rent: "CHF",
  computed_median_maturity: "an",
  computed_roe: "%",
  mtd_net_return: "%",
  r_capital_employed: "CHF",
  r_management_fees: "%",
  r_realised_income: "CHF",
  r_tga_after_distribution: "CHF",
  r_tna_before_distribution: "CHF",
  three_months_avg_volume: "Unit\xE9s",
  aged_care: "m",
  computed_roa: "%",
  reported_roe: "%",
  real_charges: "CHF",
  r_coverage_idc: "%",
  market_value_per_m2: "CHF/m\xB2",
  reported_dividend_yield: "%",
  computed_total_area: "m\xB2",
  listed_charges: "CHF",
  c_total_net_rent: "CHF",
  energy: {
    distribution_area: "m\xB2"
  },
  r_administration_of_buildings: "CHF",
  c_market_value_q1: "CHF/m\xB2",
  healthcare: "m",
  r_max_management_fees: "%",
  c_net_rent_q3: "CHF/m\xB2",
  computed_total_dwellings_area: "m\xB2",
  share_class_nav: "CHF",
  cultural_venues: "m",
  estimated_net_rent: "CHF",
  high: "CHF",
  r_mixed_market_value: "CHF",
  secondary_education: "m",
  r_total_properties: "CHF",
  r_tga_before_distribution: "CHF",
  r_total_cost_price: "CHF",
  r_ordinary_income_carried_forward_from_previous_financial_year: "CHF",
  r_residential_net_rent: "CHF",
  r_property_management_fees: "%",
  reported_residential_rental_space: "m\xB2",
  r_cost_price_q1: "CHF/m\xB2",
  estimated_net_rent_monthly: "CHF",
  residential_net_rent_m2: "CHF/m\xB2",
  r_unrealised_gains_and_losses_including_var_est_liq_tax: "CHF",
  rental_space: "m\xB2",
  distribution_value: "CHF",
  lot_area: "m\xB2",
  total_co2_scope_33: "kg/an",
  r_total_expenses: "CHF",
  r_agio_at_year_end: "%",
  r_property_management_expenses: "CHF",
  r_total_liabilities: "CHF",
  public_utility_density: "%",
  idc_m2: "kWh/m\xB2/an",
  estimated_total_net_charges: "CHF",
  computed_weighted_average_maturity: "an",
  r_capital_distribution: "CHF",
  estimated_energy_intensity: "kWh/m\xB2/an",
  r_mixed_cost_price: "CHF",
  return_on_investment: "%",
  r_net_rent_median: "CHF/m\xB2",
  climate_normals_temperature_1991_2020: "\xB0C",
  r_cost_price_median: "CHF/m\xB2",
  false: "Non",
  computed_revenue_per_share: "CHF",
  relative_agio: "%",
  potential_net_rent_monthly: "CHF",
  pts: "pts",
  c_weighted_average_interest_rate: "%",
  unit_outstanding: "Unit\xE9s",
  turnover: "CHF",
  c_mixed_market_value: "CHF",
  real_roa: "CHF",
  c_market_value_median: "CHF/m\xB2",
  charges_per_m2: "CHF/m\xB2",
  r_residential_market_value: "CHF",
  reported_ebit: "CHF",
  r_wault: "an",
  six_months_avg_volume: "Unit\xE9s",
  r_invested_capital: "CHF",
  c_loan_to_value: "%",
  hist_volatility_30_days: "%",
  r_realised_capital_gains_and_losses: "CHF",
  r_mixed_rental_space: "m\xB2",
  estimated_total_net_rent_per_m2: "CHF",
  reported_payout_ratio: "%",
  r_dividend_distribution: "CHF",
  c_net_rent: "CHF",
  hail_hazard_10_years_average: "cm",
  birth: "%",
  r_real_rent_per_m2: "CHF/m\xB2",
  debt_financing_ratio: "%",
  computed_pe_ratio: "%",
  r_short_term_liabilities: "CHF",
  reported_target_rent: "CHF",
  r_rental_income: "CHF",
  estimated_charges_monthly: "CHF",
  c_weighted_average_maturity: "an",
  c_pe_ratio: "%",
  five_years_avg_dividend_yield: "%",
  r_payout_ratio: "%",
  r_performance: "%",
  dividend_yield: "%",
  co2_scope_2_per_m2: "kg/m\xB2/an",
  residential_area: "m\xB2",
  c_total_cash_per_share: "CHF",
  real_net_rent: "CHF",
  job_density: "ETP/ha",
  total_co2_scope_1_2_33: "kg/an",
  c_debt_ratio: "%",
  computed_total_commercial_area: "m\xB2",
  c_total_agio_at_year_end: "CHF",
  estimated_area: "m\xB2",
  reported_roce: "%",
  r_maintenance_costs: "CHF",
  r_residential_rental_space: "m\xB2",
  r_max_purchase_and_sale_fees: "%",
  accessibility_index: "%",
  cost_price: "CHF",
  potential_market_value_per_m2: "CHF",
  r_share_issue_commissions: "%",
  r_retained_earnings: "CHF",
  r_idc: "kWh/an",
  death: "%",
  m_market_cap: "CHF",
  swiss_net_rent: "CHF",
  potential_net_rent: "CHF",
  co2: "kg/an",
  potential_roa: "%",
  r_share_price: "CHF",
  estimated_total_net_charges_per_m2: "CHF",
  estimated_total_income: "CHF",
  one_year_return: "%",
  r_market_value_median: "CHF/m\xB2",
  commercial_spaces_area: "m\xB2",
  computed_payout_ratio: "%",
  share_class_nb: "Unit\xE9s",
  potential_charges_monthly: "CHF",
  reported_rental_losses: "%",
  m_share_price: "CHF",
  market_price_var: "%",
  r_roce: "%",
  reported_gross_yield: "%",
  r_auditing_expenses: "CHF",
  m_dividend: "CHF",
  r_net_assets_at_beginning_of_the_financial_year: "CHF",
  last: "CHF",
  r_cost_price_q3: "CHF/m\xB2",
  r_other_rental_space: "m\xB2",
  climate_normals_precipitation_1991_2020: "mm/an",
  r_residential_area: "m\xB2",
  description: {
    distribution: "%",
    distribution_area: "m\xB2"
  },
  computed_median_cost_of_debt: "%",
  three_years_total_return: "%",
  reported_debt_ratio: "%",
  c_ebit_margin: "%",
  volume: "m\xB3",
  c_roce: "%",
  area: "m\xB2",
  estimated_net_rent_per_m2: "CHF",
  reported_mixed_rental_space: "m\xB2",
  net_rent: "CHF",
  r_residential_cost_price: "CHF",
  r_total_rental_space: "m\xB2",
  shops: "m",
  r_coverage_share_fossil: "%",
  reported_roic: "%",
  r_dividend_from_indirect_rental_income: "CHF",
  r_real_rent: "CHF",
  c_net_rent_q1: "CHF/m\xB2",
  r_co2: "kg/an",
  hist_volatility_180_days: "%",
  r_dividend_yield: "%",
  population_density: "personnes/ha",
  market_market_cap: "CHF",
  co2_scope_1_2_33_per_m2: "kg/m\xB2/an",
  share: {
    coverage: "%",
    fossil: "%",
    non_fossil: "%"
  },
  demographic: {
    ages: "%"
  },
  meter: "m",
  surface: "m\xB2",
  r_others_net_rent: "CHF",
  r_total_revenue: "CHF",
  r_long_term_liabilities: "CHF",
  r_absolute_management_fees: "CHF",
  total_expense_ratio_ref_mv: "%",
  road_accessibility: "pts",
  total_co2_scope_1_2_3: "kg/an",
  r_short_term_interest_bearing_mortgages: "CHF",
  r_debt_ratio: "%",
  potential_total_income: "CHF",
  r_gav_before_distribution: "CHF",
  r_market_value_per_m2: "CHF/m\xB2",
  r_total_market_value: "CHF",
  return_on_capital_employed: "%",
  c_current_agio_compounded: "%",
  c_mixed_net_rent: "CHF",
  ytd_net_return: "%",
  c_current_ratio: "%",
  agio: "%",
  r_custodian_bank_fees: "%",
  total_co2_scope_1_2: "kg/an",
  r_ter_mv: "%",
  r_other_interest: "CHF",
  r_share_fossil: "%",
  c_tga_compounded: "CHF",
  one_month_avg_volume: "Unit\xE9s",
  reported_rental_area: "m\xB2",
  reported_plots_rental_space: "m\xB2",
  c_payout_ratio: "%",
  reported_commercial_rental_space: "m\xB2",
  r_net_income_available_for_distribution: "CHF",
  five_years_total_return: "%",
  share_class_gav: "CHF",
  c_current_liabilities: "CHF",
  share_market_price: "CHF",
  return_on_equity: "%",
  r_others_cost_price: "CHF",
  estimated_co2_scope_1_2_33_per_m2: "kg/m\xB2/an",
  potential_net_rent_per_m2: "CHF",
  potential_market_value: "CHF",
  r_dividend_from_capital_gains: "CHF",
  reported_ebit_margin: "%",
  r_idc_per_m2: "kWh/m\xB2/an",
  c_net_initial_yield: "%",
  r_gross_yield: "%",
  r_total_net_assets: "CHF",
  c_roa: "%",
  debt_ratio: "%",
  r_total_net_rent: "CHF",
  computed_roce: "%",
  duplex: "m\xB2",
  c_total_current_agio_compounded: "CHF",
  c_price_to_book_value: "%",
  c_total_current_agio_after_distribution: "CHF",
  true: "Oui",
  one_year_total_return: "%",
  computed_debt_ratio: "%",
  r_absolute_custodian_bank_fees: "CHF",
  r_ter_gav: "%",
  dividend: "CHF",
  r_purchase_and_sale_fees: "%",
  tx_price: "CHF",
  r_coverage_co2: "%",
  commercial_area: "m\xB2",
  reported_other_rental_space: "m\xB2",
  computed_climate_avg_value: "CHF/an",
  inhabitants_per_room: "personnes",
  wault: "an",
  real_market_value: "CHF",
  r_commercial_net_rent: "CHF",
  inhabitants_per_100_m2: "personnes",
  market_cap: "CHF",
  computed_current_ratio: "%",
  r_ebit_margin: "%",
  reported_roi: "%",
  idc_per_m2: "kWh/m\xB2/an",
  solar_existing: "kW",
  co2_scope_1_2_per_m2: "kg/m\xB2/an",
  r_unrealised_capital_gains_and_losses: "CHF",
  total_net_assets: "CHF",
  reported_rental_income: "CHF",
  charges: "CHF",
  c_agio_at_year_end: "%",
  ground_area: "m\xB2",
  roa: "%",
  transport_train: "m",
  r_roic: "%",
  m_dividend_yield: "%",
  office_area: "m\xB2",
  estimated_market_value: "CHF",
  r_property_tax: "CHF",
  roe: "%",
  fifty_two_weeks_low: "CHF",
  ebit_margin: "%",
  c_gav_after_distribution: "CHF",
  co2_scope_1_2_3_per_m2: "kg/m\xB2/an",
  actual_rental_status_target: "CHF",
  built_up: {
    area: "m\xB2",
    ratio: "%"
  },
  c_weighted_average_cost_of_debt: "%",
  c_residential_market_value: "CHF",
  actual_rental_status_real: "CHF",
  co2_scope_33_per_m2: "kg/m\xB2/an",
  rate: "%",
  reported_roa: "%",
  low: "CHF",
  fifty_two_weeks_high: "CHF",
  c_others_market_value: "CHF",
  three_years_return: "%",
  primary_education: "m",
  c_roe: "%",
  r_other_revenue: "CHF",
  restaurants: "m",
  three_months_return: "%",
  r_commercial_rental_space: "m\xB2",
  r_total_interest: "CHF",
  r_maintenance_and_repairs_expenses: "CHF",
  early_years: "m",
  market_value: "CHF",
  r_market_value_q3: "CHF/m\xB2",
  r_long_term_interest_bearing_mortgages: "CHF",
  roic: "%",
  ter_mv: "%",
  reported_total_rental_space: "m\xB2",
  listed_net_rent: "CHF",
  computed_ebit_margin: "%",
  r_net_assets_before_estimated_liquidation_taxes: "CHF",
  actual_market_value: "CHF",
  r_max_share_buyback_commissions: "%",
  total_gross_assets: "CHF",
  estimated_charges_per_m2: "CHF",
  r_max_property_management_fees: "%",
  r_nopat: "CHF",
  total_co2_scope_2: "kg/an",
  market_capitalization: "CHF",
  r_co2_per_m2: "kg/m\xB2/an",
  one_year_avg_volume: "Unit\xE9s",
  r_plots_rental_space: "m\xB2",
  c_revenue_per_share: "CHF",
  r_roe: "%",
  official_ground_area: "m\xB2",
  green_density: "%",
  r_total_income: "CHF",
  estimated_market_value_per_m2: "CHF",
  open: "CHF",
  c_operating_profit: "CHF",
  yearly_management_fee: "%",
  r_dividend_from_direct_rental_income: "CHF",
  actual_rental_status: "CHF",
  rental_losses: "%",
  r_net_income: "CHF",
  gross_rent: "CHF",
  decibels: "dB",
  ter_gav: "%",
  r_max_construction_and_works_fees: "%",
  estimated_charges: "CHF",
  r_market_maker_fees: "CHF",
  r_rental_losses: "%",
  qtd_net_return: "%",
  industrial_area: "m\xB2",
  divorce: "%",
  r_rental_space: "m\xB2",
  r_market_value_q1: "CHF/m\xB2",
  co2_scope_1_per_m2: "kg/m\xB2/an",
  r_total_dividend: "CHF",
  reported_capital_employed: "CHF",
  c_gav_compounded: "CHF",
  r_max_share_issue_commissions: "%",
  implied_volatility: "%",
  vwap: "CHF",
  r_market_cap: "CHF",
  real_net_rent_monthly: "CHF",
  potential_charges: "CHF",
  m_share_price_var: "%",
  reported_wault: "an",
  marriage: "%",
  r_commercial_market_value: "CHF",
  hist_volatility_90_days: "%",
  co2_m2: "kg/m\xB2/an",
  c_net_rent_median: "CHF/m\xB2",
  r_market_value: "CHF",
  r_target_rent: "CHF",
  reported_cost_price: "CHF",
  minute: "min",
  return_on_asset: "%",
  r_mortgage_interest: "CHF",
  c_market_value_q3: "CHF/m\xB2",
  household_size: "personnes",
  r_total_cash: "CHF",
  real_rent: "CHF",
  c_commercial_net_rent: "CHF",
  r_mixed_net_rent: "CHF",
  r_max_custodian_bank_fees: "%",
  computed_net_initial_yield: "%",
  emigration: "%",
  hist_volatility_250_days: "%",
  r_other_short_term_liabilities: "CHF",
  market_price: "CHF",
  alpha: "%",
  payout_ratio: "%",
  transport_bus: "m",
  immigration: "%",
  rent_default_rate: "%",
  per_mill: "\u2030",
  reported_share_price: "CHF",
  r_total_area: "m\xB2",
  estimated_total_net_rent: "CHF",
  r_other_net_rent: "CHF",
  r_other_assets: "CHF",
  r_other_long_term_liabilities: "CHF",
  total_co2_scope_1: "kg/an",
  computed_price_to_book_value: "%",
  r_ter_nav: "%",
  r_building_expenses: "CHF",
  r2: "%",
  five_days_avg_volume: "Unit\xE9s",
  r_net_rent_q3: "CHF/m\xB2",
  r_negative_interest: "CHF",
  r_cost_price: "CHF",
  estimated_roa: "%",
  swiss_francs: "CHF",
  reported_purchase_and_sale_fees: "%",
  reported_long_term_liabilities: "CHF",
  reported_unrealised_gains_and_losses_including_var_est_liq_tax: "CHF",
  computed_three_years_total_return: "%",
  reported_total_revenue: "CHF",
  reported_total_properties: "CHF",
  reported_total_dividend: "CHF",
  computed_gav_after_distribution: "CHF",
  reported_short_term_interest_bearing_mortgages: "CHF",
  reported_net_income_available_for_distribution: "CHF",
  reported_ter_nav: "%",
  reported_absolute_management_fees: "CHF",
  reported_other_interest: "CHF",
  computed_current_agio_after_distribution: "%",
  computed_operating_profit: "CHF",
  reported_nav_before_distribution: "CHF",
  reported_share_issue_commissions: "%",
  reported_other_revenue: "CHF",
  reported_net_income: "CHF",
  computed_five_years_total_return: "%",
  market_last: "CHF",
  reported_ordinary_income_carried_forward_from_previous_financial_year: "CHF",
  reported_tga_before_distribution: "CHF",
  reported_net_assets_before_estimated_liquidation_taxes: "CHF",
  reported_dividend_from_indirect_rental_income: "CHF",
  reported_other_long_term_liabilities: "CHF",
  computed_gav_compounded: "CHF",
  reported_absolute_custodian_bank_fees: "CHF",
  reported_construction_and_works_fees: "%",
  market_five_years_return: "%",
  reported_short_term_liabilities: "CHF",
  reported_total_interest: "CHF",
  reported_ter_mv: "%",
  market_fifty_two_weeks_high: "CHF",
  market_vwap: "CHF",
  computed_tna_compounded: "CHF",
  market_six_months_return: "%",
  reported_total_cash: "CHF",
  market_one_month_return: "%",
  reported_total_income: "CHF",
  listed_total_charges: "CHF",
  reported_custodian_bank_fees: "%",
  reported_total_liabilities: "CHF",
  reported_other_assets: "CHF",
  reported_realised_income: "CHF",
  computed_nav_after_distribution: "CHF",
  reported_auditing_expenses: "CHF",
  reported_unrealised_capital_gains_and_losses: "CHF",
  reported_long_term_interest_bearing_mortgages: "CHF",
  reported_negative_interest: "CHF",
  computed_current_liabilities: "CHF",
  computed_total_current_agio_after_distribution: "CHF",
  market_share_price: "CHF",
  reported_total_expenses: "CHF",
  reported_dividend_from_direct_rental_income: "CHF",
  reported_management_fees: "%",
  market_one_year_total_return: "%",
  reported_valuation_and_auditing_expenses: "CHF",
  reported_net_assets_at_beginning_of_the_financial_year: "CHF",
  market_five_years_total_return: "%",
  reported_building_expenses: "CHF",
  listed_total_net_rent: "CHF",
  reported_property_management_fees: "%",
  reported_market_cap: "CHF",
  reported_other_short_term_liabilities: "CHF",
  reported_dividend_distribution: "CHF",
  reported_mortgage_interest: "CHF",
  reported_taxes: "CHF",
  reported_tna_before_distribution: "CHF",
  market_ytd_net_return: "%",
  reported_nopat: "CHF",
  reported_retained_earnings: "CHF",
  market_one_year_return: "%",
  reported_ter_gav: "%",
  listed_charges_monthly: "CHF",
  market_share_price_var: "%",
  market_fifty_two_weeks_low: "CHF",
  reported_valuation_expenses: "CHF",
  reported_other_expenses: "CHF",
  market_three_years_return: "%",
  reported_capital_distribution: "CHF",
  reported_estimated_liquidation_taxes: "CHF",
  reported_tga_after_distribution: "CHF",
  reported_share_buyback_commissions: "%",
  market_turnover: "CHF",
  market_five_years_avg_dividend_yield: "%",
  computed_current_agio_compounded: "%",
  computed_total_agio_at_year_end: "CHF",
  reported_dividend_from_capital_gains: "CHF",
  reported_administration_of_buildings: "CHF",
  computed_nav_compounded: "CHF",
  computed_total_current_agio_compounded: "CHF",
  market_dividend_yield: "%",
  reported_revenue_from_postal_and_bank_accounts: "CHF",
  reported_maintenance_and_repairs_expenses: "CHF",
  reported_profit_and_capital_taxes: "CHF",
  computed_tga_compounded: "CHF",
  market_three_months_return: "%",
  market_high: "CHF",
  reported_realised_capital_gains_and_losses: "CHF",
  reported_property_tax: "CHF",
  listed_net_rent_monthly: "CHF",
  reported_tna_after_distribution: "CHF",
  reported_agio_at_year_end: "%",
  reported_gav_before_distribution: "CHF"
};
var license_agreement = {
  part7: {
    content6: "entre dans ou propose toute composition ou arrangement avec ses cr\xE9anciers en g\xE9n\xE9ral ; ou",
    content8: "Chaque partie peut r\xE9silier la licence par notification \xE9crite \xE0 l'autre partie dans le cas o\xF9 l'autre partie a enfreint un terme mat\xE9riel de ce CLUF et que l'infraction n'a pas \xE9t\xE9 corrig\xE9e dans les trente (30) jours suivant la r\xE9ception de la notification \xE9crite par la partie concern\xE9e. Une telle r\xE9siliation ne d\xE9clenchera aucun droit de votre part \xE0 obtenir un remboursement.",
    content3: "est incapable de payer ses dettes ou devient insolvable ;",
    content1: "La licence est valable pour la dur\xE9e mentionn\xE9e dans le DT pertinent. En l'absence de termes d\xE9finis dans un DT, la licence est valable pour un an \xE0 compter de la date de signature du DT par les deux parties et sera automatiquement renouvel\xE9e pour des p\xE9riodes successives d'un an, sauf r\xE9siliation par l'une ou l'autre des parties avec un pr\xE9avis \xE9crit de trois mois.",
    title: "7. Terme",
    content4: "fait l'objet d'un ordre \xE9mis ou d'une r\xE9solution adopt\xE9e pour l'administration, la liquidation ou la dissolution (autre que dans le but d'une fusion ou d'une reconstruction solvable);",
    content5: "a un administrateur ou un autre repr\xE9sentant, gestionnaire, fiduciaire, liquidateur, administrateur ou un fonctionnaire similaire nomm\xE9 sur tout ou une partie substantielle de ses actifs ;",
    content10: "La r\xE9siliation de ce CLUF n'affectera pas les droits, r\xE9clamations ou responsabilit\xE9s accumul\xE9s des parties, ni n'affectera la continuit\xE9 en vigueur des clauses suivantes : 6, 11 et 13.",
    content2: "Chaque partie a le droit, sans pr\xE9judice de ses autres droits ou recours, de r\xE9silier la licence imm\xE9diatement par notification \xE9crite \xE0 l'autre partie, si l'autre partie :",
    content7: "est l'objet de tout \xE9v\xE9nement ou circonstance analogue \xE0 l'un des \xE9l\xE9ments pr\xE9c\xE9dents dans toute juridiction applicable.",
    content9: "QUANTHOME peut \xE9galement r\xE9silier la licence sous r\xE9serve d'un pr\xE9avis \xE9crit de trente (30) jours en raison de votre utilisation de l'APP pour enfreindre toute loi applicable li\xE9e \xE0 l'utilisation de l'APP, notamment celles de la Suisse, ou si QUANTHOME consid\xE8re raisonnablement que ses marques ou sa r\xE9putation sont endommag\xE9es en raison de votre action ou omission. Une telle r\xE9siliation ne d\xE9clenchera aucun droit de votre part \xE0 obtenir un remboursement."
  },
  part8: {
    content7: "QUANTHOME N'AURA AUCUNE RESPONSABILIT\xC9 SI L'APPLICATION A \xC9T\xC9 MODIFI\xC9E DE QUELQUE MANI\xC8RE QUE CE SOIT, OU POUR TOUTE D\xC9FAILLANCE R\xC9SULTANT DE L'UTILISATION DE L'APPLICATION AVEC UNE CONFIGURATION MAT\xC9RIELLE, UNE PLATEFORME OU UN SYST\xC8ME D'EXPLOITATION AUTRE QUE CELUI RECOMMAND\xC9.",
    content6: "AUCUNE INFORMATION OU CONSEIL, ORAL OU \xC9CRIT, FOURNI PAR QUANTHOME, SES N\xC9GOCIANTS, DISTRIBUTEURS, AGENTS OU EMPLOY\xC9S NE CR\xC9ERA UNE GARANTIE NI N'AUGMENTERA EN AUCUNE FA\xC7ON L'\xC9TENDUE DE QUELQUE GARANTIE FOURNIE CI-DESSUS.",
    content4: "LE CONTENU DE L'APPLICATION PEUT INCLURE DES INFORMATIONS OBTENUES AUPR\xC8S DE SOURCES TIERCES, ET QUANTHOME N'ASSUME AUCUNE RESPONSABILIT\xC9 OU OBLIGATION QUANT \xC0 L'EXACTITUDE OU \xC0 L'EXHAUSTIVIT\xC9 DE CES INFORMATIONS.",
    content5: "DE PLUS, IL N'Y A AUCUNE GARANTIE DE NON-VIOLATION ET DE TITRE OU DE JOUISSANCE PAISIBLE. QUANTHOME NE GARANTIT PAS QUE L'APPLICATION EST SANS ERREUR OU FONCTIONNERA SANS INTERRUPTION. AUCUN DROIT OU RECOURS NE VOUS SERA CONF\xC9R\xC9. L'APPLICATION N'EST PAS CON\xC7UE, DESTIN\xC9E OU AUTORIS\xC9E \xC0 \xCATRE UTILIS\xC9E DANS DES ENVIRONNEMENTS DANGEREUX REQU\xC9RANT DES CONTR\xD4LES SANS FAILLE, Y COMPRIS, SANS LIMITATION, LA CONCEPTION, LA CONSTRUCTION, L'ENTRETIEN OU L'OP\xC9RATION D'INSTALLATIONS NUCL\xC9AIRES, DE SYST\xC8MES DE NAVIGATION OU DE COMMUNICATION A\xC9RIENNE, DE CONTR\xD4LE DU TRAFIC A\xC9RIEN, ET DE SYST\xC8MES DE SOUTIEN VITAL OU D'ARMES. QUANTHOME D\xC9CLINE SP\xC9CIFIQUEMENT TOUTE GARANTIE EXPRESSE OU IMPLICITE DE CONFORMIT\xC9 \xC0 DE TELLES FINALIT\xC9S.",
    content3: "LE CONTENU DE L'APPLICATION N'A PAS LA PR\xC9TENTION D'\xCATRE COMPREHENSIF OU DE SE SUBSTITUER \xC0 DES CONSEILS PROFESSIONNELS EN INVESTISSEMENT, EN FISCALIT\xC9, EN DROIT OU AUTRES. VOUS DEVRIEZ CONSULTER VOS CONSEILLERS FINANCIERS, FISCAUX OU JURIDIQUES POUR OBTENIR DES INFORMATIONS CONCERNANT VOTRE SITUATION INDIVIDUELLE.",
    title: "8. Avis de non-responsabilit\xE9 sur la garantie",
    content1: "VOUS RECONNAISSEZ EXPRESS\xC9MENT ET ACCEPTEZ QUE L'UTILISATION DE L'APPLICATION EST \xC0 VOTRE PROPRE ET UNIQUE RISQUE. L'APPLICATION EST FOURNIE \xAB EN L'\xC9TAT \xBB SANS GARANTIE D'AUCUNE SORTE PAR QUANTHOME, SES DIRECTEURS, EMPLOY\xC9S, AGENTS ET/OU PARTENAIRES. DANS LA MESURE MAXIMALE AUTORIS\xC9E PAR LA LOI APPLICABLE, QUANTHOME ET SES FOURNISSEURS ET PARTENAIRES D\xC9CLARENT EXPRESS\xC9MENT QU'ILS RENONCENT \xC0 TOUTES GARANTIES ET REPR\xC9SENTATIONS, QU'ELLES SOIENT EXPRESSES, IMPLICITES OU AUTRES, Y COMPRIS LES GARANTIES DE COMMERCIALISABILIT\xC9 OU D'AD\xC9QUATION \xC0 UN OBJECTIF PARTICULIER.",
    content2: "LE CONTENU FOURNI PAR L'APPLICATION NE DOIT PAS \xCATRE INTERPR\xC9T\xC9 COMME UN CONSEIL D'INVESTISSEMENT, UNE RECOMMANDATION OU UNE OFFRE D'ACHAT OU DE VENTE DE QUELQUE INSTRUMENT FINANCIER QUE CE SOIT OU DE PARTICIPER \xC0 UNE STRAT\xC9GIE DE N\xC9GOCIATION PARTICULI\xC8RE. TOUTE CONFIANCE ACCORD\xC9E AU CONTENU EST \xC0 VOTRE SEUL RISQUE."
  },
  part11: {
    content11: "Le traitement de ces donn\xE9es aura lieu conform\xE9ment \xE0 notre Politique de Confidentialit\xE9 que vous pouvez consulter ici.",
    content4: "mot de passe crypt\xE9",
    content7: "Activit\xE9 de connexion et de d\xE9connexion (QUANTHOME se r\xE9serve le droit d'enregistrer et de surveiller l'activit\xE9 g\xE9n\xE9rale des utilisateurs sur notre plateforme, y compris, mais sans s'y limiter, les parcours de navigation, les actions effectu\xE9es et les pages visit\xE9es, dans le but d'am\xE9liorer l'exp\xE9rience utilisateur, d'assurer la s\xE9curit\xE9 et d'am\xE9liorer nos services)",
    content2: "nom complet",
    content8: "Erreurs, pannes et plantages de l'APP et des appareils",
    content3: "email professionnel",
    content1: "Vous convenez que les seules donn\xE9es personnelles \xE0 \xEAtre trait\xE9es par QUANTHOME \xE0 la suite de votre acc\xE8s et de votre utilisation de l'APP consisteront en :",
    content9: "pour chaque utilisateur, \xE0 tout moment (les \u201C<strong>Donn\xE9es</strong>\u201D).",
    content6: "IP et agent utilisateur pour chaque session",
    content10: "Des informations suppl\xE9mentaires peuvent \xEAtre collect\xE9es et trait\xE9es dans le cadre de DT sp\xE9cifiques et avec le consentement explicite du Client.",
    content5: "ID et nom de l'entit\xE9 pour laquelle l'utilisateur est administrateur, membre ou op\xE9rateur",
    title: "11. Protection des donn\xE9es"
  },
  part12: {
    content7: "Rien dans ce contrat de licence d'utilisation (CLUF) ne doit \xEAtre interpr\xE9t\xE9 comme cr\xE9ant un partenariat, une agence, une coentreprise ou une relation employeur/employ\xE9 entre les parties. Aucune des parties n'a l'autorit\xE9 d'assumer ou de cr\xE9er une obligation ou une responsabilit\xE9, expresse ou implicite, au nom de l'autre partie ou de lier cette autre partie de quelque mani\xE8re que ce soit.",
    content6: "Tous les avis en vertu du CLUF doivent \xEAtre faits par \xE9crit et envoy\xE9s \xE0 l'adresse commerciale sp\xE9cifi\xE9e pour le CLUF, sauf si une partie d\xE9signe par \xE9crit une adresse diff\xE9rente. Les parties consentent \xE0 l'utilisation de moyens \xE9lectroniques et de transmissions par t\xE9l\xE9copie pour les communications consid\xE9r\xE9es comme un \xE9crit sign\xE9. Toute reproduction du CLUF r\xE9alis\xE9e par des moyens fiables est consid\xE9r\xE9e comme un original.",
    content2: "Les dispositions de ce CLUF sont dissociables, de sorte que l'invalidit\xE9 de toute clause de ce CLUF d\xE9clar\xE9e par un tribunal comp\xE9tent n'affectera pas la validit\xE9 des autres clauses. Toute clause invalide sera soumise \xE0 une ex\xE9cution partielle conform\xE9ment \xE0 l'intention commune originale des parties dans la mesure maximale permise par la l\xE9gislation applicable.",
    content1: "Ce CLUF ou le DT associ\xE9 ne peuvent \xEAtre c\xE9d\xE9s par vous sans le consentement \xE9crit pr\xE9alable de QUANTHOME.",
    content5: "En cas de force majeure ou d'autres \xE9v\xE9nements exceptionnels (\xAB <strong>Force Majeure</strong> \xBB) pour lesquels QUANTHOME n'est pas responsable et qui rendent impossible ou consid\xE9rablement plus difficile le fonctionnement de l'APP, QUANTHOME peut restreindre ou suspendre l'APP pendant la dur\xE9e de cet obstacle ou r\xE9silier le contrat de licence d'utilisation (CLUF). La Force Majeure inclut, sans s'y limiter, la guerre, les troubles, la r\xE9bellion, les actes de sabotage et des \xE9v\xE9nements similaires, les gr\xE8ves ou autres conflits industriels, les lois et r\xE9glementations nouvellement adopt\xE9es, les retards caus\xE9s par des actions ou des omissions de la part d'un gouvernement/autorit\xE9s, les incendies, les explosions ou d'autres \xE9v\xE9nements in\xE9vitables, les \xE9pid\xE9mies, les pand\xE9mies, les inondations, les temp\xEAtes, les tremblements de terre ou d'autres \xE9v\xE9nements naturels exceptionnels. En aucun cas, QUANTHOME ne pourra \xEAtre tenu responsable des r\xE9clamations li\xE9es \xE0 la non-ex\xE9cution, \xE0 une ex\xE9cution incorrecte ou \xE0 une ex\xE9cution tardive des obligations contractuelles en raison de tels \xE9v\xE9nements de Force Majeure.",
    title: "12. Divers",
    content4: "Le fait qu'une partie ne demande pas l'ex\xE9cution stricte de toute disposition des pr\xE9sentes ne constituera pas une renonciation \xE0 cette disposition, ni une renonciation \xE0 toute violation ult\xE9rieure de ladite disposition. Toutes les renonciations doivent \xEAtre faites par \xE9crit pour \xEAtre applicables en vertu des pr\xE9sentes.",
    content3: "Ce pr\xE9sent CLUF constitue l'int\xE9gralit\xE9 de l'accord entre les parties concernant l'objet des pr\xE9sentes et remplace tous les accords et communications ant\xE9rieurs, qu'ils soient oraux ou \xE9crits, entre les parties relatifs \xE0 l'objet des pr\xE9sentes, ainsi que tous les pr\xE9c\xE9dents modes de traitement ou usages de l'industrie. Tel qu'utilis\xE9 dans les pr\xE9sentes, le terme \xAB y compris \xBB signifie \xAB y compris, mais sans s'y limiter \xBB."
  },
  part9: {
    content4: "LES LIMITATIONS DE RESPONSABILIT\xC9 CI-DESSUS SONT DESTIN\xC9ES \xC0 S'APPLIQUER \xC0 TOUTES LES DISPOSITIONS DE CE CONTRAT DE LICENCE UTILISATEUR FINAL.",
    title: "9. LIMITATION DE RESPONSABILIT\xC9",
    content3: "AUCUNE CIRCONSTANCE NE SAURAIT ENGAGER LA RESPONSABILIT\xC9 DE QUANTHOME OU DE SES PARTENAIRES POUR TOUTE UTILISATION NON AUTORIS\xC9E DE L'APPLICATION VISANT \xC0 D\xC9VELOPPER, DISTRIBUER OU UTILISER TOUT MAT\xC9RIEL QUI EST DIFFAMATOIRE, CALOMNIEUX, LIBELLEUX OU OBSC\xC8NE, QUI PR\xC9SENTE UNE PERSONNE SOUS UN FAUX JOUR OU CONSTITUE UNE ATTEINTE \xC0 TOUT DROIT \xC0 LA VIE PRIV\xC9E, QUI ENFREINT LES DROITS DE TOUT TIERS OU QUI EST CONTRAIRE \xC0 TOUTE LOI OU R\xC9GLEMENTATION \xC9TRANG\xC8RE, F\xC9D\xC9RALE OU LOCALE.",
    content1: "DANS LA MESURE PERMISE PAR LA LOI APPLICABLE, NI QUANTHOME NI SES FOURNISSEURS ET PARTENAIRES NE SERONT RESPONSABLES ENVERS VOUS OU TOUT TIERS POUR DES DOMMAGES INDIRECTS, SP\xC9CIAUX, ACCESSOIRES, PUNITIFS, DE COUVERTURE OU CONS\xC9CUTIFS (Y COMPRIS, MAIS SANS S'Y LIMITER, DES DOMMAGES POUR L'INCAPACIT\xC9 D'UTILISER DES \xC9QUIPEMENTS OU D'ACC\xC9DER \xC0 DES DONN\xC9ES, PERTE D'AFFAIRES, PERTE DE PROFITS, INTERRUPTION D'ACTIVIT\xC9 OU SIMILAIRES), R\xC9SULTANT DE L'UTILISATION DE, OU DE L'INCAPACIT\xC9 \xC0 UTILISER, L'APPLICATION ET BAS\xC9 SUR TOUTE TH\xC9ORIE DE RESPONSABILIT\xC9 Y COMPRIS VIOLATION DE CONTRAT, VIOLATION DE GARANTIE, D\xC9LIT (Y COMPRIS N\xC9GLIGENCE), RESPONSABILIT\xC9 DU FAIT DES PRODUITS OU AUTRE, M\xCAME SI QUANTHOME OU SES REPR\xC9SENTANTS ONT \xC9T\xC9 AVIS\xC9S DE LA POSSIBILIT\xC9 DE TELS DOMMAGES ET M\xCAME SI UN RECOURS \xC9NONC\xC9 CI-DESSUS S'AV\xC8RE AVOIR \xC9CHOU\xC9 DANS SON OBJECTIF ESSENTIEL.",
    content2: "QUANTHOME N'A AUCUNE RESPONSABILIT\xC9 FINANCI\xC8RE dans la plus grande mesure permise par la loi applicable."
  },
  part1: {
    title: "1. D\xE9finitions",
    content2: "<strong>CLUF</strong> d\xE9signe cet accord de licence utilisateur final ;",
    content1: "L'<strong>APP</strong> d\xE9signe l'application web fournie ici par QUANTHOME, ainsi que, le cas \xE9ch\xE9ant, la documentation correspondante, les supports associ\xE9s, les documents imprim\xE9s et la documentation en ligne ou \xE9lectronique, ainsi que toutes les mises \xE0 jour ou am\xE9liorations de ce qui pr\xE9c\xE8de qui vous sont fournies ;",
    content3: "<strong>QUANTHOME</strong> signifie Quanthome SA, IDE : CHE-321.617.538, ayant son si\xE8ge social \xE0 Lausanne, Suisse."
  },
  part2: {
    content: "QUANTHOME vous accorde par la pr\xE9sente un droit limit\xE9, non exclusif, non transf\xE9rable et non sous-licenciable d'utiliser l'APP pour une p\xE9riode unique de 365 jours suivant l'achat d'une licence annuelle conform\xE9ment au document de transaction en annexe (\xAB <strong>DT</strong> \xBB).",
    title: "2. Licence d'utilisation de l'APP"
  },
  part13: {
    title: "13. Droit applicable et juridiction",
    content1: "Ce CLUF sera r\xE9gi par le droit mat\xE9riel suisse, sans tenir compte des principes de conflit de lois, en particulier en excluant la Convention des Nations Unies sur les contrats de vente internationale de marchandises. Il en sera de m\xEAme pour tout TD conclu en vertu de ce CLUF.",
    content2: "Tout litige r\xE9sultant de ou li\xE9 \xE0 ce CLUF sera soumis \xE0 la juridiction exclusive des tribunaux ordinaires de Lausanne, Suisse, auxquels les parties conviennent irr\xE9vocablement d'\xEAtre soumises. Il en sera de m\xEAme pour tout DT conclu en vertu de ce CLUF."
  },
  part3: {
    content1: "Vous ne pouvez reproduire de quelque mani\xE8re que ce soit ou distribuer des copies de l'APP, mettre l'APP \xE0 la disposition de tiers de quelque mani\xE8re que ce soit, t\xE9l\xE9charger l'APP sur un site web ou transf\xE9rer \xE9lectroniquement l'APP d'un ordinateur \xE0 un autre ou sur un r\xE9seau, sauf si cela est express\xE9ment autoris\xE9 en vertu des termes de ce CLUF.",
    content5: "Vous ne pouvez pas partager votre compte avec une autre personne ou entit\xE9, d\xE9passant ainsi votre quota d'utilisateurs de compte.",
    content6: "Vous ne pouvez pas modifier l'APP ni cr\xE9er des \u0153uvres d\xE9riv\xE9es bas\xE9es sur l'APP.",
    content3: "Vous ne pouvez pas vendre, louer, louer \xE0 bail, pr\xEAter ou sous-licencier l'APP.",
    content2: "Vous ne pouvez pas alt\xE9rer, fusionner, modifier, adapter ou traduire l'APP, ni d\xE9compiler, d\xE9sassembler, proc\xE9der \xE0 de l\u2019ing\xE9nierie inverse ou r\xE9duire de toute autre mani\xE8re l'APP sous une forme perceptible par l\u2019homme, ni entreprendre toute activit\xE9 visant \xE0 contourner, neutraliser ou autrement enfreindre (ou ayant pour effet de faciliter, modifier ou aider le contournement, la neutralisation ou l\u2019infraction \xE0) le bon fonctionnement et/ou le fonctionnement s\xE9curis\xE9 de l'APP, ni porter atteinte de quelque mani\xE8re que ce soit \xE0 un brevet d\xE9tenu ou \xE0 une demande de brevet d\xE9pos\xE9e par QUANTHOME.",
    content4: "Vous ne pouvez pas distribuer, louer, louer \xE0 bail ou vendre les r\xE9sultats de l'utilisation de l'APP (en particulier les donn\xE9es).",
    title: "3. Restrictions de Licence"
  },
  part6: {
    content1: "Vous acceptez de payer tous les frais applicables sp\xE9cifi\xE9s dans un DT et les frais d'utilisation d\xE9passant ces autorisations. Les montants sont dus d\xE8s r\xE9ception de la facture et payables dans les 30 jours suivant la date de la facture sur un compte sp\xE9cifi\xE9 par QUANTHOME, et des frais de retard peuvent s'appliquer. QUANTHOME ne donne pas de cr\xE9dits ni de remboursements pour les frais pr\xE9pay\xE9s, les frais uniques ou d'autres frais d\xE9j\xE0 dus, pay\xE9s ou engag\xE9s. QUANTHOME peut modifier les frais lors du renouvellement d'un DT sous r\xE9serve d'un pr\xE9avis \xE9crit de quarante-cinq (45) jours \xE0 votre intention.",
    content2: "QUANTHOME facturera les charges dues sur une base annuelle au d\xE9but de chaque p\xE9riode de contrat, sauf en cas de d\xE9passement qui sera factur\xE9 en arri\xE9r\xE9s si n\xE9cessaire.",
    title: "6. Charges et paiement pour DT"
  },
  part4: {
    content1: "La licence ci-dessus vous accorde une licence limit\xE9e d'utilisation de l'APP et aucune autre licence ou droit n'est accord\xE9 par les pr\xE9sentes, que ce soit express\xE9ment ou par implication. QUANTHOME et ses fournisseurs et partenaires conservent tous les droits, titres et int\xE9r\xEAts, y compris tous les droits d'auteur et les droits de propri\xE9t\xE9 intellectuelle, sur l'APP et toutes ses copies.",
    title: "4. Propri\xE9t\xE9",
    content2: "Tous les droits non sp\xE9cifiquement accord\xE9s dans ce CLUF, y compris mais sans s'y limiter aux droits d'auteur nationaux et internationaux, sont r\xE9serv\xE9s par QUANTHOME, ses fournisseurs et ses partenaires."
  },
  update: {
    title: "Nous avons mis \xE0 jour notre contrat de licence."
  },
  input: {
    label: "J'accepte le contrat de licence.",
    title: "Veuillez confirmer que vous avez lu et accept\xE9 notre <span>contrat de licence</span>.",
    error: "Il est obligatoire d'accepter le contrat de licence pour acc\xE9der \xE0 l'application."
  },
  part5: {
    content1: "Conform\xE9ment aux termes du pr\xE9sent CLUF, vous acceptez de respecter les r\xE8gles et politiques \xE9tablies de temps \xE0 autre par QUANTHOME concernant les mises \xE0 jour et les composants de s\xE9curit\xE9 de l'APP. QUANTHOME s'engage \xE0 appliquer ces r\xE8gles et politiques de mani\xE8re non discriminatoire aux utilisateurs de l'APP, ces r\xE8gles comprenant, par exemple mais sans s'y limiter, les mises \xE0 jour, modifications et/ou installations requises ou automatis\xE9es de l'APP pour traiter les probl\xE8mes de s\xE9curit\xE9, d'interop\xE9rabilit\xE9 et/ou de performance.",
    content2: "Ces mises \xE0 jour, modifications et autres peuvent se produire de mani\xE8re p\xE9riodique ou selon les besoins, sans pr\xE9avis de votre part.",
    title: "5. Mises \xE0 jour, S\xE9curit\xE9 et R\xE9vocation"
  },
  part10: {
    content2: "Les limitations ou exclusions de garanties et de responsabilit\xE9 contenues dans ce CLIF n'affectent ni ne pr\xE9judicient les droits statutaires d'un consommateur.",
    title: "10. Utilisateurs Finaux Consommateurs Seulement",
    content1: "Les limitations ou exclusions de garanties et de responsabilit\xE9 contenues dans ce CLIF n'affectent ni ne pr\xE9judicient les droits statutaires d'un consommateur."
  },
  title: "Contrat de licence utilisateur final pour l'application web de Quanthome SA",
  intro: {
    first: "IMPORTANT : CE CONTRAT DE LICENCE UTILISATEUR FINAL (<strong>CLUF</strong>) EST UN ACCORD JURIDIQUE LIANT ENTRE VOUS (QU'IL S'AGISSE D'UN INDIVIDU OU D'UNE ENTIT\xC9) ET QUANTHOME. LISEZ-LE ATTENTIVEMENT AVANT D'UTILISER L'APPLICATION WEB (<strong>APP</strong>). IL FOURNIT UNE LICENCE POUR UTILISER L'APPLICATIONET CONTIENT DES INFORMATIONS SUR LA GARANTIE ET DES CLAUSES DE NON-RESPONSABILIT\xC9. EN S\xC9LECTIONNANT LE BOUTON \xAB J'ACCEPTE \xBB ET EN UTILISANT L'APP, VOUS CONFIRMEZ VOTRE ACCEPTATION DE L'APPLICATIONET ACCEPTEZ D'\xCATRE LI\xC9 PAR LES TERMES DE CE CLUF.",
    second: "SI VOUS N'ACCEPTEZ PAS D'\xCATRE LI\xC9 PAR CES CONDITIONS, ALORS N'UTILISEZ PAS L'APPLICATION."
  }
};
var funds = {
  environmental: {
    risks: {
      computed_climate_avg_rate: {
        key: "Dommages annuels totaux attendus par 1'000 CHF",
        description: "Dommages annuels moyens attendus aux b\xE2timents du fonds dus \xE0 la gr\xEAle , aux inondations et aux temp\xEAtes, par 1'000 CHF"
      },
      computed_climate_avg_value: {
        description: "Dommages annuels totaux attendus aux b\xE2timents du fonds dus \xE0 la gr\xEAle aux inondations et aux temp\xEAtes, en CHF ",
        key: "Dommages annuels totaux attendus en CHF"
      }
    },
    title: "Environnemental",
    hail_hazard_10_years: "Taille de la gr\xEAle",
    climate: {
      risk: {
        description: "L\u2019indice de risque climatique est bas\xE9 sur l\u2019exposition des b\xE2timents, au sein des v\xE9hicules d\u2019investissement, \xE0 diff\xE9rents risques environnementaux. Chaque risque a un poids \xE9gal dans le calcul de l\u2019indice."
      }
    },
    building_with_solar_existing: "B\xE2timents \xE9quip\xE9s de panneaux solaires",
    share: {
      fossil: "Part d'\xE9nergie fossile",
      r_coverage_share_fossil: "Couverture",
      coverage: "Taux de couverture",
      r_share_fossil: "Part d'\xE9nergies fossiles",
      non_fossil: "Part d'\xE9nergie non-fossile"
    },
    tile: {
      environmental_risks_details: "D\xE9tails",
      environmental_risks_total: "Total",
      energy_source: "Source d'\xE9nergie",
      environmental_risks: "Risques environnementaux",
      solar: "Solaire",
      climate_risk_index: "Indice de risque climatique",
      share: "Part \xE9nerg\xE9tique",
      idc_and_co2: "Intensit\xE9 \xE9nerg\xE9tique & CO\u2082"
    },
    solar_potential: "Potentiel solaire total",
    estimated_co2_emission_per_m2: "CO\u2082 par m\xB2",
    idc: {
      idc_per_m2: {
        description: "L'intensit\xE9 \xE9nerg\xE9tique mesure la consommation d'\xE9nergie estim\xE9e par m\xE8tre carr\xE9 de surface de chauffage sur une ann\xE9e pour chaque b\xE2timent dans le v\xE9hicule d'investissement. L'intensit\xE9 \xE9nerg\xE9tique globale du v\xE9hicule est ensuite calcul\xE9e avec une moyenne pond\xE9r\xE9e des b\xE2timents, dans laquelle chaque b\xE2timent est pond\xE9r\xE9 en fonction de sa surface de chauffage.",
        key: "Intensit\xE9 \xE9nerg\xE9tique"
      },
      r_idc: "\xC9nergie totale",
      r_coverage_idc: "Couverture",
      title: "Intensit\xE9 \xE9nerg\xE9tique",
      total_idc: "\xC9nergie totale",
      r_idc_per_m2: "Intensit\xE9 \xE9nerg\xE9tique"
    },
    avalanches: "Avalanches",
    estimated_idc_per_m2: "Intensit\xE9 \xE9nerg\xE9tique par m\xB2",
    computed_windstorm_avg_rate: "Temp\xEAte",
    total_estimated_idc: "Intensit\xE9 \xE9nerg\xE9tique totale",
    sia261: "SIA261",
    computed_hail_avg_rate: "Gr\xEAle",
    co2: {
      co2_scope_1_2_33_per_m2: "CO\u2082 (scope 1 + 2 + 3.3)",
      total_co2_scope_1_2_33: "Total CO\u2082 (scope 1 + 2 + 3.3)",
      title: "\xC9missions de CO\u2082",
      co2_scope_1_per_m2: "CO\u2082 (scope 1)",
      r_coverage_co2: "Couverture",
      co2_scope_2_per_m2: "CO\u2082 (scope 2)",
      co2_scope_1_2_per_m2: {
        key: "CO\u2082 (scope 1 + 2)",
        description: "Les \xE9missions de CO\u2082 sont calcul\xE9es en multipliant l\u2019intensit\xE9 \xE9nerg\xE9tique par le coefficient REIDA pour chaque b\xE2timent. Les \xE9missions totales de CO\u2082 du v\xE9hicule sont ensuite d\xE9termin\xE9es par une moyenne pond\xE9r\xE9e des b\xE2timents."
      },
      r_co2_per_m2: "\xC9missions de CO\u2082",
      co2_scope_33_per_m2: "CO\u2082 (scope 3.3)",
      r_co2: "\xC9missions totales de CO\u2082",
      total_co2_scope_1_2: "Total CO\u2082 (scope 1 + 2)"
    },
    risk: {
      title: "Risque"
    },
    total_estimated_co2_emission: "Total CO\u2082",
    overbank_sedimentation: "S\xE9dimentation en zone de d\xE9bordement",
    energy: {
      title: "\xC9nergie"
    },
    floods_50_years: "Inondations",
    landslides: "Glissements de terrain",
    debris_flow: "Flux de d\xE9bris",
    evolution: {
      chart: {
        title: "Graphique"
      },
      title: "\xC9volution"
    },
    press_score: "PRESS score environnement:",
    computed_flood_avg_rate: "Inondation",
    solar_existing: "Puissance solaire install\xE9e",
    rockfalls: "Chutes de pierres",
    solar_existing_per_m2: "Puissance solaire install\xE9e par m\xB2"
  },
  financials: {
    metrics: {
      c_revenue_per_share: "Revenu par action",
      title: "Indicateurs financiers",
      c_operating_profit: "B\xE9n\xE9fice d'exploitation",
      r_dividend_from_direct_rental_income: "Dividende provenant des revenus locatifs directs",
      five_years_avg_dividend_yield: "Rendement moyen de dividende sur 5 ans",
      c_earnings_per_share: "B\xE9n\xE9fice par action",
      r_total_dividend: "Dividende total",
      r_roi: "ROI (Retour sur Investissement)",
      r_dividend_yield: "Rendement de dividende",
      r_roic: "ROIC (Retour sur le Capital Investi)",
      r_debt_ratio: "Ratio d'endettement",
      c_net_initial_yield: "Rendement initial net",
      c_ebit_margin: "Marge op\xE9rationnelle (marge EBIT)",
      income_statement: {
        title: "Indicateurs du compte de r\xE9sultat",
        chart_title: "Visualisation du compte de r\xE9sultat"
      },
      quantitative_valuation_ratios: {
        title: "Ratios d'\xE9valuation quantitative"
      },
      r_wault: "WAULT (Dur\xE9e r\xE9siduelle moyenne pond\xE9r\xE9e des baux)",
      ratios: {
        title: "Ratios"
      },
      r_performance: "Performance",
      r_payout_ratio: "Taux de distribution",
      c_roa: "ROA (Rendement des actifs)",
      c_current_ratio: "Ratio de liquidit\xE9",
      c_agio_at_year_end: "Agio \xE0 la fin de l'ann\xE9e",
      m_dividend_yield: "Rendement de dividende",
      c_pe_ratio: "Ratio C/B (P/E ratio)",
      r_rental_losses: "Pertes sur loyer",
      r_dividend_from_capital_gains: "Dividende provenant des plus-values",
      c_total_cash_per_share: "Tr\xE9sorerie totale par action",
      c_debt_ratio: "Ratio d'endettement",
      r_dividend_from_indirect_rental_income: "Dividende provenant des revenus locatifs indirects",
      c_price_to_book_value: "Ratio cours/valeur comptable (price to book ratio)",
      liquidity: {
        title: "Indicateurs de liquidit\xE9"
      },
      c_roe: "ROE (Rentabilit\xE9 des Capitaux Propres)",
      balance_sheet: {
        chart_title: "Visualisation du bilan"
      },
      c_roce: "ROCE (Rentabilit\xE9 des capitaux investis)",
      c_loan_to_value: "Ratio pr\xEAt-valeur",
      c_payout_ratio: "Taux de distribution",
      r_estimated_liquidation_taxes: "Taxes de liquidation estim\xE9es",
      r_roe: "ROE (Rentabilit\xE9 des Capitaux Propres)",
      c_current_liabilities: "Passifs courants",
      c_weighted_average_cost_of_debt: "Taux d'int\xE9r\xEAt moyen pond\xE9r\xE9",
      r_ebit_margin: "Marge op\xE9rationnelle (marge EBIT)",
      dividends: {
        title: "Dividendes"
      },
      c_weighted_average_maturity: "Maturit\xE9 moyenne pond\xE9r\xE9e"
    },
    portfolio: {
      r_total_market_value: "Total",
      r_commercial_cost_price: "Commercial",
      c_market_value_median: "M\xE9diane",
      c_commercial_market_value: "Commercial",
      r_cost_price_q1: "T1",
      r_residential_market_value: "R\xE9sidentiel",
      r_residential_cost_price: "R\xE9sidentiel",
      r_commercial_market_value: "Commercial",
      r_market_value_median: "M\xE9diane",
      r_others_cost_price: "Autres",
      c_others_market_value: "Autres",
      c_total_market_value: "Total",
      r_cost_price: {
        title: "Prix de revient rapport\xE9 des b\xE2timents"
      },
      r_market_value_q3: "T3",
      c_mixed_market_value: "Mixte",
      title: "Valeur du portefeuille",
      computed_market_value: {
        title: "Valeur de march\xE9 des b\xE2timents"
      },
      r_cost_price_by_m2: {
        title: "Prix de revient rapport\xE9 par m\xB2"
      },
      c_cost_price_by_m2: {
        title: "Prix de revient par m\xB2"
      },
      r_plots_cost_price: "Parcelles",
      r_mixed_market_value: "Mixte",
      c_residential_market_value: "R\xE9sidentiel",
      r_cost_price_q3: "T3",
      r_plots_market_value: "Parcelles",
      computed_market_value_by_m2: {
        title: "Valeur de march\xE9 par m\xB2"
      },
      c_market_value: {
        title: "Valeur de march\xE9 des b\xE2timents estim\xE9e"
      },
      r_other_market_value: "Autres",
      r_total_cost_price: "Total",
      c_market_value_by_m2: {
        title: "Valeur de march\xE9 par m\xB2"
      },
      c_cost_price: {
        title: "Prix de revient des b\xE2timents"
      },
      c_market_value_q3: "T3",
      r_market_value_by_m2: {
        title: "Valeur de march\xE9 rapport\xE9e par m\xB2"
      },
      c_market_value_q1: "T1",
      r_market_value_q1: "T1",
      r_cost_price_median: "M\xE9diane",
      r_market_value: {
        title: "Valeur de march\xE9 rapport\xE9e des b\xE2timents"
      },
      r_mixed_cost_price: "Mixte",
      r_other_cost_price: "Autres"
    },
    accounting: {
      balance_sheet: {
        table_title: "Tableau de bilan"
      },
      income_statement: {
        table_title: "Tableau du compte de r\xE9sultat"
      }
    },
    tile: {
      trade: "Statistiques de Commerce",
      return: "Rendement",
      stock_history: "Historique des prix des actions",
      charges: "Charges locatives",
      evolution: "\xC9volution",
      risk_statistics: "Statistiques de Risque",
      key_performance: "Principaux indicateurs de performance",
      dividends: "Dividendes",
      rental_income: "Revenu locatif",
      key_financials_per_share: "Performance financi\xE8re (par action)",
      losses: "Pertes",
      key_financials: "Performance financi\xE8re (totale)",
      fees: "Frais",
      measures: "M\xE9triques d'\xE9valuation"
    },
    performance: {
      year_end_total_value: {
        title: "Valeur totale \xE0 la fin de l'ann\xE9e"
      },
      c_current_agio_before_distribution: "Agio avant distribution",
      r_tna_after_distribution: "TNA apr\xE8s distribution",
      c_current_agio_after_distribution: "Agio apr\xE8s distribution",
      c_tna_compounded: "TNA capitalis\xE9",
      r_tga_after_distribution: "TGA apr\xE8s distribution",
      r_gav_before_distribution: "GAV avant distribution",
      r_market_cap: "Capitalisation",
      current_total_value: {
        title: "Valeur totale actuelle"
      },
      m_share_price: "Prix de l'action",
      c_gav_compounded: "GAV capitalis\xE9",
      r_share_price: "Prix de l'action",
      r_tna_before_distribution: "TNA avant distribution",
      m_market_cap: "Capitalisation",
      m_dividend_yield: "Rendement de dividende",
      r_nav_before_distribution: "VNI avant distribution",
      c_total_current_agio_compounded: "Agio total capitalis\xE9",
      c_total_current_agio_after_distribution: "Agio total apr\xE8s distribution",
      r_tga_before_distribution: "TGA avant distribution",
      r_agio_at_year_end: "Agio",
      c_gav_after_distribution: "GAV apr\xE8s distribution",
      c_current_agio_compounded: "Agio capitalis\xE9",
      c_total_agio_at_year_end: "Agio",
      c_nav_after_distribution: "VNI apr\xE8s distribution",
      title: "Performance",
      c_nav_compounded: "VNI capitalis\xE9e",
      current_value_per_share: {
        title: "Valeur actuelle par action"
      },
      c_tga_compounded: "TGA capitalis\xE9",
      year_end_value_per_share: {
        title: "Valeur par action \xE0 la fin de l'ann\xE9e"
      }
    },
    rental_income: {
      c_total_net_rent: "Total",
      c_commercial_net_rent: "Commercial",
      computed_by_m2: {
        title: "Revenu locatif par m\xB2"
      },
      estimated_by_m2: {
        title: "Revenu locatif par m\xB2"
      },
      title: "Revenu locatif",
      reported_by_m2: {
        title: "Revenu locatif par m\xB2 rapport\xE9"
      },
      c_net_rent_q1: "T1",
      r_others_net_rent: "Autres",
      computed: {
        title: "Revenu locatif"
      },
      r_other_net_rent: "Autres",
      r_net_rent_q3: "T3",
      r_plots_net_rent: "Parcelles",
      r_commercial_net_rent: "Commercial",
      r_net_rent_median: "M\xE9diane",
      r_total_net_rent: "Total",
      r_resiential_net_rent: "R\xE9sidentiel",
      reported: {
        title: "Revenu locatif rapport\xE9"
      },
      r_net_rent_q1: "T1",
      c_net_rent_median: "M\xE9diane",
      r_mixed_net_rent: "Mixte",
      c_mixed_net_rent: "Mixte",
      c_resiential_net_rent: "R\xE9sidentiel",
      c_net_rent_q3: "T3",
      estimated: {
        title: "Revenu locatif"
      }
    },
    stock: {
      three_months_avg_volume: "Volume moyen sur 3 mois",
      alpha: "Alpha (5 ans Mensuel)",
      one_year_avg_volume: "Volume moyen sur 1 an",
      evolution: {
        title: "\xC9volution"
      },
      hist_volatility_250_days: "Volatilit\xE9 historique sur 1 An",
      volume: "Dernier volume",
      six_months_avg_volume: "Volume moyen sur 6 mois",
      five_years_return: "5 ans",
      fifty_two_weeks_low: "Plus bas sur 52 semaines",
      qtd_net_return: "Cumul trimestriel \xE0 ce jour (TCD)",
      trade: {
        title: "Statistiques de Commerce"
      },
      hist_volatility_180_days: "Volatilit\xE9 historique sur 6 Mois",
      five_days_avg_volume: "Volume moyen sur 5 jours",
      unit_outstanding: "Actions en circulation",
      title: "Performance des actions",
      six_months_return: "6 Mois",
      hist_volatility_30_days: "Volatilit\xE9 historique sur 1 Mois",
      one_year_return: "1 an",
      three_months_return: "3 mois",
      fifty_two_weeks_high: "Plus haut sur 52 semaines",
      three_years_return: "3 ans",
      ytd_net_return: "Cumul annuel \xE0 ce jour (AAJ)",
      mtd_net_return: "Cumul mensuel \xE0 ce jour (MTD)",
      one_month_return: "1 Mois",
      history: {
        title: "Historique des prix des actions"
      },
      sharpe_ratio: "Ratio de Sharpe",
      hist_volatility_90_days: "Volatilit\xE9 historique sur 3 Mois",
      one_month_avg_volume: "Volume moyen sur 1 mois",
      beta: "B\xEAta (5 ans Mensuel)",
      risk: {
        title: "Statistiques de Risque"
      },
      turnover: "Chiffre d'affaires",
      r2: "R\xB2"
    },
    fees: {
      r_ter_nav: "TERrefVNI",
      r_property_management_fees: "Frais de gestion immobili\xE8re",
      r_ter_mv: "TERrefMV",
      r_ter_gav: "TERrefGAV",
      maximum: {
        title: "Frais Maximum"
      },
      r_max_share_buyback_commissions: "Commission de rachat d'actions",
      r_max_management_fees: "Frais de gestion",
      r_max_construction_and_works_fees: "Construction et travaux",
      r_max_purchase_and_sale_fees: "Achat et vente de biens immobiliers",
      r_custodian_bank_fees: "Frais de banque d\xE9positaire",
      r_construction_and_works_fees: "Construction et travaux",
      effective: {
        title: "Frais Effectifs"
      },
      r_max_property_management_fees: "Frais de gestion immobili\xE8re",
      title: "Frais",
      r_purchase_and_sale_fees: "Achat et vente de biens immobiliers",
      r_max_share_issue_commissions: "Commission d'\xE9mission d'actions",
      r_share_issue_commissions: "Commission d'\xE9mission d'actions",
      r_share_buyback_commissions: "Commission de rachat d'actions",
      r_management_fees: "Frais de gestion",
      r_max_custodian_bank_fees: "Frais de banque d\xE9positaire"
    },
    cost_price: {
      title: "Prix de revient"
    },
    charges: {
      title: "Charges locatives"
    },
    title: "Finances",
    side_menu: {
      hover_label: "Variation"
    },
    trading: {
      title: "Informations de n\xE9gociation"
    },
    market_value: {
      title: "Valeur de march\xE9"
    },
    income_statement: {
      title: "Compte de r\xE9sultats"
    },
    highlights: {
      title: "Informations financi\xE8res"
    },
    stock_performance: {
      title: "Performance des actions"
    },
    evolution: {
      chart: {
        title: "Graphique"
      },
      title: "\xC9volution"
    },
    debts: {
      title: "Structure de la dette"
    },
    report: {
      annual: "annuel",
      semi_annual: "semi-annuel"
    },
    balance_sheet: {
      title: "Bilan"
    },
    revenue: {
      title: "Revenu"
    },
    benchmark: "S\xE9lectionnez un indice de r\xE9f\xE9rence"
  },
  performance: {
    total_expense_ratio_ref_mv: "Ratio total des d\xE9penses (TER_MV)",
    payout_ratio: "Taux de distribution",
    wault_suffix: "ann\xE9es",
    hist_volatility_250_days: "Volatilit\xE9 historique sur 1 An",
    rent_default_rate: "Pertes sur loyer",
    hist_volatility_90_days: "Volatilit\xE9 historique sur 3 Mois",
    fifty_two_w_high: "Plus haut sur 52 semaines",
    total_net_assets: "Actifs nets totaux",
    return_on_asset: "ROA (Rendement des actifs)",
    market_capitalization: "Capitalisation",
    yearly_management_fee: "Frais de gestion",
    dividend: "Dernier dividende",
    three_m_return: "3 mois",
    five_y_avg_dividend_yield: "Rendement moyen de dividende  sur 5 ans",
    dividend_yield: "Rendement de dividende",
    volume: "Volume moyen",
    fifty_two_w_low: "Plus bas sur 52 semaines",
    alpha: "Alpha (5 ans Mensuel)",
    one_m_return: "1 Mois",
    return_on_equity: "Rentabilit\xE9 des capitaux propres (RCP)",
    turnover: "Chiffre d'affaires",
    volume_suffix: "Unit\xE9s",
    return_on_capital_employed: "ROCE (Rentabilit\xE9 des capitaux investis)",
    relative_agio: "Agio",
    three_y_return: "3 ans",
    debt_financing_ratio: "Ratio d'endettement",
    distribution_yield: "Rendement de distribution",
    return_on_investment: "Retour sur investissement (ROI)",
    return_on_invested_capital: "Retour sur capitaux investis (ROIC)",
    beta: "B\xEAta (5 ans Mensuel)",
    mtd_net_return: "Cumul mensuel \xE0 ce jour (MTD)",
    one_y_return: "1 an",
    total_expense_ratio_ref_nav: "Ratio total des d\xE9penses (TER_VNI)",
    total_gross_assets: "Total des actifs bruts",
    ebit_margin: "Marge op\xE9rationnelle (marge EBIT)",
    ytd_net_return: "Cumul annuel \xE0 ce jour (AAJ)",
    hist_volatility_30_days: "Volatilit\xE9 historique sur 1 Mois",
    hist_volatility_180_days: "Volatilit\xE9 historique sur 6 Mois",
    r2: "R\xB2",
    total_expense_ratio_ref_gav: "Ratio total des d\xE9penses (TER_GAV)",
    qtd_net_return: "Cumul trimestriel \xE0 ce jour (TCD)",
    wault_label: "Dur\xE9e r\xE9siduelle moyenne pond\xE9r\xE9e des baux (WAULT)"
  },
  noright: {
    title: "REIVs",
    subtitle: "Cette fonctionnalit\xE9 n\xE9cessite un plan plus complet.",
    button: "Contactez le responsable de compte",
    details: "Le module des V\xE9hicules d'Investissement Immobilier (REIVs) pr\xE9sente des informations compl\xE8tes sur une large gamme d'entit\xE9s immobili\xE8res suisses."
  },
  governance: {
    tile: {
      certification: "Certification",
      press_score: "PRESS \u2013 Scores de durabilit\xE9 immobili\xE8re publics",
      valuation_expert: "Experts en \xE9valuation",
      property_management: "Gestion immobili\xE8re",
      ownership: "Propri\xE9t\xE9",
      auditors: "Auditeurs",
      minergie: "Minergie"
    },
    manager: "Gestionnaire du fonds",
    certificates_rating: {
      title: "Certificats et notation"
    },
    social: "Social",
    governance: "Gouvernance",
    custodian_bank: "Banque d\xE9positaire",
    esg: "ESG (Environnement, Social et Gouvernance)",
    press_score: "PRESS score gouvernance:",
    director: "Directeur du fonds",
    ranking: "Classement",
    title: "Gouvernance",
    minergie_buildings: "Proportion des b\xE2timents Minergie",
    organisation: {
      title: "Organisation"
    },
    environmental: "Environnemental"
  },
  administrative: {
    custodian_bank: "Banque d\xE9positaire",
    benchmark_bloomberg_ticker: "Ticker du benchmark",
    benchmark: "Indice de r\xE9f\xE9rence",
    manager: "Gestionnaire du fonds",
    name: "Registre des actions",
    director: "Directeur du fonds",
    domicile: "Domicile du fonds"
  },
  social: {
    transport_accessibility: {
      road_accessibility: {
        title: "Par la route",
        description: "Moyenne des scores d'accessibilit\xE9s par route selon l'ARE, pour chaque b\xE2timent",
        key: "Accessibilit\xE9 par la route"
      },
      transport_accessibility: {
        key: "Accessibilit\xE9 en transports publics",
        description: "Moyenne des scores d'accessibilit\xE9s par les transports publics selon l'ARE, pour chaque b\xE2timent",
        title: "En train"
      },
      title: "Accessibilit\xE9"
    },
    accessibility: {
      aged_care: "Soins aux personnes \xE2g\xE9es",
      computed_public_transport_minute_mean: "Transports publics",
      computed_restaurants_meter_mean: "Restaurants",
      computed_pt_accessibility_mean: {
        title: "Score d'accessibilit\xE9 moyen"
      },
      computed_early_years_meter_mean: "Premi\xE8res ann\xE9es",
      mean_shops: "Boutiques",
      transport_train: "Train",
      computed_healthcare_minute_mean: "Services de sant\xE9",
      mean_primary_education: "Enseignement primaire",
      tree: {
        title: "Accessibilit\xE9 par mode de transport"
      },
      mean_restaurants: "Restaurants",
      computed_public_open_space_meter_mean: "Espace public ouvert",
      computed_healthcare_meter_mean: "Services de sant\xE9",
      computed_cultural_venues_meter_mean: "\xC9tablissements culturels",
      computed_aged_care_minute_mean: "Soins aux personnes \xE2g\xE9es",
      early_years: "Premi\xE8res ann\xE9es",
      computed_transport_bus_minute_mean: "Bus",
      computed_secondary_education_meter_mean: "Enseignement secondaire",
      computed_aged_care_meter_mean: "Soins aux personnes \xE2g\xE9es",
      computed_restaurants_minute_mean: "Restaurants",
      mean_score: "Score",
      cultural_venues: "\xC9tablissements culturels",
      mean_transport_train: "Train",
      computed_transport_train_meter_mean: "Train",
      computed_social_and_cultural_activities_minute_mean: "Activit\xE9s sociales et culturelles",
      computed_cultural_venues_minute_mean: "\xC9tablissements culturels",
      mean_cultural_venues: "\xC9tablissements culturels",
      computed_transport_bus_meter_mean: "Bus",
      computed_sports_recreation_meter_mean: "Sport et loisirs",
      computed_transport_train_minute_mean: "Train",
      title: "Accessibilit\xE9",
      computed_public_open_space_minute_mean: "Espace public ouvert",
      computed_secondary_education_minute_mean: "Enseignement secondaire",
      healthcare: "Services de sant\xE9",
      mean_secondary_education: "Enseignement secondaire",
      computed_primary_education_meter_mean: "Enseignement primaire",
      computed_sports_recreation_minute_mean: "Sport et loisirs",
      shops: "Boutiques",
      computed_transport_bike_meter_mean: "Stationnement pour v\xE9los",
      computed_primary_education_minute_mean: "Enseignement primaire",
      transport_bus: "Bus",
      computed_transport_bike_minute_mean: "Stationnement pour v\xE9los",
      mean_aged_care: "Soins aux personnes \xE2g\xE9es",
      computed_shops_meter_mean: "Boutiques",
      computed_road_accessibility_mean: {
        title: "Score d'accessibilit\xE9 moyen"
      },
      table: {
        title: "Temps de marche moyen jusqu'aux commodit\xE9s"
      },
      primary_education: "Enseignement primaire",
      secondary_education: "Enseignement secondaire",
      computed_shops_minute_mean: "Boutiques",
      mean_early_years: "Premi\xE8res ann\xE9es",
      restaurants: "Restaurants",
      computed_early_years_minute_mean: "Premi\xE8res ann\xE9es",
      computed_aged_and_early_years_care_minute_mean: "Soins aux personnes \xE2g\xE9es et \xE0 la petite enfance",
      score: "Score",
      radar: {
        title: "Accessibilit\xE9 des services \xE0 proximit\xE9"
      },
      mean_healthcare: "Services de sant\xE9",
      mean_transport_bus: "Bus"
    },
    well_being: {
      public_utility_density: {
        key: "Part des b\xE2timents publics",
        description: "Cet indicateur mesure la part des b\xE2timents publics (h\xF4pitaux, \xE9tablissements de soins pour personnes \xE2g\xE9es, \xE9coles, etc.) dans le portefeuille du v\xE9hicule.",
        title: "B\xE2timents publics"
      },
      green_density: {
        title: "V\xE9g\xE9tation",
        key: "Densit\xE9 d'espaces verts",
        description: "La densit\xE9 d'espaces verts repr\xE9sente la moyenne du nombre d'hectares environnants contenant une majorit\xE9 de zones vertes pour chaque b\xE2timent, selon l'utilisation du sol (NOAS04)"
      },
      computed_public_utility_density: {
        title: "Densit\xE9 de b\xE2timents publics"
      },
      title: "Bien-\xEAtre",
      computed_green_density: {
        title: "Densit\xE9 d'espaces verts"
      }
    },
    density: {
      title: "Densit\xE9",
      computed_job_density: {
        title: "Densit\xE9 d'emploi"
      },
      computed_population_density: {
        title: "Densit\xE9 de population"
      },
      population_density: {
        title: "Densit\xE9 de population",
        key: "Densit\xE9 de population",
        description: "La densit\xE9 de population mesure la densit\xE9 de population moyenne dans les hectares environnants par b\xE2timent, selon STATPOP."
      },
      job_density: {
        description: "La densit\xE9 d'emplois mesure la densit\xE9 d'emplois moyenne en hectares environnants par b\xE2timent, selon STATENT.",
        title: "Densit\xE9 d'emplois",
        key: "Densit\xE9 d'emplois"
      }
    },
    promiscuity: {
      tile: {
        occupancy: "Taux d'occupation",
        migration: "Migration"
      },
      arrival_per_inhabitant: "Arriv\xE9e par habitant",
      title: "Densit\xE9 de population",
      departure_per_inhabitant: "D\xE9part par habitant",
      per_bedroom: "Par chambre \xE0 coucher",
      per_100_m2: "Par 100 m\xB2"
    },
    demographic: {
      tile: {
        ages: "\xC2ges",
        gender: "Genre",
        foreigners: "\xC9trangers"
      },
      title: "D\xE9mographique"
    },
    tile: {
      accessibility_to_services: "Accessibilit\xE9 aux services",
      accessibility_others: "Autre (distance moyenne)",
      accessibility_transportation: "Transports publics (distance moyenne)",
      accessibility_education: "Sant\xE9 et \xE9ducation (distance moyenne)",
      accessibility_score: "Accessibilit\xE9"
    },
    press_score: "PRESS score social:",
    title: "Social"
  },
  designation: {
    instrument_name: "Nom de l'instrument",
    currency: "Monnaie",
    ticker: "Nom commun",
    isin: "ISIN",
    bloomberg_ticker: "Ticker Bloomberg",
    valor_no: "Code Valor"
  },
  financials_per_share: {
    last_distribution: "Derni\xE8re date de distribution",
    share_class_nb: "Actions en circulation",
    share_class_gav: "Valeur totale d'inventaire (GAV)",
    share_market_price: "Prix de l'action",
    share_class_nav: "Valeur nette d'inventaire (VNI)",
    distribution_value: "Valeur de distribution"
  },
  composition: {
    lot_area: "Surface du terrain",
    lots_nb: "Nombre de parcelles",
    fund_age: "\xC2ge du portefeuille immobilier",
    other_area: "Surface totale autre",
    report_date: "Dernier rapport",
    buildings_nb: "Nombre de b\xE2timents",
    office_area: "Surface totale de bureau",
    semi_annual_report_date: "Dernier rapport (semi-annuel)",
    mixed_area: "Surface mixte totale",
    building_groups_nb: "Nombre de groupes de b\xE2timents",
    residential_area: "Surface r\xE9sidentielle totale",
    plot_area: "Surface totale du terrain",
    commercial_area: "Surface commerciale totale",
    dwellings_nb: "Nombre de logements",
    report_age: "\xC2ge du rapport immobilier actuel",
    industrial_area: "Surface industrielle totale",
    total_area: "Surface totale",
    annual_report_date: "Dernier rapport (annuel)"
  },
  trading: {
    title: "Trading"
  },
  overview: {
    agio: "Agio",
    total_co2: "CO\u2082",
    total_net_assets: "TNA",
    debt_ratio: "Ratio d'endettement",
    esg_rating: "\xC9valuation PRESS",
    net_initial_yield: "Rendement initial net",
    roa: "ROA (Rendement des actifs)",
    market_cap: "Capitalisation",
    net_rent: "Revenu locatif",
    ter_gav: "TERrefGAV"
  },
  description: {
    ranking: "Classement des fonds :",
    tile: {
      buildings: "B\xE2timents",
      allocation_treemap: "Treemap des cat\xE9gories de b\xE2timent",
      geo_treemap: "Treemap g\xE9ographique",
      stock: "Action",
      composition: "Composition",
      administrative: "Administratif",
      designation: "D\xE9signation",
      distribution: "Distribution",
      areas: "Zones"
    },
    distribution: {
      value_string: "Surface",
      label: {
        reported_type: "Type",
        typology: "Typologie",
        region: "Canton",
        type: "Cat\xE9gorie",
        class: "Classe"
      },
      label_string: "Canton"
    },
    allocation: {
      title: "Allocation"
    },
    identification: {
      title: "Identification"
    },
    overview: {
      title: "Aper\xE7u",
      map: "Carte"
    },
    title: "Description",
    composition: {
      title: "Composition"
    }
  },
  stock: {
    distribution_frequency: "Fr\xE9quence de distribution",
    launch_date: "Date de lancement",
    units_nb: "Actions en circulation",
    last_distribution: "Derni\xE8re date de distribution",
    year_end: "Date de fin d'ann\xE9e",
    units_class: "Classe d'unit\xE9s",
    distribution_date: "Date de distribution"
  },
  accounting: {
    title: "Comptabilit\xE9"
  },
  environment: {
    energy_distribution: {
      value_string: "Surface chauff\xE9e",
      label_string: "Chauffage"
    }
  },
  transactions: {
    value: {
      sale: "vendu",
      purchase: "achet\xE9"
    },
    title: "Transactions"
  },
  debt: {
    title: "Dette"
  },
  report: {
    semi_annual: "Rapport semi-annuel",
    annual: "Rapport annuel"
  },
  page: {
    title: "Tous les fonds suisses"
  },
  assets: {
    title: "Inventaire"
  }
};
var screener = {
  tabs: {
    esg: "ESG (Environnement, Social et Gouvernance)",
    accounting: "Comptabilit\xE9",
    information: "Informations",
    governance: "Gouvernance",
    trading: "Trading",
    structure: "Structure",
    fees: "Frais",
    financial: "Financier",
    stock: "Performance des actions",
    type: "Type",
    saved_screens: "Vues sauvegard\xE9es",
    energy: "\xC9nergie",
    performance: "Performance",
    social: "Social",
    dimension: "Dimension",
    legal_forms: "Formes juridiques",
    transaction: "Transaction",
    location: "Emplacement"
  },
  filters: {
    multi_select: {
      options: {
        unlisted_fund: "Fonds non cot\xE9",
        mixed: "Mixte",
        commercial: "Commercial",
        foundation: "Fondation",
        real_estate_firm: "Soci\xE9t\xE9 immobili\xE8re",
        listed_fund: "Fonds cot\xE9",
        residential: "R\xE9sidentiel"
      }
    },
    labels: {
      floors_nb: "Nombre d'\xE9tages",
      idc: "Intensit\xE9 \xE9nerg\xE9tique",
      rooms_nb: "Nombre de chambres",
      street: "Rue",
      roa: "ROA (Rendement des actifs)",
      price: "Prix",
      columns_to_ignore: "Colonnes",
      region: "R\xE9gion",
      canton: "Canton",
      potential_net_rent_per_m2: "Loyer net potentiel par m\xB2",
      net_rent: "Revenu locatif",
      dwellings_nb: "Nombre de logements",
      plot_surface: "Surface de parcelle",
      floor: "\xC9tage",
      rent: "Revenu locatif",
      construction_year: "Ann\xE9e de construction",
      potential_net_rent: "Loyer net potentiel",
      ground_area: "Surface de terrain",
      undefined: "-",
      sort: "Trier",
      buildings_nb: "Nombre de b\xE2timents",
      potential_charges: "Frais potentiels",
      label: "\xC9tiquette",
      municipality: "Municipalit\xE9",
      co2: "CO\u2082",
      potential_market_value: "Valeur de march\xE9 potentielle",
      potential_market_value_per_m2: "Valeur de march\xE9 potentielle par m\xB2",
      locality: "Localit\xE9",
      area: "Surface de parcelle",
      potential_roa: "ROA (Rendement des actifs)",
      charges: "Charges locatives",
      elevator: "Ascenseur",
      potential_charges_per_m2: "Charges potentielles par m\xB2",
      energy_source_heating: "Chauffage"
    },
    panel: {
      show: "Afficher"
    },
    groups: {
      information: "Informations"
    },
    single_select: {
      options: {
        radar: "Diagramme en radar",
        area: "Graphique en aires",
        scatter: "Nuage de points",
        boxplot: "Bo\xEEte \xE0 moustache",
        heatmap: "Carte thermique",
        bar: "Diagramme \xE0 barres",
        line: "Graphique \xE0 courbes",
        histogram: "Histogramme",
        "1m": "1M",
        "5y": "5A",
        ytd: "AAJ (YTD)",
        "7d": "7J",
        "2y": "2A",
        "3m": "3M",
        "6m": "6M",
        "1y": "1A",
        "3y": "3A",
        "4y": "4A",
        false: "Wahr",
        max: "Max",
        true: "Vrai"
      }
    }
  }
};
var actions = {
  request_download: {
    message: "Demande cr\xE9\xE9e",
    csv: "T\xE9l\xE9charger CSV"
  },
  screener: {
    filter: {
      remove: "Supprimer les filtres",
      edit: "Modifier le filtre",
      save: "Enregistrer le filtre",
      search: "Filtres"
    },
    filter_header: {
      header: "Colonnes",
      label: "D\xE9finir la visibilit\xE9 des colonnes"
    },
    preset: {
      save: "Enregistrer l'\xE9cran",
      delete: "Supprimer la vue",
      copy: "Copier la vue",
      reset: "R\xE9initialiser l'\xE9cran"
    },
    per_page: {
      header: "Nombre de lignes",
      label: "Lignes par page"
    }
  },
  add_to_portfolios: {
    modal: {
      portfolio_name: "Nom du portefeuille",
      new: "Nouvelle",
      name: "Nom",
      add_to_existing: "Ajouter \xE0 un portefeuille existant",
      create_button: "Cr\xE9er"
    },
    confrm_modal: {
      title: "Logements d\xE9j\xE0 inclus",
      buttons: {
        confirm: "Proc\xE9der",
        cancel: "Retour"
      }
    },
    confirm_modal: {
      text_2: "Voulez-vous les remplacer par le b\xE2timent \xE0 la place ?",
      text_1: "Le portefeuille contient d\xE9j\xE0 des logements de {{building_label}}."
    },
    success_add_portfolio: {
      message: "Ajout de {{asset}} \xE0 votre portefeuille {{portfolio_state}}",
      title: "R\xE9ussi"
    },
    adding_portfolio: {
      title: "Ajout",
      message: "Ajouter des {{asset}}(s) \xE0 votre portefeuille"
    },
    success_create_portfolio: {
      message: "Un nouveau portefeuille a \xE9t\xE9 cr\xE9\xE9",
      title: "R\xE9ussi"
    },
    title: "Ajouter au portefeuille"
  },
  portfolios: {
    remove: {
      success: {
        message: "{{ asset }}(s) retir\xE9(e)(s) de votre portefeuille"
      }
    }
  },
  update: {
    processing: {
      done: "L'op\xE9ration a \xE9t\xE9 effectu\xE9e avec succ\xE8s. La page sera mise \xE0 jour bient\xF4t.",
      message: "L'op\xE9ration sera bient\xF4t effectu\xE9e.",
      title: "Mise \xE0 jour"
    }
  },
  watchlist: {
    remove: {
      button: {
        label: "Ne plus suivre"
      },
      success: {
        message: "Actif retir\xE9 de votre liste de suivi"
      }
    },
    add: {
      button: {
        label: "Suivre"
      },
      success: {
        message: "Actif ajout\xE9 \xE0 votre liste de suivi"
      }
    }
  },
  companies: {
    delete: "Supprimer",
    create: "Cr\xE9er une entreprise"
  },
  add_to_watchlist: {
    title: "Ajouter \xE0 la liste de suivi"
  }
};
var table_header = {
  r_total_cash: "Tr\xE9sorerie totale",
  total_net_assets: "Actifs nets totaux",
  reported_total_area: "Surface locative",
  r_ebit_margin: "Marge op\xE9rationnelle (marge EBIT)",
  area: "Surface",
  c_total_current_agio_compounded: "Agio total actuel capitalis\xE9",
  m_dividend_yield: "Rendement actuel des dividendes",
  buyer_name: "Acheteur",
  email: "Email",
  energy_source_heating: "Chauffage",
  r_gav_before_distribution: "GAV avant distribution",
  cost_price: "Prix de revient",
  r_nav_before_distribution: "VNI avant distribution",
  id: "ID",
  total_consumer_seat: "Nombre total de licences utilisateur-consommateur",
  three_years_return: "Rendement net sur 3 ans",
  r_net_income_available_for_distribution: "Revenu net disponible pour distribution",
  r_tna_before_distribution: "TNA avant distribution",
  r_capital_distribution: "Distribution de capital",
  r_total_provisions: "Provisions totales",
  m_share_price: "Prix de l'action",
  potential_market_value_per_m2: "Valeur de march\xE9 par m\xB2",
  municipality_nb: "Num\xE9ro de municipalit\xE9",
  floor: "\xC9tage",
  consumer_users: "Utilisateurs-consommateurs",
  r_absolute_custodian_bank_fees: "Frais de banque d\xE9positaire",
  r_long_term_liabilities: "Passifs \xE0 long terme",
  c_pe_ratio: "Ratio C/B (P/E ratio)",
  r_taxes: "Imp\xF4ts",
  commercial_area: "Surface commerciale",
  contact_user_email: "E-mail de la personne de contact",
  c_median_maturity: "Maturit\xE9 m\xE9diane",
  r_commercial_rental_space: "Surface locative commerciale",
  r_absolute_directors_fees: "R\xE9mun\xE9ration du conseil d'administration (montant)",
  r_realised_capital_gains_and_losses: "Gains et pertes en capital r\xE9alis\xE9s",
  start: "D\xE9but",
  r_ebit: "EBIT (B\xE9n\xE9fice avant int\xE9r\xEAts et imp\xF4ts)",
  region: "R\xE9gion",
  m_unit_outstanding: "Unit\xE9s en circulation",
  r_net_assets_at_end_of_the_financial_year: "Actifs nets \xE0 la fin de l'exercice financier",
  hist_volatility_30_days: "Volatilit\xE9 historique sur 1 Mois",
  estimated_idc_per_m2: "Intensit\xE9 \xE9nerg\xE9tique par m\xB2",
  share_class_nav: "Valeur Nette d'Actif",
  building_groups_nb: "Nombre de groupes de b\xE2timents",
  one_year_avg_volume: "Volume moyen sur 1 an",
  ewid: "Ewid",
  m_dividend: "Dividende",
  canton: "Canton",
  r_unrealised_capital_gains_and_losses: "Gains et pertes en capital non r\xE9alis\xE9s",
  share_class_nb: "Nombre d'actions",
  used_all_seats: "Nombre total de licences attribu\xE9es",
  commercial_spaces_area: "Surface commerciale",
  fund_names: "Propri\xE9taire",
  r_agio_at_year_end: "Agio \xE0 la fin de l'ann\xE9e",
  r_share_buyback_commissions: "Commissions de rachat d'actions",
  r_construction_and_works_fees: "Frais de construction et de travaux",
  r_other_assets: "Autres actifs",
  actual_rental_status_target: "Revenu locatif cible",
  r_nopat: "NOPAT (R\xE9sultat net d'exploitation)",
  contact_user: "Personne de contact",
  already_reimbursed: "D\xE9j\xE0 rembours\xE9",
  c_nav_compounded: "VNI capitalis\xE9e",
  r_absolute_management_fees: "Frais de gestion",
  sector_nb: "Num\xE9ro de secteur",
  r_variation_estimated_liquidation_taxes: "Variation des imp\xF4ts sur la liquidation estim\xE9e",
  related_am: "Responsable de compte",
  r_tga_before_distribution: "TGA avant distribution",
  investor_users: "Utilisateurs-investisseurs",
  ground_area: "Surface de terrain",
  potential_gross_rent_per_m2: "Loyer brut par m\xB2",
  ter_nav: "TERrefVNI",
  value_net_asset: "Valeur Nette d'Actif",
  r_invested_capital: "Capital investi",
  real_rent: "Loyer r\xE9el",
  c_current_agio_after_distribution: "Agio actuel apr\xE8s distribution",
  total_gross_assets: "Total des actifs bruts",
  total_institutional_seat: "Nombre total de licences utilisateur-institutionnel",
  actual_market_value: "Valeur de march\xE9",
  c_debt_ratio: "Ratio d'endettement",
  r_total_liabilities: "Total des passifs",
  r_ter_nav: "TERrefVNI",
  r_provisions_for_future_works: "Provisions pour travaux futurs",
  r_other_revenue: "Autres revenus",
  r_tna_after_distribution: "TNA apr\xE8s distribution",
  target_rent: "Loyer cible",
  r_property_management_expenses: "D\xE9penses de gestion immobili\xE8re",
  locality: "Localit\xE9",
  co2: "CO\u2082",
  hist_volatility_180_days: "Volatilit\xE9 historique sur 6 Mois",
  r_maintenance_costs: "Co\xFBts de maintenance",
  seller_name: "Vendeur",
  energy_intensity: "Intensit\xE9 \xE9nerg\xE9tique",
  r_total_dividend: "Dividende total",
  potential_net_rent: "Revenu locatif",
  c_total_cash_per_share: "Tr\xE9sorerie totale par action",
  date: "Ann\xE9e",
  potential_charges_monthly: "Charges mensuelles des locataires",
  total_investor_seat: "Nombre total de licences utilisateur-investisseur",
  real_net_rent: "Revenu locatif",
  c_current_liabilities: "Passifs courants",
  r_short_term_liabilities: "Passifs \xE0 court terme",
  real_roa: "ROA (Rendement des actifs)",
  c_tga_compounded: "TGA capitalis\xE9",
  c_total_current_agio_after_distribution: "Agio total actuel apr\xE8s distribution",
  qtd_net_return: "Cumul trimestriel du rendement net \xE0 ce jour",
  c_net_initial_yield: "Rendement initial net",
  c_current_agio_compounded: "Agio actuel capitalis\xE9",
  r_total_revenue: "Revenu total",
  r_other_rental_space: "Autre surface locative",
  implied_volatility: "Volatilit\xE9 implicite",
  c_gav_after_distribution: "GAV apr\xE8s distribution",
  phone: "T\xE9l\xE9phone",
  potential_total_income: "Loyer net",
  r_administration_of_buildings: "Administration des b\xE2timents",
  duplex: "Duplex",
  r_dividend_from_direct_rental_income: "Dividende provenant des revenus locatifs directs",
  last_report_date: "Date du dernier rapport",
  mtd_net_return: "Cumul mensuel du rendement net",
  social: "Score S",
  real_charges_monthly: "Charges mensuelles des locataires",
  yearly_management_fee: "Frais de gestion",
  end: "Fin",
  nb: "Num\xE9ro de parcelle",
  r_mortgage_interest: "Int\xE9r\xEAt hypoth\xE9caire",
  share_class_gav: "Valeur brute des actifs",
  street_short: "Adresse",
  ticker: "Ticker",
  potential_market_value: "Valeur de march\xE9",
  one_year_total_return: "Rendement total sur 1 an",
  r_tna: "TNA",
  label: "\xC9tiquette",
  r_absolute_legal_fees: "Frais juridiques (montant)",
  r_net_income: "Revenu net",
  roic: "ROIC (Retour sur le Capital Investi)",
  rental_losses: "Pertes sur loyer",
  municipality_name: "Municipalit\xE9",
  r_administration_expenses: "D\xE9penses administratives",
  agio: "Agio",
  license_use: "Utilisation des licences",
  has_building: "A un b\xE2timent",
  r_dividend_from_capital_gains: "Dividende provenant des plus-values",
  r_absolute_property_management_fees: "Frais de gestion immobili\xE8re (montant)",
  r_auditing_expenses: "D\xE9penses d'audit",
  companies: "Entreprises",
  last_active: "Derni\xE8re activit\xE9",
  energy_source_water: "Source de chauffage de l'eau",
  construction_date: "Ann\xE9e de construction",
  r_commercial_spaces_area: "Surface commerciale",
  used_consumer_seat: "Licences utilisateur-consommateur attribu\xE9es",
  r_max_share_buyback_commissions: "Max commissions de rachat d'actions",
  r_market_value: "Valeur de march\xE9",
  minergie_label: "\xC9tiquette",
  rent_default_rate: "D\xE9faut de loyer",
  rate: "Taux",
  three_months_avg_volume: "Volume moyen sur 3 mois",
  r_profit_and_capital_taxes: "Imp\xF4ts sur les b\xE9n\xE9fices et imp\xF4ts sur le capital",
  actual_rental_status_real: "Revenu locatif",
  r_roi: "ROI (Retour sur Investissement)",
  r_dividend_from_indirect_rental_income: "Dividende provenant des revenus locatifs indirects",
  ytd_net_return: "Cumul annuel du rendement net \xE0 ce jour",
  r_ter_mv: "TERrefMV",
  r2: "R\xB2",
  dwellings_nb: "Nombre de logements",
  r_cost_price: "Prix de revient",
  r_performance: "Performance",
  fifty_two_weeks_high: "Plus haut sur 52 semaines",
  actual_target_roa: "ROA cible",
  currency: "Monnaie",
  r_max_custodian_bank_fees: "Frais de banque d\xE9positaire maximum",
  r_long_term_interest_bearing_mortgages: "Pr\xEAts hypoth\xE9caires \xE0 long terme portant int\xE9r\xEAt",
  labels: "Labels Minergie",
  beta: "B\xEAta",
  payout_ratio: "Taux de distribution",
  developer_mode: "Mode d\xE9veloppeur",
  fifty_two_weeks_low: "Plus bas sur 52 semaines",
  high: "Haut",
  social_rating: "Note S",
  c_roa: "ROA (Rendement des actifs)",
  c_weighted_average_cost_of_debt: "Co\xFBt moyen pond\xE9r\xE9 de la dette",
  r_debt_ratio: "Ratio d'endettement",
  r_unrealised_gains_and_losses_including_var_est_liq_tax: "Gains/pertes non r\xE9alis\xE9s incluant la variation de l'imp\xF4t sur la liquidation",
  contact_user_phone: "Num\xE9ro de t\xE9l\xE9phone de la personne de contact",
  zip: "Code postal",
  dividend_date: "Date de dividende",
  r_residential_area: "Surface r\xE9sidentielle",
  r_purchase_and_sale_fees: "Frais d'achat et de vente",
  roe: "ROE (Rentabilit\xE9 des Capitaux Propres)",
  low: "Bas",
  r_total_income: "Revenu total",
  rights: "Droits",
  r_roe: "ROE (Rentabilit\xE9 des Capitaux Propres)",
  c_ebit_margin: "Marge op\xE9rationnelle (marge EBIT)",
  r_absolute_custodian_bank_commission_fees: "Frais de commissions de banque d\xE9positaire (montant)",
  r_other_administration_expenses: "Autres frais d'administration",
  r_share_issue_commissions: "Commissions d'\xE9mission d'actions",
  hist_volatility_250_days: "Volatilit\xE9 historique sur 1 an",
  six_months_return: "Rendement net sur 6 mois",
  r_wault: "WAULT (Dur\xE9e r\xE9siduelle moyenne pond\xE9r\xE9e des baux)",
  r_total_net_assets: "Actifs nets totaux",
  r_maintenance_and_repairs_expenses: "D\xE9penses d'entretien et de r\xE9parations",
  r_other_short_term_liabilities: "Autres passifs \xE0 court terme",
  lots_nb: "Nombre de parcelles",
  r_custodian_bank_fees: "Frais de banque d\xE9positaire",
  r_gross_yield: "ROA (Rendement des actifs)",
  r_net_assets_at_beginning_of_the_financial_year: "Actifs nets au d\xE9but de l'exercice financier",
  c_earnings_per_share: "B\xE9n\xE9fice par action",
  c_median_cost_of_debt: "Co\xFBt m\xE9dian de la dette",
  esg: "Score ESG",
  last_activity_date: "Derni\xE8re activit\xE9",
  potential_charges_per_m2: "Charges par m\xB2",
  five_days_avg_volume: "Volume moyen 5 jours",
  volume: "Volume",
  five_years_avg_dividend_yield: "Rendement moyen de dividende sur 5 ans",
  r_units_outstanding: "Unit\xE9s en circulation",
  r_negative_interest: "Int\xE9r\xEAt n\xE9gatif",
  environmental_rating: "Note E",
  c_gav_compounded: "GAV capitalis\xE9",
  one_month_return: "Rendement net sur 1 mois",
  total_area: "Surface totale",
  r_total_interest: "Int\xE9r\xEAt total",
  dividend_yield: "Rendement de dividende",
  institutional_users: "Utilisateurs-institutionnels",
  r_total_area: "Surface totale",
  egid: "EGID",
  c_price_to_book_value: "Ratio cours/valeur comptable (price to book ratio)",
  r_net_assets_before_estimated_liquidation_taxes: "Actifs nets avant les imp\xF4ts de liquidation estim\xE9s",
  r_retained_earnings: "B\xE9n\xE9fices non distribu\xE9s",
  three_months_return: "Rendement net sur 3 mois",
  value_gross_asset: "Valeur brute des actifs",
  m_share_price_var: "Variation du prix de l'action",
  last_renovation_year: "Derni\xE8re ann\xE9e de r\xE9novation",
  subscribed_date: "Abonn\xE9 depuis",
  r_rental_losses: "Pertes sur loyer",
  m_market_cap: "Capitalisation",
  r_total_properties: "Total des propri\xE9t\xE9s",
  free_investor_seat: "Licences utilisateur-investisseur restantes",
  r_dividend_yield: "Rendement de dividende \xE0 la fin de l'ann\xE9e",
  r_property_management_fees: "Frais de gestion immobili\xE8re",
  short_name: "Nom court",
  market_value: "Valeur de march\xE9",
  bloomberg_ticker: "Ticker",
  rent_defaults: "D\xE9fauts de paiement de loyer",
  r_short_term_interest_bearing_mortgages: "Pr\xEAts hypoth\xE9caires \xE0 court terme portant int\xE9r\xEAt",
  free_institutional_seat: "Licences utilisateur-institutionnel restantes",
  estimated_co2_emission_per_m2: "CO\u2082 par m\xB2",
  r_capital_employed: "Capital employ\xE9",
  alpha: "Alpha",
  actual_real_roa: "ROA (Rendement des actifs)",
  debt_ratio: "Ratio d'endettement",
  enterprise: "Entreprise",
  net_initial_yield: "Rendement initial net",
  launch_date: "Date de lancement",
  fund_legal_forms: "Type de propri\xE9taire",
  c_weighted_average_maturity: "Maturit\xE9 moyenne pond\xE9r\xE9e",
  esg_rating: "Note ESG",
  counterpart_fund: "Fonds contrepartie",
  r_roce: "ROCE (Rentabilit\xE9 des capitaux investis)",
  residential_area: "Surface r\xE9sidentielle",
  five_years_total_return: "Rendement total sur 5 ans",
  potential_net_rent_per_m2: "Revenu locatif par m\xB2",
  environmental: "Score E",
  dividend: "Dividende",
  days_left: "Jours restants",
  rental_space: "Surface",
  r_revenue_from_postal_and_bank_accounts: "Revenus provenant des comptes postaux et comptes bancaires",
  r_tga: "TGA",
  roi: "ROI (Retour sur Investissement)",
  one_month_avg_volume: "Volume moyen sur 1 mois",
  roa: "ROA (Rendement des actifs)",
  r_market_maker_fees: "Frais de teneur de march\xE9",
  r_realised_income: "Revenu r\xE9alis\xE9",
  r_ordinary_maintenance_and_repairs_expenses: "D\xE9penses ordinaires de maintenance et de r\xE9parations",
  r_roic: "ROIC (Retour sur le Capital Investi)",
  r_roa: "ROA (Rendement des actifs)",
  rooms_nb: "Nombre de pi\xE8ces",
  hist_volatility_90_days: "Volatilit\xE9 historique sur 3 Mois",
  six_months_avg_volume: "Volume moyen sur 6 mois",
  c_revenue_per_share: "Revenu par action",
  c_payout_ratio: "Taux de distribution",
  address: "Adresse",
  subscription_start: "Date d'abonnement",
  c_roce: "ROCE (Rentabilit\xE9 des capitaux investis)",
  r_absolute_custodian_bank_distribution_fees: "Frais de distribution de banque d\xE9positaire (montant)",
  turnover: "Chiffre d'affaires",
  net_rent: "Loyer net",
  value: "Valeur",
  potential_charges: "Charges locatives",
  r_tga_after_distribution: "TGA apr\xE8s distribution",
  all_users: "Membres de l'\xE9quipe",
  r_payout_ratio: "Taux de distribution",
  role: "R\xF4le",
  ter_gav: "TERrefGAV",
  solar_existing: "Puissance solaire install\xE9e",
  r_max_management_fees: "Frais de gestion maximum",
  potential_gross_rent: "Loyer brut",
  rate_type: "Type de taux",
  r_building_expenses: "D\xE9penses d\u2019exploitation",
  expires_at: "Date d'expiration",
  r_residential_rental_space: "Surface locative r\xE9sidentielle",
  c_total_agio_at_year_end: "Agio total \xE0 la fin de l'ann\xE9e",
  r_property_tax: "Taxe fonci\xE8re",
  r_valuation_and_auditing_expenses: "D\xE9penses d'\xE9valuation et d'audit",
  r_estimated_liquidation_taxes: "Taxes de liquidation estim\xE9es",
  isin: "ISIN",
  r_max_share_issue_commissions: "Commissions d'\xE9mission de parts maximales",
  real_market_value: "Valeur de march\xE9",
  c_agio_at_year_end: "Agio \xE0 la fin de l'ann\xE9e",
  state: "Processus d'invitation",
  vwap: "VWAP (Prix moyen pond\xE9r\xE9 en fonction du volume)",
  governance: "Score G",
  c_operating_profit: "B\xE9n\xE9fice d'exploitation",
  r_mixed_rental_space: "Surface locative mixte",
  r_market_cap: "Capitalisation boursi\xE8re \xE0 la fin de l'ann\xE9e",
  r_max_property_management_fees: "Frais de gestion immobili\xE8re maximum",
  r_real_rent: "Revenu locatif",
  building_category: "Cat\xE9gorie de b\xE2timent",
  c_three_years_total_return: "Retour total sur 3 ans",
  real_charges: "Charges locatives",
  fund_name: "Nom du fonds",
  r_ter_gav: "TERrefGAV",
  c_nav_after_distribution: "VNI apr\xE8s distribution",
  environment: {
    score: "Score environnemental"
  },
  r_other_expenses: "Autres d\xE9penses",
  c_loan_to_value: "Ratio pr\xEAt-valeur",
  r_share_price: "Prix de l'action",
  free_consumer_seat: "Licences utilisateur-consommateur restantes",
  r_other_long_term_liabilities: "Autres passifs \xE0 long terme",
  total_co2: "\xC9missions de CO\u2082",
  buildings_nb: "Nombre de b\xE2timents",
  r_extraordinary_maintenance_and_repairs_expenses: "D\xE9penses d'entretien et de r\xE9parations extraordinaires",
  r_max_construction_and_works_fees: "Frais de construction et de travaux maximum",
  type: "Type",
  user: "Utilisateur",
  total_all_seats: "Nombre total de licences",
  r_target_rent: "Revenu locatif cible",
  r_rental_income: "Revenu locatif",
  egrid: "EGRID",
  r_rental_space: "Surface locative",
  used_institutional_seat: "Licences utilisateur-institutionnel attribu\xE9es",
  governance_rating: "Note G",
  r_provisions_for_doubtful_debtors: "Provisions pour cr\xE9ances douteuses",
  r_management_fees: "Frais de gestion",
  potential_roa: "ROA (Rendement des actifs)",
  c_five_years_total_return: "Rendement total sur 5 ans",
  ter_mv: "TERrefMV",
  r_valuation_expenses: "D\xE9penses d'\xE9valuation",
  three_years_total_return: "Retour total sur 3 ans",
  legal_form: "Forme juridique",
  five_years_return: "Rendement net sur 5 ans",
  last: "Dernier",
  name: "Nom",
  c_tna_compounded: "TNA capitalis\xE9",
  r_other_interest: "Autres int\xE9r\xEAts",
  r_total_expenses: "D\xE9penses totales",
  created_at: "Date de cr\xE9ation",
  market_cap: "Capitalisation",
  r_ordinary_income_carried_forward_from_previous_financial_year: "Revenu ordinaire report\xE9 de l'exercice financier pr\xE9c\xE9dent",
  open: "Prix \xE0 l\u2019ouverture",
  key_name: "Nom cl\xE9",
  real_net_rent_monthly: "Revenu locatif mensuel",
  c_current_ratio: "Ratio de liquidit\xE9",
  c_roe: "ROE (Rentabilit\xE9 des Capitaux Propres)",
  r_plots_rental_space: "Surface locative \xE0 b\xE2tir",
  floors_nb: "Nombre d'\xE9tages",
  r_max_purchase_and_sale_fees: "Frais d'achat et de vente maximum",
  r_interest_on_building_rights: "Int\xE9r\xEAt sur les droits de construction",
  m_dividend_date: "Date de dividende",
  entity_name: "Nom",
  lot_nb: "Num\xE9ro de parcelle",
  used_investor_seat: "Licences utilisateur-investisseur attribu\xE9es",
  actions: "Plus d'actions",
  potential_net_rent_monthly: "Revenu locatif mensuel",
  market_price: "Prix de l'action",
  expiration_date: "Date de fin de contrat",
  estimated_area: "Surface",
  one_year_return: "Rendement net sur 1 an",
  r_total_rental_space: "Surface locative totale",
  r_dividend_distribution: "Distribution de dividendes",
  tx_price: "Co\xFBt de transaction",
  construction_year: "Ann\xE9e de construction",
  tx_year: "Ann\xE9e de transaction"
};
var highlight = {
  label: {
    category: {
      high: "Haut",
      very_high: "Tr\xE8s haut",
      medium: "Moyen",
      low: "Bas",
      very_low: "Tr\xE8s bas",
      null: "-",
      undefined: "-"
    }
  }
};
var asset_page = {
  environmental: {
    energy: {
      co2: {
        title: "\xC9missions de CO\u2082",
        total_official_co2_emission: "Total CO\u2082 (officiel)",
        total_estimated_co2_emission: "Total CO\u2082",
        estimated_co2_emission_per_m2: "CO\u2082 par m\xB2",
        official_co2_emission_per_m2: "CO\u2082 par m\xB2 (officiel)",
        estimated_co2: "\xC9missions de CO\u2082"
      },
      idc: {
        estimated_idc: "Intensit\xE9 \xE9nerg\xE9tique",
        total_estimated_idc: "Intensit\xE9 \xE9nerg\xE9tique totale",
        title: "Intensit\xE9 \xE9nerg\xE9tique",
        total_official_idc: "Intensit\xE9 \xE9nerg\xE9tique totale (officielle)",
        official_idc_per_m2: "Intensit\xE9 \xE9nerg\xE9tique par m\xB2 (officiel)",
        estimated_idc_per_m2: "Intensit\xE9 \xE9nerg\xE9tique par m\xB2"
      },
      heating: {
        energy_generator_heating_1: "G\xE9n\xE9rateur de chauffage",
        energy_source_heating_1: "Source d'\xE9nergie de chauffage",
        energy_generator_water_1: "G\xE9n\xE9rateur d'eau chaude",
        energy_source_water_1: "Source d'\xE9nergie pour l'eau chaude",
        title: "G\xE9n\xE9ration de chauffage"
      },
      title: "\xC9nergie",
      solar: {
        solar_existing: "Puissance solaire install\xE9e",
        title: "Solaire",
        solar_potential: "Potentiel solaire"
      }
    },
    risk: {
      climate_risk_index: {
        title: "Indice de risque climatique"
      },
      sia261: "Zone sismique SIA 261",
      debris_flow: "Flux de d\xE9bris",
      overbank_sedimentation: "S\xE9dimentation en zone de d\xE9bordement",
      risk: {
        title: "Risques environnementaux"
      },
      chart: {
        suffix: "/10",
        description: "L'indice de risque climatique est calcul\xE9 en fonction de l'exposition \xE0 diff\xE9rents risques environnementaux. Chaque risque a un poids \xE9gal dans l'indice."
      },
      avalanches: "Avalanches",
      hail_hazard_10_years_average: "Taille de la gr\xEAle",
      title: "Risques",
      rockfalls: "Chutes de pierres",
      floods_50_years: "Inondations",
      landslides: "Glissements de terrain",
      windstorm_avg_rate: {},
      hail_avg_rate: {},
      damage_rate: {},
      detailed_rates: {},
      flood_avg_rate: {}
    },
    environment: {
      pollution: {
        road_noise_day: {
          label: "Bruit de circulation de jour"
        },
        road_noise_night: {
          label: "Bruit de circulation de nuit"
        },
        rail_noise_night: {
          label: "Bruit de train de nuit"
        },
        rail_noise_day: {
          label: "Bruit de train de jour"
        },
        title: "Pollution sonore"
      },
      climate: {
        temperature: {
          title: "Temp\xE9rature moyenne"
        },
        title: "Climat",
        rain: {
          title: "Pr\xE9cipitations moyennes"
        },
        sunlight: {
          title: "Ensoleillement moyen"
        }
      },
      title: "Environnement"
    },
    co2: {
      co2_scope_1_2_33_per_m2: "CO\u2082 (scope 1 + 2 + 3.3)",
      co2_scope_2_per_m2: "CO\u2082 (scope 2)",
      co2_scope_1_2_per_m2: {
        description: "Les \xE9missions de CO\u2082 sont calcul\xE9es en multipliant l'intensit\xE9 \xE9nerg\xE9tique par le coefficient REIDA correspondant pour chaque b\xE2timent.",
        key: "CO\u2082 (scope 1 + 2)"
      },
      co2_scope_1_per_m2: "CO\u2082 (scope 1)",
      total_co2_scope_1_2: "Total CO\u2082 (scope 1 + 2)",
      total_co2_scope_1_2_33: "Total CO\u2082 (scope 1 + 2 + 3.3)",
      co2_scope_33_per_m2: "CO\u2082 (scope 3.3)"
    },
    idc: {
      idc_per_m2: {
        description: "L'intensit\xE9 \xE9nerg\xE9tique mesure la consommation d'\xE9nergie estim\xE9e par m\xE8tre carr\xE9 de surface de chauffage sur une ann\xE9e pour le b\xE2timent.",
        key: "Intensit\xE9 \xE9nerg\xE9tique"
      },
      total_idc: "\xC9nergie totale"
    },
    title: "Environnemental",
    risks: {
      damage_rate: {}
    }
  },
  social: {
    demographic: {
      birth: {
        subject: "Naissances"
      },
      civil_status: {
        death: "D\xE9c\xE8s par an",
        divorce: "Divorces par an",
        birth: "Naissances par an",
        title: "\xC9tat civil",
        household: "Taille moyenne du m\xE9nage",
        marriage: "Mariages par an"
      },
      ages: {
        title: "\xC2ges"
      },
      emigration: {
        subject: "\xC9migration"
      },
      title: "D\xE9mographique",
      vital_statistics: {
        title: "Statistiques vitales"
      },
      immigration: {
        subject: "Immigration"
      },
      foreigners: {
        title: "\xC9trangers"
      },
      gender: {
        title: "Genre"
      },
      migration: {
        title: "Migration"
      },
      death: {
        subject: "D\xE9c\xE8s"
      }
    },
    transportation_accessibility: {
      computed_early_years_meter: "Premi\xE8res ann\xE9es",
      computed_shops_minute: "Boutiques",
      computed_primary_education_meter: "Enseignement primaire",
      computed_cultural_venues_meter: "\xC9tablissements culturels",
      computed_restaurants_meter: "Restaurants",
      radar: {
        title: "Accessibilit\xE9 des services \xE0 proximit\xE9"
      },
      computed_sports_recreation_minute: "Sport et loisirs",
      computed_transport_bike_minute: "Stationnement pour v\xE9los",
      computed_sports_recreation_meter: "Sport et loisirs",
      computed_restaurants_minute: "Restaurants",
      official_pt_accessibility: {
        title: "Score d'accessibilit\xE9 moyen"
      },
      computed_healthcare_meter: "Services de sant\xE9",
      computed_social_and_cultural_activities_minute: "Activit\xE9s sociales et culturelles",
      computed_public_open_space_minute: "Espace public ouvert",
      computed_cultural_venues_minute: "\xC9tablissements culturels",
      computed_public_transport_minute: "Transports publics",
      computed_transport_bus_meter: "Bus",
      road_accessibility: {
        label: "Accessibilit\xE9 par la route",
        title: "Par la route",
        description: "Score d'accessibilit\xE9 par la route selon l'ARE"
      },
      transport_accessibility: {
        title: "En train",
        label: "Accessibilit\xE9 en transports publics",
        description: "Score d'accessibilit\xE9 en transports publics selon l'ARE"
      },
      computed_aged_care_minute: "Soins aux personnes \xE2g\xE9es",
      title: "Accessibilit\xE9",
      computed_aged_care_meter: "Soins aux personnes \xE2g\xE9es",
      computed_transport_bus_minute: "Bus",
      computed_healthcare_minute: "Services de sant\xE9",
      official_road_accessibility: {
        title: "Score d'accessibilit\xE9 moyen"
      },
      computed_secondary_education_meter: "Enseignement secondaire",
      computed_shops_meter: "Boutiques",
      computed_transport_bike_meter: "Stationnement pour v\xE9los",
      computed_aged_and_early_years_care_minute: "Soins aux personnes \xE2g\xE9es et \xE0 la petite enfance",
      computed_early_years_minute: "Premi\xE8res ann\xE9es",
      computed_transport_train_meter: "Train",
      computed_primary_education_minute: "Enseignement primaire",
      map: {
        title: "Carte des services \xE0 proximit\xE9"
      },
      computed_transport_train_minute: "Train",
      table: {
        title: "Temps de marche moyen jusqu'aux commodit\xE9s"
      },
      computed_secondary_education_minute: "Enseignement secondaire",
      computed_public_open_space_meter: "Espace public ouvert"
    },
    well_being: {
      title: "Bien-\xEAtre",
      public_utility: {
        key: "B\xE2timent public",
        title: "B\xE2timent public"
      }
    },
    accessibility: {
      transportation: {
        title: "Transports publics"
      },
      transport_train: "Train",
      aged_care: "Soins aux personnes \xE2g\xE9es",
      goods_and_services: {
        title: "Autre"
      },
      title: "Distances aux biens et services",
      early_years: "Premi\xE8res ann\xE9es",
      distance: {
        title: "Accessibilit\xE9"
      },
      chart: {
        subject: "Indice",
        title: "Accessibilit\xE9",
        suffix: "/10"
      },
      restaurants: "Restaurants",
      healthcare: "Sant\xE9",
      shops: "Boutiques",
      health_and_edu: {
        title: "Sant\xE9 & \xC9ducation"
      },
      cultural_venues: "\xC9tablissements culturels",
      primary_education: "Enseignement primaire",
      transport_bus: "Bus",
      secondary_education: "Enseignement secondaire"
    },
    income_and_taxes: {
      income: {
        label: "Revenu",
        description: "Description",
        title: "Revenu",
        subject: "Revenu par contribuable"
      },
      wealth: {
        label: "Fortune"
      },
      title: "Revenus et imp\xF4ts",
      canton_tax: {
        title: "Multiplicateurs d'imp\xF4ts cantonaux"
      },
      capital: {
        label: "Capital"
      },
      municipality_tax: {
        title: "Multiplicateurs de taxe municipale"
      },
      profit: {
        label: "Profit"
      }
    },
    density: {
      occupancy_per_100_m2: {
        title: "Taux d'occupation par 100 m\xB2"
      },
      occupancy: {
        per_meter: "Par 100 m\xB2",
        per_bedroom: "Par chambre \xE0 coucher",
        title: "Taux d'occupation"
      },
      migration: {
        departure: "D\xE9part par habitant",
        title: "Migration",
        arrival: "Arriv\xE9e par habitant"
      },
      title: "Densit\xE9",
      green_density: {
        key: "Densit\xE9 d'espaces verts",
        description: "La mesure de densit\xE9 d'espaces verts \xE9value la part des hectares environnants contenant une majorit\xE9 de zones vertes, selon l'utilisation des sols (NOAS04)",
        title: "V\xE9g\xE9tation"
      },
      population_density: {
        title: "Densit\xE9 de population",
        description: "La densit\xE9 de population mesure la densit\xE9 de population moyenne dans les hectares environnants par b\xE2timent, selon STATPOP.",
        key: "Densit\xE9 de population"
      },
      job_density: {
        title: "Densit\xE9 d'emplois",
        description: "La densit\xE9 d'emplois mesure la densit\xE9 d'emplois moyenne en hectares environnants par b\xE2timent, selon STATENT.",
        key: "Densit\xE9 d'emplois"
      },
      occupancy_per_m2: {
        subject: "Habitants"
      },
      income: {
        title: "Revenu par contribuable",
        subject: "Revenu par contribuable"
      },
      occupancy_per_bedroom: {
        subject: "Habitants",
        title: "Taux d'occupation par chambre"
      }
    },
    title: "Social"
  },
  valuation: {
    parameters: {
      transaction_fees: {
        property_transfert_fees: {
          suffix: "%",
          label: "Frais de transfert de propri\xE9t\xE9"
        },
        notary_fees: {
          suffix: "%",
          label: "Frais de notaire"
        },
        land_registration_fees: {
          suffix: "%",
          label: "Frais d'enregistrement foncier"
        },
        title: "Frais de transaction"
      },
      buyer_seller: {
        other_fees_pts: {
          label: "Autres frais",
          suffix: "%"
        },
        title: "Acheteur / Vendeur",
        other_fees_chf: {
          label: "Autres frais",
          suffix: "CHF"
        },
        share_buyers_seller: {
          suffix: "%",
          label: "Part acheteur / vendeur"
        },
        asset_manager_fees: {
          suffix: "%",
          label: "Frais du gestionnaire d'actifs"
        }
      },
      due_diligence_cost: {
        other_valuations: {
          label: "Autres \xE9valuations",
          suffix: "CHF"
        },
        title: "Co\xFBt de diligence raisonnable",
        valuation: {
          suffix: "CHF",
          label: "\xC9valuation"
        }
      },
      title: "Param\xE8tres"
    },
    qh_method: {
      result: {
        title: "R\xE9sultat",
        total_acquisition_cost: {
          suffix: "CHF",
          label: "Co\xFBt total d'acquisition"
        },
        purchase_price: {
          label: "Prix d'achat",
          suffix: "CHF"
        }
      },
      description: {
        content: "Les algorithmes d'apprentissage automatique de Quanthome estiment le rendement cible attendu pour le b\xE2timent et pr\xE9disent une valeur bas\xE9e sur les flux de tr\xE9sorerie estim\xE9s.",
        title: "Description"
      },
      title: "La m\xE9thode de Quanthome"
    },
    cap_rate_method: {
      cap_rate_inputs: {
        title: "Entr\xE9es du taux de capitalisation",
        capitalization_rate: {
          label: "Taux de capitalisation",
          suffix: "%"
        }
      },
      income_inputs: {
        other: {
          label: "Autres revenus",
          suffix: "CHF"
        },
        dwelling_net_rent: {
          suffix: "CHF",
          label: "Loyer net du logement"
        },
        office_net_income: {
          label: "Revenu net de bureau",
          suffix: "CHF"
        },
        residential_net_income: {
          suffix: "CHF",
          label: "Revenu net r\xE9sidentiel"
        },
        title: "Entr\xE9es de revenus",
        industrial: {
          label: "Industriel",
          suffix: "CHF"
        },
        parking: {
          suffix: "CHF",
          label: "Parking"
        },
        commercial: {
          label: "Revenu commercial",
          suffix: "CHF"
        }
      },
      result: {
        total_acquisition_cost: {
          label: "Co\xFBt total d'acquisition",
          suffix: "CHF"
        },
        purchase_price: {
          suffix: "CHF",
          label: "Prix d'achat"
        },
        title: "R\xE9sultat"
      },
      description: {
        content: "La m\xE9thode du taux de capitalisation (cap rate) appliqu\xE9e \xE0 l'immobilier est utilis\xE9e pour estimer la valeur potentielle d'un bien. Elle est calcul\xE9e en divisant le revenu locatif par le rendement cible. Les taux de capitalisation ne tiennent pas compte de l'appr\xE9ciation future de la valeur ou des co\xFBts de financement.",
        title: "Description"
      },
      title: "M\xE9thode du taux de capitalisation"
    },
    title: "\xC9valuation"
  },
  description: {
    tile: {
      description: "Description",
      parent_description: "Description du parent",
      usage: "Utilisation",
      administrative_information: "Informations Administratives",
      geometry: "G\xE9om\xE9trie",
      addresses: "Adresses",
      location: "Emplacement",
      amenities: "Commodit\xE9s",
      dwellings: {
        parent_description: "Description du parent du b\xE2timent"
      },
      buildings: {
        parent_description: "Description de la parcelle"
      }
    },
    title: "Description",
    identification: {
      title: "Identification"
    },
    general_information: {
      title: "Informations G\xE9n\xE9rales"
    }
  },
  financials: {
    ratio_metric: {
      total_tenant_charges: "Charges totales des locataires",
      price_per_m2: "Prix par m\xB2",
      office: "Bureau",
      residential: "R\xE9sidentiel",
      title: "Indicateurs par m\xE8tre carr\xE9",
      price: {
        title: "Prix"
      },
      commercial_spaces: {
        label: "Espaces commerciaux"
      },
      charges_per_m2: "Charges locatives par m\xB2",
      charges: {
        title: "Charges"
      },
      average: "Moyenne",
      market_value_reported: "Valeur de march\xE9",
      rent_per_m2: "Revenu locatif par m\xB2",
      industrial: "Industriel",
      rent: {
        title: "Revenu locatif"
      },
      commercial: "Commercial",
      dwellings: {
        label: "Logements"
      },
      market_value: "Valeur de march\xE9"
    },
    title: "Finances",
    unit: {
      chf: "CHF"
    },
    charges: {
      title: "Charges locatives"
    },
    tile: {
      charges: "Charges locatives",
      rental_income: "Revenu locatif",
      evolution: "\xC9volution"
    },
    dwellings: {
      label: "Logements"
    },
    revenue: {
      title: "Revenu"
    },
    comparables: {
      title: "Comparables"
    },
    units: {
      total_rent: "CHF",
      commercial_rent: "CHF",
      residential_rent: "CHF"
    },
    performance: {
      rental_income: "Revenu locatif",
      title: "Performance"
    },
    metrics: {
      title: "Indicateurs par m\xE8tre carr\xE9"
    },
    total: {
      label: "Total"
    },
    commercial_spaces: {
      label: "Espaces commerciaux"
    }
  },
  overview: {
    description: {
      market_value: "Valeur de march\xE9",
      co2: "CO\u2082",
      net_rent: "Revenu locatif",
      idc: "Intensit\xE9 \xE9nerg\xE9tique",
      charges: "Charges locatives",
      roa: "ROA (Rendement des actifs)"
    }
  },
  governance: {
    item: {
      management: {
        website: "Site web",
        name: "Nom"
      },
      ownership: {
        link: "lien",
        owner: "Propri\xE9taire",
        registry: "Cadastre"
      },
      certification: {
        minergy: "Minergie"
      }
    },
    tile: {
      ownership: "Propri\xE9t\xE9",
      management: "Gestion immobili\xE8re",
      certification: "Certification"
    },
    title: "Gouvernance",
    organisation: {
      title: "Organisation"
    }
  },
  assets: {
    title: "Inventaire"
  }
};
var modal = {
  leaving: {
    buttons: {
      proceed: "Proc\xE9der"
    },
    default_text: "Vous avez cliqu\xE9 sur un lien fourni par Quanthome SA qui vous dirigera en dehors de l\u2019application.\nNous n\u2019avons aucun lien avec ce site web ni avec son propri\xE9taire. Nous vous recommandons vivement, de mani\xE8re g\xE9n\xE9rale lors de votre navigation sur internet, de ne jamais communiquer vos donn\xE9es personnelles sans avoir soigneusement v\xE9rifi\xE9 si le site web en question est (toujours) digne de confiance.\nAucun autre site web ne devrait vous demander vos identifiants Quanthome et aucun gestionnaire d\u2019actifs ne vous demandera votre mot de passe.",
    registry: {
      title: "\xC9tapes \xE0 suivre dans le processus externe"
    },
    title: "Vous \xEAtes sur le point de quitter l'application"
  },
  notifications: {
    title_emailinfo: "Vous pouvez d\xE9sormais d\xE9finir vos pr\xE9f\xE9rences d'email",
    administration_linked: "Vous pouvez d\xE9sormais g\xE9rer l'entreprise {{enterprise}}.",
    empty_message: "Aucune notification",
    title_download: "T\xE9l\xE9charger",
    subtitle_emailinfo: "g\xE9rez les emails que vous recevrez de notre part",
    administration_days_left: "L'\xE9tat de l'entreprise {{enterprise}} n\xE9cessite votre attention : l'\xE9tat {{currentState}} a {{daysLeft}} jours restants.",
    title: "Notifications",
    title_recoverycode: "G\xE9n\xE9rez \xE0 nouveau vos codes de r\xE9cup\xE9ration maintenant",
    administration_examination: "L'entreprise {{enterprise}} est en \xE9tat d'examen depuis un mois.",
    title_administration: "Administration",
    administration_unlinked: "L'entreprise {{enterprise}} a \xE9t\xE9 retir\xE9e de votre liste de gestion."
  },
  downloads: {
    subtitle: {
      file_ready: "Votre fichier est pr\xEAt \xE0 \xEAtre t\xE9l\xE9charg\xE9",
      file_failed: "Votre fichier a \xE9chou\xE9 en raison d'une erreur - Veuillez contacter votre administrateur.",
      file_about_to_expire: "Votre fichier va expirer bient\xF4t.",
      file_expired: "Votre fichier a expir\xE9",
      file_be_ready_soon: "Votre fichier sera pr\xEAt \xE0 \xEAtre t\xE9l\xE9charg\xE9 bient\xF4t."
    },
    empty_message: "Aucun t\xE9l\xE9chargement",
    title: "T\xE9l\xE9chargements",
    not_available: "La fonctionnalit\xE9 de t\xE9l\xE9chargement n'est pas disponible avec votre plan tarifaire actuel."
  },
  preset: {
    title: "Pr\xE9r\xE9glages",
    empty_message: "Aucun pr\xE9r\xE9glage"
  },
  support: {
    error_message: {
      bad_category: "Vous devez s\xE9lectionner une cat\xE9gorie",
      too_many_char: "Trop de caract\xE8res {{char_nb}} > 500",
      no_message: "Vous devez r\xE9diger un message"
    },
    message: "Message",
    select: {
      title: "Probl\xE8me, message, besoin, id\xE9e...",
      message: "Message",
      need: "Besoin",
      placeholder: "Choisir",
      problem: "Probl\xE8me"
    },
    success: {
      message: "Votre rapport a \xE9t\xE9 envoy\xE9 avec succ\xE8s \xE0 notre service client.",
      title: "Rapport envoy\xE9"
    },
    title: "Aide",
    complete_title: "Support / Contact",
    submit_button: "Contactez notre support",
    upload: "T\xE9l\xE9charger"
  },
  historic: {
    title: "Histoire"
  },
  history: {
    title: "Histoire",
    empty_history: "Aucune historique"
  },
  notification: {
    title_download: "T\xE9l\xE9charger"
  }
};
var income_statement = {
  label: {
    total_revenues: "Revenus totaux",
    r_revenue_from_postal_and_bank_accounts: "Revenus provenant des comptes postaux et comptes bancaires",
    r_building_expenses: "D\xE9penses d\u2019exploitation",
    interest_expenses: "D\xE9penses d'int\xE9r\xEAts",
    r_provisions_for_doubtful_debtors: "Provisions pour cr\xE9ances douteuses",
    r_profit_and_capital_taxes: "Imp\xF4ts sur les b\xE9n\xE9fices et imp\xF4ts sur le capital",
    r_valuation_and_auditing_expenses: "D\xE9penses d'\xE9valuation et d'audit",
    r_mortgage_interest: "Int\xE9r\xEAt hypoth\xE9caire",
    r_net_income: "Revenu net",
    r_market_maker_fees: "Frais de teneur de march\xE9",
    r_extraordinary_maintenance_and_repairs_expenses: "D\xE9penses d'entretien et de r\xE9parations extraordinaires",
    ordinary_income_carried_forward: "Revenu ordinaire report\xE9",
    r_absolute_management_fees: "Frais de gestion (montant)",
    retained_earnings: "B\xE9n\xE9fices non distribu\xE9s",
    r_absolute_custodian_bank_distribution_fees: "Frais de distribution de banque d\xE9positaire (montant)",
    r_maintenance_costs: "Co\xFBts de maintenance",
    unrealised_gains_losses_including_liquidation_taxes_variation: "Gains/pertes non r\xE9alis\xE9s incluant la variation des taxes de liquidation",
    total_net_income_available_for_distribution: "Revenu net total disponible pour distribution",
    r_realised_capital_gains_and_losses: "Gains et pertes en capital r\xE9alis\xE9s",
    realised_gains_losses: "Gains/pertes r\xE9alis\xE9s",
    r_total_interest: "Int\xE9r\xEAt total",
    r_administration_expenses: "D\xE9penses administratives",
    r_valuation_expenses: "D\xE9penses d'\xE9valuation",
    other_revenue: "Autres revenus",
    capital_distribution: "Distribution de capital",
    r_ordinary_income_carried_forward_from_previous_financial_year: "Revenu ordinaire report\xE9 de l'exercice financier pr\xE9c\xE9dent",
    valuation_and_auditing_expenses: "D\xE9penses d'\xE9valuation et d'audit",
    total_income: "Revenu total",
    r_absolute_directors_fees: "R\xE9mun\xE9ration du conseil d'administration (montant)",
    r_total_provisions: "Provisions totales",
    r_absolute_legal_fees: "Frais juridiques (montant)",
    r_maintenance_and_repairs_expenses: "D\xE9penses d'entretien et de r\xE9parations",
    r_provisions_for_future_work: "Provisions pour travaux futurs",
    r_dividend_distribution: "Distribution de dividendes",
    r_net_income_available_for_distribution: "Revenu net disponible pour distribution",
    r_provisions_for_future_works: "Provisions pour travaux futurs",
    reproted_market_maker_fees: "Frais de teneur de march\xE9",
    r_absolute_custodian_bank_commission_fees: "Frais de commissions de banque d\xE9positaire (montant)",
    r_auditing_expenses: "D\xE9penses d'audit",
    dividend_distribution: "Distribution de dividendes",
    taxes: "Imp\xF4ts",
    r_unrealised_gains_and_losses_including_var_est_liq_tax: "Gains/pertes non r\xE9alis\xE9s incluant la variation des taxes de liquidation",
    r_interest_on_building_rights: "Int\xE9r\xEAt sur les droits de construction",
    r_taxes: "Imp\xF4ts",
    r_other_interest: "Autres int\xE9r\xEAts",
    r_other_administration_expenses: "Autres frais d'administration",
    r_other_expenses: "Autres d\xE9penses",
    other_expenses: "Autres d\xE9penses",
    negative_interest: "Int\xE9r\xEAt n\xE9gatif",
    realised_income: "Revenu r\xE9alis\xE9",
    maintenance_costs: "Co\xFBts de maintenance",
    r_unrealised_capital_gains_and_losses: "Gains et pertes en capital non r\xE9alis\xE9s",
    r_total_expenses: "D\xE9penses totales",
    r_total_revenue: "Revenu total",
    reproted_ordinary_maintenance_and_repairs_expenses: "D\xE9penses ordinaires de maintenance et de r\xE9parations",
    r_negative_interest: "Int\xE9r\xEAt n\xE9gatif",
    r_total_income: "Revenu total",
    r_retained_earnings: "B\xE9n\xE9fices non distribu\xE9s",
    r_absolute_custodian_bank_fees: "Frais de banque d\xE9positaire (montant)",
    revenue_from_postal_and_bank_accounts: "Revenus provenant des comptes postaux et comptes bancaires",
    year: "Ann\xE9e",
    r_absolute_property_management_fees: "Frais de gestion immobili\xE8re (montant)",
    r_capital_distribution: "Distribution de capital",
    r_administration_of_buildings: "Administration des b\xE2timents",
    net_income: "Revenu net",
    r_ordinary_maintenance_and_repairs_expenses: "D\xE9penses ordinaires de maintenance et de r\xE9parations",
    rental_income: "Revenu locatif",
    r_rental_income: "Revenu locatif",
    other_net_income_available_for_distribution: "Autre revenu net disponible pour distribution",
    r_property_management_expenses: "D\xE9penses de gestion immobili\xE8re",
    r_other_revenue: "Autres revenus",
    r_property_tax: "Taxe fonci\xE8re",
    r_realised_income: "Revenu r\xE9alis\xE9",
    total_expenses: "D\xE9penses totales"
  },
  unit: {
    chf: "CHF"
  },
  legend: {
    group: {
      income_statement: "Compte de r\xE9sultats",
      distribution_of_realised_income: "Distribution des revenus r\xE9alis\xE9s"
    }
  }
};
var balance_sheet = {
  label: {
    r_total_cash: "Tr\xE9sorerie totale",
    r_other_assets: "Autres actifs",
    r_short_term_liabilities: "Passifs \xE0 court terme",
    r_other_long_term_liabilities: "Autres passifs \xE0 long terme",
    r_total_liabilities: "Total des passifs",
    date: "Date",
    r_short_term_interest_bearing_mortgages: "Pr\xEAts hypoth\xE9caires \xE0 int\xE9r\xEAt \xE0 court terme",
    r_total_net_assets: "Actifs nets totaux",
    r_long_term_liabilities: "Passifs \xE0 long terme",
    r_total_properties: "Total des propri\xE9t\xE9s",
    total_asset: "Actif total",
    r_tga_before_distribution: "Total des actifs",
    asset_total: "Total des actifs",
    r_net_assets_before_estimated_liquidation_taxes: "Actifs nets avant imp\xF4ts de liquidation estim\xE9s",
    other_liabilities: "Autres passifs",
    r_tna_before_distribution: "TNA avant distribution",
    r_estimated_liquidation_taxes: "Taxes de liquidation estim\xE9es",
    r_other_short_term_liabilities: "Autres passifs \xE0 court terme",
    total_liabilities: "Total des passifs",
    r_long_term_interest_bearing_mortgages: "Hypoth\xE8ques \xE0 int\xE9r\xEAt \xE0 long terme"
  },
  legend: {
    group: {
      asset: "Actif",
      liabilities: "Passifs",
      equity: "Capitaux propres"
    }
  },
  unit: {
    chf: "CHF"
  }
};
var portfolios = {
  designation: {
    fund_age: "\xC2ge du portefeuille immobilier",
    residential_area: "Surface r\xE9sidentielle totale",
    total_area: "Surface totale",
    created_at: "Date de cr\xE9ation",
    buildings_nb: "Nombre de b\xE2timents",
    individual_dwellings_nb: "Nombre de logements inclus sans leur b\xE2timent complet",
    type: "Composition des actifs du portefeuille",
    industrial_area: "Surface industrielle totale",
    office_area: "Surface totale de bureau",
    dwellings_nb: "Nombre de logements",
    updated_at: "Derni\xE8re mise \xE0 jour",
    name: "Nom de l'instrument",
    commercial_area: "Surface commerciale totale"
  },
  notification: {
    success_create: {
      message: "Le portefeuille a \xE9t\xE9 cr\xE9\xE9 avec succ\xE8s",
      title: "Cr\xE9\xE9 avec succ\xE8s"
    }
  },
  environmental: {
    solar_potential: "Potentiel solaire total",
    solar_existing_per_m2: "Puissance solaire install\xE9e par m\xB2",
    debris_flow: "Flux de d\xE9bris",
    solar_existing: "Puissance solaire install\xE9e",
    floods_50_years: "Inondations",
    evolution: {
      chart: {
        title: "Graphique"
      }
    },
    avalanches: "Avalanches",
    rockfalls: "Chutes de pierres",
    estimated_co2_emission_per_m2: "CO\u2082 par m\xB2",
    landslides: "Glissements de terrain",
    building_with_solar_existing: "B\xE2timents \xE9quip\xE9s de panneaux solaires",
    overbank_sedimentation: "S\xE9dimentation en zone de d\xE9bordement",
    hail_hazard_10_years_average: "Taille de la gr\xEAle",
    total_estimated_co2_emission: "Total CO\u2082",
    estimated_idc_per_m2: "Intensit\xE9 \xE9nerg\xE9tique par m\xB2",
    total_estimated_idc: "Intensit\xE9 \xE9nerg\xE9tique totale"
  },
  description: {
    distribution: {
      label_string: "Canton",
      value_string: "Surface"
    }
  },
  tiles: {
    energy_source: {
      title: "Source d'\xE9nergie"
    },
    risks: {
      title: "Risques environnementaux"
    },
    designation: {
      title: "D\xE9signation"
    },
    solar: {
      title: "Solaire"
    },
    distribution: {
      title: "Distribution"
    },
    risk_index: {
      title: "Indice de risque climatique"
    },
    idc_and_co2: {
      title: "Intensit\xE9 \xE9nerg\xE9tique & CO\u2082"
    },
    composition: {
      title: "Composition"
    }
  },
  environment: {
    energy_distribution: {
      label_string: "Chauffage",
      value_string: "Surface chauff\xE9e"
    }
  },
  financials: {
    evolution: {
      title: "\xC9volution",
      chart: {
        title: "Graphique"
      }
    },
    performance: {
      title: "Performance",
      evolution: {
        title: "\xC9volution"
      }
    }
  },
  noright: {
    details: "Le module de portefeuille vous permet d'avoir une vision globale sur un portefeuille immobilier, des donn\xE9es financi\xE8res aux donn\xE9es ESG.",
    title: "Portefeuilles",
    button: "Contactez le responsable de compte",
    subtitle: "Cette fonctionnalit\xE9 n\xE9cessite un plan plus complet."
  },
  widget: {
    identification: {
      title: "Identification"
    },
    risk: {
      title: "Risque"
    },
    energy: {
      title: "\xC9nergie"
    }
  },
  overview: {
    type: {
      dwelling: "Logement",
      mixed: "Mixte",
      empty: "Vide",
      building: "b\xE2timent"
    },
    potential_market_value: "Valeur de march\xE9",
    potential_roa: "ROA (Rendement des actifs)",
    potential_charges: "Charges",
    potential_net_rent: "Revenu locatif"
  },
  modal: {
    confirm_delete: {
      title: "Supprimer le portefeuille",
      text: "\xCAtes-vous s\xFBr de vouloir supprimer ce portefeuille?",
      cancel: "Retour",
      proceed: "Proc\xE9der",
      notification: {
        text: "Le portefeuille a \xE9t\xE9 supprim\xE9"
      }
    }
  },
  create_modal: {
    title: "Nouveau portefeuille"
  }
};
var asset = {
  description: {
    amenities: {
      buildings: {
        imputed_cachet: "Cachet",
        fallout_shelter: "Abri antiatomique",
        imputed_elevator: "Ascenseur",
        imputed_near_highway: "Pr\xE8s de l'autoroute",
        imputed_near_transports: "Proche des transports",
        imputed_bike_room: "Local \xE0 v\xE9los"
      },
      dwellings: {
        imputed_mansarde: "Mansarde",
        imputed_cellar: "Cave",
        imputed_balcony: "Balcon",
        imputed_attique: "Attique"
      }
    },
    buildings: {
      industrial_area: "Surface industrielle",
      construction_date: "Ann\xE9e de construction",
      category: "Cat\xE9gorie",
      city: "Ville",
      class: "Classe",
      official_nb: "Num\xE9ro officiel",
      total_area: "Surface totale",
      egid: "EGID",
      type: "Type",
      commercial_area: "Surface commerciale",
      dwellings_nb: "Nombre de logements",
      area: "Surface de terrain",
      status: "Statut",
      land_use: "Utilisation du terrain",
      floors_nb: "Nombre d'\xE9tages",
      office_area: "Surface de bureaux",
      volume: "Volume total",
      residential_area: "Surface r\xE9sidentielle"
    },
    lots: {
      municipality: "Municipalit\xE9",
      sector: "Secteur",
      surface: "Surface",
      type: "Type",
      land_use: "Utilisation du terrain",
      built_up_area: "Surface construite",
      number: "Num\xE9ro",
      built_up_ratio: "Ratio de construction",
      city: "Ville",
      label: "\xC9tiquette",
      egrid: "EGRID"
    },
    dwellings: {
      floor: "\xC9tage",
      rooms_nb: "Nombre de chambres",
      city: "Ville",
      category: "Cat\xE9gorie",
      land_use: "Utilisation du terrain",
      construction_date: "Ann\xE9e de construction",
      status: "Statut",
      ewid: "Ewid",
      egid: "EGID",
      class: "Classe",
      surface: "Surface",
      type: "Type"
    }
  },
  get_building_from_group: {
    empty: {
      message: "Il n'y a aucun b\xE2timent dans ce groupe.",
      title: "Aucun b\xE2timent dans ce groupe"
    }
  }
};
var policy = {
  eea_rights_list: {
    objection: "Droit de s'opposer au traitement de vos Donn\xE9es et de retirer votre consentement (art. 21 RGPD),",
    access: "Droit d'acc\xE8s \xE0 vos donn\xE9es (art. 15 RGPD),",
    forgotten: "Droit \xE0 l'oubli (art. 17 RGPD),",
    complaint: "Droit de d\xE9poser une plainte aupr\xE8s d'une autorit\xE9 dans votre lieu de r\xE9sidence ou de travail habituel, ou l\xE0 o\xF9 une infraction a eu lieu (art. 77 RGPD),",
    automated_decisions: "Droit de ne pas \xEAtre soumis \xE0 des d\xE9cisions individuelles automatis\xE9es (un processus que QUANTHOME n'utilise pas).",
    rectification: "Droit de rectification (art. 16 RGPD),",
    processing_restriction: "Droit de restreindre le traitement sur demande (art. 18 RGPD)"
  },
  data_list: {
    company_name: "Le nom ou la raison sociale de l'entreprise que vous repr\xE9sentez",
    first_name: "Votre pr\xE9nom",
    phone_number: "Votre num\xE9ro de t\xE9l\xE9phone",
    last_name: "Votre nom de famille",
    email_address: "Votre adresse e-mail"
  },
  data_protection: "Comment QUANTHOME prot\xE8ge vos Donn\xE9es ?",
  rights_exercise: "Pour plus de d\xE9tails ou pour exercer vos droits, contactez-nous \xE0 <2>contact@quanthome.com</2>.",
  data_correction: "Vous pouvez nous contacter pour conna\xEEtre vos Donn\xE9es personnelles trait\xE9es, v\xE9rifier leur exactitude et demander leur compl\xE9tion, mise \xE0 jour, correction ou suppression, dans la mesure permise par la loi, notamment l'art. 32 LPD.",
  cookies: {
    types_list: {
      functional: "Cookies fonctionnels : Am\xE9liorent le fonctionnement de notre site, commegarder en m\xE9moire des contenus pr\xE9c\xE9demment consult\xE9s ou des d\xE9tails d'inscription. Ces cookies permettent de personnaliser le contenu  et vous font gagner du temps en \xE9vitant de devoir vous inscrire \xE0 nouveau lors de vos prochaines visites. Nous utilisons \xE9galement des cookies pour l'analyse et la publicit\xE9.",
      essential: "Cookies essentiels : N\xE9cessaires au fonctionnement de notre site web.",
      statistical: "Cookies statistiques : Ils nous aident \xE0 comprendre comment les visiteurs interagissent avec notre site, en fournissant des informations sur les pages visit\xE9es, le temps pass\xE9 et tout probl\xE8me, tel que des messages d'erreur. Cela aide \xE0 am\xE9liorer la performance de notre Site.",
      third_party: "Cookies tiers : D\xE9finis par des tiers que nous utilisons pour divers services (par exemple, analyse du site ou publicit\xE9). QUANTHOME utilise des cookies Google Analytics, qui fournissent des informations sur les activit\xE9s des utilisateurs sans les identifier. Les cookies Google Analytics ne collectent pas de Donn\xE9es sur les visiteurs du site. Pour en savoir plus sur Google Analytics, cliquez <2>https://support.google.com/analytics/answer/6004245?hl=fr</11>."
    },
    consent: "Nous demandons votre consentement expr\xE8s pour l'utilisation de cookies lors de l'acc\xE8s au Site. En acceptant cette Politique, vous pouvez refuser les cookies. Vous pouvez g\xE9rer les cookies \xE0 tout moment via les param\xE8tres de votre navigateur ou de votre appareil \xE9lectronique. Cependant, veuillez noter que certains cookies sont essentiels au fonctionnement du Site, et son utilisation pourrait \xEAtre alt\xE9r\xE9e si les cookies sont refus\xE9s ou bloqu\xE9s.",
    what_are_cookies: "Que sont les cookies?",
    purpose: "Nous utilisons des cookies pour am\xE9liorer l'utilisabilit\xE9 et la fonctionnalit\xE9 de notre site et pour personnaliser ou am\xE9liorer votre exp\xE9rience de navigation, rendant votre prochaine visite plus agr\xE9able.",
    more_information: "Pour plus d'informations, visitez <2>https://gdpr.eu/cookies/</2>. Consultez \xE9galement la section d'aide de votre navigateur ou de votre appareil \xE9lectronique pour des instructions sp\xE9cifiques sur la gestion des cookies.",
    types: "Quels types de cookies sont utilis\xE9s ?",
    usage: "Pourquoi et comment utilisons-nous des cookies?",
    types_overview: "Les cookies que nous utilisons incluent :",
    definition: "Les cookies sont de petits fichiers texte plac\xE9s sur votre ordinateur par les sites web que vous visitez. Ils sont largement utilis\xE9s pour garantir le bon fonctionnement des sites ou pour am\xE9liorer leur efficacit\xE9, et pour fournir des informations aux propri\xE9taires de sites. Les cookies peuvent traiter automatiquement des Donn\xE9es sur votre appareil et/ou transf\xE9rer des Donn\xE9es vous concernant au propri\xE9taire du site ou \xE0 des tiers. Vous pouvez g\xE9rer les cookies du site."
  },
  retention_request: "Vous pouvez demander \xE0 QUANTHOME de conserver vos Donn\xE9es pour une \xE9ventuelle inscription future ou pour continuer \xE0 recevoir notre newsletter.",
  consent: "Si les raisons ci-dessus ne sont pas consid\xE9r\xE9es comme l\xE9gitimes, vous consentez au traitement des Donn\xE9es aux fins mentionn\xE9es en acceptant cette Politique.",
  personal_data_definition: "Les donn\xE9es personnelles ('Donn\xE9es') d\xE9signent toute information relative \xE0 un individu. Ces donn\xE9es peuvent soit vous identifier directement (par exemple, votre nom, votre adresse e-mail ou votre num\xE9ro de s\xE9curit\xE9 sociale), soit le faire indirectement en combinant diverses informations vous concernant (par exemple, l'adresse IP de votre ordinateur, votre carte de cr\xE9dit ou votre num\xE9ro de t\xE9l\xE9phone).",
  access_right: "Sauf disposition contraire de la loi applicable, vous avez le droit de savoir si nous traitons des donn\xE9es vous concernant \xE0 tout moment et d'exercer votre droit d'acc\xE8s conform\xE9ment \xE0 l'article 25 de la LPD.",
  data_usage: {
    contact_information: "Votre adresse, email et num\xE9ro de t\xE9l\xE9phone nous permettent de vous contacter. Ces informations sont requises pour les ventes de produits. Lorsqu'elles sont utilis\xE9es pour des newsletters ou des communications promotionnelles, cela se fait sur la base de votre consentement.",
    cookies_analytics: "Les donn\xE9es transmises par les cookies du site sont destin\xE9es \xE0 des analyses internes et \xE0 la publicit\xE9. Cela repose sur notre int\xE9r\xEAt l\xE9gitime et votre consentement lorsque la loi l'exige.",
    payment_verification: "Vos coordonn\xE9es bancaires valident votre paiement pour les produits. Cela est contractuellement requis.",
    account_creation: "Votre pr\xE9nom, nom de famille et, le cas \xE9ch\xE9ant, le nom de votre entreprise, pour cr\xE9er votre compte et vous permettre d'acc\xE9der au site et de commander des produits. Cela est requis contractuellement.",
    legal_compliance: "Toutes les Donn\xE9es transmises peuvent \xEAtre trait\xE9es pour se conformer aux obligations l\xE9gales et \xE0 d'autres imp\xE9ratifs juridiques",
    legal_age_verification: "Votre date de naissance garantit que vous \xEAtes majeur pour conclure des contrats avec nous. Cela repose sur notre int\xE9r\xEAt l\xE9gitime."
  },
  eea_representative: "Notre repr\xE9sentant dans l'EEE est [\xE0 compl\xE9ter]. Les directives suivantes s'appliquent \xE0 toutes les donn\xE9es que vous fournissez \xE0 QUANTHOME.",
  processing_methods: "Nous pouvons traiter vos Donn\xE9es soit automatiquement, soit manuellement, en mettant toujours en \u0153uvre des mesures de s\xE9curit\xE9 appropri\xE9es.",
  why_collect_data: "Pourquoi QUANTHOME collecte-t-il ces Donn\xE9es?",
  your_rights: "Quels droits avez-vous concernant vos Donn\xE9es ?",
  law_compliance: "Nous traitons vos Donn\xE9es conform\xE9ment aux lois applicables, notamment les lois suisses et europ\xE9ennes sur la protection des donn\xE9es, en adoptant des mesures pour pr\xE9venir tout acc\xE8s, divulgation, alt\xE9ration ou destruction non autoris\xE9s.",
  data_handling: "Comment QUANTHOME g\xE8re vos Donn\xE9es ?",
  retention_period: "QUANTHOME conserve vos donn\xE9es uniquement aussi longtemps que n\xE9cessaire, g\xE9n\xE9ralement 3 ans apr\xE8s votre dernier contact avec QUANTHOME. En raison de nos obligations l\xE9gales, certaines donn\xE9es, en particulier celles li\xE9es \xE0 notre relation contractuelle, doivent \xEAtre conserv\xE9es pendant au moins 10 ans.",
  data_hosting: "O\xF9 sont h\xE9berg\xE9es vos Donn\xE9es ?",
  terms_invitation: "Nous vous invitons \xE9galement \xE0 consulter nos Conditions d'utilisation et notre contrat de licence utilisateur final",
  credential_safety: "Pour prot\xE9ger la confidentialit\xE9 de vos donn\xE9es, vous devez garder vos identifiants en s\xE9curit\xE9 et ne pas les divulguer \xE0 quiconque. Vous \xEAtes responsable de toute utilisation des services offerts sur le Site utilisant vos identifiants.",
  data_sharing: "Avec qui QUANTHOME pourrait-il partager vos Donn\xE9es ?",
  consent_withdrawal: "Si nous nous appuyons sur votre consentement pour traiter vos Donn\xE9es, nous solliciterons votre consentement libre et sp\xE9cifique, en fournissant des instructions claires. Vous pouvez r\xE9voquer votre consentement \xE0 tout moment. Vous avez \xE9galement le droit de demander la portabilit\xE9 de vos Donn\xE9es trait\xE9es automatiquement sur la base de votre consentement ou de la n\xE9cessit\xE9 contractuelle.",
  cookies_section: "Cookies",
  non_identifying_data_use: "D'autres donn\xE9es non identifiantes, y compris des donn\xE9es agr\xE9g\xE9es ou anonymis\xE9es, peuvent \xEAtre utilis\xE9es pour g\xE9rer les services, am\xE9liorer les relations avec les clients, diagnostiquer des probl\xE8mes techniques et recueillir des informations d\xE9mographiques agr\xE9g\xE9es.",
  data_provided: "Donn\xE9es que QUANTHOME collecte automatiquement lorsque vous acc\xE9dez au Site ou que vous fournissez volontairement lors de la cr\xE9ation d'un compte ou ult\xE9rieurement, lors des commandes (les champs marqu\xE9s d'un ast\xE9risque sont obligatoires, et des champs suppl\xE9mentaires peuvent \xEAtre fournis de mani\xE8re optionnelle) :",
  introduction: "Votre vie priv\xE9e est importante pour nous. En tant que responsable du traitement des donn\xE9es, Quanthome SA s'engage \xE0 traiter les donn\xE9es personnelles que vous partagez avec nous de mani\xE8re transparente et conform\xE9ment \xE0 la l\xE9gislation en vigueur.",
  rights_overview: "Vous avez le droit de conna\xEEtre et de demander la suppression, la correction ou la mise \xE0 jour des Donn\xE9es que nous traitons \xE0 votre sujet.",
  legal_updates: "Mise \xE0 jour des informations juridiques.",
  third_party_security: "Nous nous effor\xE7ons \xE9galement de garantir que tout tiers avec lequel vos donn\xE9es pourraient \xEAtre partag\xE9es (comme d\xE9crit ci-dessus) les traite de mani\xE8re s\xE9curis\xE9e, en pr\xE9servant leur confidentialit\xE9 et leur int\xE9grit\xE9.",
  sharing_list: {
    corporate_events: "Dans le cadre de fusions, d'acquisitions, d'\xE9v\xE9nements de restructuration ou de proc\xE9dures de faillite possibles, vos donn\xE9es pourraient \xEAtre transf\xE9r\xE9es \xE0 des tiers en tant qu'actif de QUANTHOME. Nous nous efforcerons de vous informer de tels transferts \xE0 l'avance, mais nous ne pouvons pas garantir une option de d\xE9sinscription",
    service_execution: "Avec tout tiers n\xE9cessaire \xE0 l'ex\xE9cution du service (par exemple, employ\xE9s, entreprises affili\xE9es, fournisseurs de paiement, entreprises logistiques, notre fournisseur d'h\xE9bergement et personnel informatique).",
    legal_requirements: "Avec tout tiers l\xE9galement requis en raison d'une directive des autorit\xE9s judiciaires ou gouvernementales ou en conformit\xE9 avec nos obligations l\xE9gales."
  },
  legal_processing_objection: "Vous avez \xE9galement le droit de demander que nous arr\xEAtions tout traitement sp\xE9cifique des Donn\xE9es obtenues ou trait\xE9es en violation de la loi et de vous opposer \xE0 tout traitement des Donn\xE9es pour des raisons l\xE9gitimes.",
  security_measures: "QUANTHOME s'efforce d'assurer la s\xE9curit\xE9 de vos Donn\xE9es, en pr\xE9venant tout acc\xE8s, utilisation, modification ou divulgation non autoris\xE9s.",
  company_info: "Quanthome SA, ci-apr\xE8s d\xE9nomm\xE9e 'QUANTHOME', 'nous' ou 'notre', est une soci\xE9t\xE9 anonyme inscrite au registre du commerce du Canton de Vaud, situ\xE9e \xE0 l'Avenue de Mon-Repos 24, 1005 Lausanne, Suisse.",
  agreement: "En acc\xE9dant au site <1>www.quanthome.com</1> (\xAB Site \xBB), que nous exploitons, vous consentez express\xE9ment \xE0 notre traitement de vos donn\xE9es conform\xE9ment \xE0 cette Politique.",
  eea_rights: "Si vous \xEAtes r\xE9sident de l'EEE, vous disposez sp\xE9cifiquement des droits suivants :",
  what_is_personal_data: "Que sont les Donn\xE9es personnelles ?",
  data_retention: "Combien de temps QUANTHOME conserve-t-il vos Donn\xE9es ?",
  hosting_details: "Les Donn\xE9es collect\xE9es par QUANTHOME sont h\xE9berg\xE9es en Suisse et trait\xE9es par Infomaniak",
  updates: "Nous nous r\xE9servons le droit d'apporter des modifications et des corrections \xE0 ces dispositions. Veuillez consulter r\xE9guli\xE8rement cette page pour des mises \xE0 jour et de nouvelles informations.",
  title: "Politique de confidentialit\xE9",
  type_of_data: "Quel type de Donn\xE9es fournissez-vous \xE0 QUANTHOME ?",
  data_processing_basis: "Nous traitons vos donn\xE9es sur la base de raisons l\xE9gitimes sp\xE9cifi\xE9es ci-dessous, ou sur la base de votre consentement :",
  policy_date: "Cette politique de confidentialit\xE9 (la 'Politique') est dat\xE9e du 30 septembre 2023. Elle peut \xEAtre r\xE9vis\xE9e r\xE9guli\xE8rement (voir l'article 11).",
  data_deletion_request: "Si vous souhaitez que nous supprimions vos Donn\xE9es de nos syst\xE8mes, envoyez une demande au contact ci-dessous, que nous respecterons \xE0 moins que nous ayons besoin de conserver vos Donn\xE9es pour des raisons l\xE9gales ou un autre but l\xE9gitime.",
  sharing_overview: "QUANTHOME peut partager vos Donn\xE9es comme suit :",
  security_breach_protocol: "Veuillez nous informer imm\xE9diatement de tout soup\xE7on ou de toute confirmation d'utilisation abusive de vos identifiants. N'oubliez pas, aucune mesure de s\xE9curit\xE9 n'est infaillible.",
  anonymization_alternative: "Au lieu de d\xE9truire ou de supprimer vos Donn\xE9es, QUANTHOME pourrait les anonymiser de mani\xE8re permanente, rendant l'identification impossible.",
  additional_information: "Toute information personnelle que vous partagez spontan\xE9ment avec nous dans des \xE9changes par e-mail ; Toute autre Donn\xE9e collect\xE9e par des cookies et le serveur web. Plus de d\xE9tails sur les Donn\xE9es collect\xE9es automatiquement peuvent \xEAtre trouv\xE9s dans l'article 10 de la Politique",
  international_transfers: "Dans certaines circonstances, notamment pour des raisons techniques, vos Donn\xE9es pourraient \xEAtre transf\xE9r\xE9es en dehors de la Suisse ou de l'Union europ\xE9enne. Dans de tels cas, les tiers garantiront des mesures ad\xE9quates assurant que les exigences l\xE9gales et la protection de vos droits sont respect\xE9es.",
  transfer_consent: "En acc\xE9dant au Site et en partageant des Donn\xE9es, vous consentez express\xE9ment \xE0 de tels transferts.",
  anonymization_use: "Nous pourrions traiter vos Donn\xE9es pour supprimer les informations identifiables (anonymisation), puis utiliser ces donn\xE9es anonymes \xE0 des fins non d\xE9crites dans la Politique (par exemple, analyse comparative, ciblage de campagne ou d\xE9veloppement et commercialisation de nouveaux services)",
  data_provision_consequences: "Vous n'avez aucune obligation l\xE9gale ou contractuelle de nous fournir des Donn\xE9es. Cependant, le refus de fournir certaines Donn\xE9es ou l'exercice des droits mentionn\xE9s dans l'article 9 pourrait nous emp\xEAcher de vous fournir nos produits, y compris l'acc\xE8s au site.",
  inquiries: "Pour toute demande concernant cette Politique ou l'utilisation de vos donn\xE9es, veuillez nous contacter \xE0 <2>contact@quanthome.com</2> ou appeler le +41 21 312 16 93."
};
var boarding_page = {
  login: {
    abort: "Annuler",
    aal2: {
      forgot_button: "Utilisez des codes de r\xE9cup\xE9ration",
      subtitle: "Veuillez compl\xE9ter la deuxi\xE8me \xE9tape d'authentification.",
      submit_button: "Soumettre",
      title: "Entrez le OTP (mot de passe \xE0 usage unique)"
    },
    aal1: {
      submit_button: "Connexion",
      forgot_button: "Mot de passe oubli\xE9/r\xE9initialiser ?",
      title: "Connectez-vous \xE0 votre compte",
      subtitle: "Bienvenue!"
    },
    missing_otp: {
      title: "Configuration de OTP invalide",
      description: "Le mot de passe \xE0 usage unique (OTP) pour ce compte n'est pas configur\xE9 ou est incorrect. Si le probl\xE8me persiste, veuillez contacter votre administrateur pour r\xE9soudre le probl\xE8me."
    },
    failed: {
      title: "Erreur lors de la connexion"
    }
  },
  show_recovery: {
    button: {
      download: "T\xE9l\xE9charger",
      regenerate_code: "G\xE9n\xE9rer de nouveaux codes de r\xE9cup\xE9ration",
      copied: "Copi\xE9",
      proceed: "Proc\xE9der",
      copy: "Copie",
      print: "Imprimer"
    },
    warning: "Conservez votre code de r\xE9cup\xE9ration dans un endroit s\xFBr. Ces codes sont le dernier recours pour acc\xE9der \xE0 votre compte en cas de perte de votre second facteur. Si vous ne parvenez pas \xE0 retrouver ce code, <0>vous perdrez</0> l'acc\xE8s \xE0 votre compte.",
    explain: {
      regenerate_code: "Lorsque vous g\xE9n\xE9rez de nouveaux codes de r\xE9cup\xE9ration, vous devez t\xE9l\xE9charger ou imprimer les nouveaux codes. Vos anciens codes ne fonctionneront plus."
    },
    label: {
      regenerate_code: "G\xE9n\xE9rer de nouveaux codes de r\xE9cup\xE9ration"
    },
    title: "Code de r\xE9cup\xE9ration",
    subtitle: "Ne perdez jamais votre code de r\xE9cup\xE9ration."
  },
  otp: {
    subtitle: "Authentificateur \xE0 double facteur pour prot\xE9ger au mieux les donn\xE9es.",
    step: {
      type_code: "Lorsque le OTP est pr\xEAt, v\xE9rifiez en saisissant votre TOTP",
      scan_qr: "Scannez ce code QR pour configurer votre appareil de confiance via votre application OTP.",
      trusted_device: "Ouvrez votre application OTP pr\xE9f\xE9r\xE9e sur votre appareil de confiance"
    },
    button: {
      abort: "Je le ferai plus tard",
      verify: "V\xE9rifier mon appareil avec TOPT"
    },
    legend: "(T)OTP* : Mot de passe \xE0 usage unique (bas\xE9 sur le temps)",
    failed: {
      title: "Erreur lors de la configuration de l'appareil OTP"
    },
    title: "Configurer votre OTP (mot de passe \xE0 usage unique)"
  },
  verify_mail: {
    step: {
      choose_method: {
        description: "Tapez votre adresse e-mail pour la v\xE9rifier",
        success: {
          message: "Un e-mail pour finaliser votre v\xE9rification vous a \xE9t\xE9 envoy\xE9.",
          title: "Code envoy\xE9"
        },
        subtitle: "V\xE9rifiez votre adresse email",
        button: "Envoyer le code"
      },
      sent_email: {
        subtitle: "V\xE9rifiez votre adresse email",
        button: "V\xE9rifiez le code",
        description: "\xC9crivez le code que vous venez de recevoir par e-mail",
        success: {
          message: "Votre e-mail est maintenant v\xE9rifi\xE9",
          title: "V\xE9rification termin\xE9e"
        }
      }
    },
    abort: "Je le ferai plus tard",
    title: "Terminez votre configuration"
  },
  forgot_password: {
    last_step: "Vous pouvez maintenant changer votre mot de passe:",
    button: {
      send: "Envoyer mon code",
      cancel: "Annuler la r\xE9cup\xE9ration",
      save: "Enregistrer mon mot de passe",
      verify: "V\xE9rifiez mon code"
    },
    subtitle: "Pas de panique, tout va bien se passer",
    success: {
      title: "Mot de passe chang\xE9 avec succ\xE8s",
      message: "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe."
    },
    title: "Mot de passe oubli\xE9",
    check_code_from_email: "Un code de r\xE9cup\xE9ration a \xE9t\xE9 envoy\xE9 \xE0 votre email..."
  },
  recovery_code: {
    form: {
      button: "V\xE9rifier"
    },
    title: "R\xE9cup\xE9ration \xE0 deux facteurs",
    abort_button: "Annuler",
    faq: {
      what_is_recovery: {
        question: "Qu'est-ce qu'un code de r\xE9cup\xE9ration ?",
        answer: "Le code de r\xE9cup\xE9ration est le code que vous avez re\xE7u lorsque vous avez li\xE9 votre appareil pour la premi\xE8re fois. Vous devriez l'avoir conserv\xE9 en lieu s\xFBr."
      },
      lock: {
        question: "Vous n'arrivez pas \xE0 acc\xE9der \xE0 votre compte?",
        answer: "Veuillez contacter votre administrateur pour la r\xE9cup\xE9ration du compte."
      },
      description: "Si vous n'\xEAtes pas en mesure d'acc\xE9der \xE0 votre appareil mobile, saisissez votre code de r\xE9cup\xE9ration pour v\xE9rifier votre identit\xE9."
    },
    reset: {
      success: {
        message: "Vous pouvez d\xE9sormais lier un nouvel appareil.",
        title: "Le code de r\xE9cup\xE9ration est correct"
      }
    },
    missing: {
      description: "Le code de r\xE9cup\xE9ration pour ce compte n'est pas d\xE9fini ou a expir\xE9. Veuillez contacter le support de Quanthome pour r\xE9soudre le probl\xE8me.",
      title: "Code de r\xE9cup\xE9ration invalide"
    }
  },
  register: {
    notification: {
      changed_email: {
        message: "Vos informations ont \xE9t\xE9 mises \xE0 jour avec succ\xE8s - Vous devriez avoir re\xE7u un nouvel e-mail pour v\xE9rifier votre nouvelle adresse e-mail.",
        title: "Adresse e-mail modifi\xE9e"
      },
      privileged_session_reached: {
        message: "Pour des raisons de s\xE9curit\xE9, le processus d'inscription doit \xEAtre compl\xE9t\xE9 dans les 30 minutes. Veuillez demander un autre lien d'invitation pour recommencer l'inscription.",
        title: "Session privil\xE9gi\xE9e expir\xE9e (time out)"
      },
      flow_expiration: {
        message: "Le flux a expir\xE9 - Contactez votre administrateur.",
        title: "Expir\xE9"
      }
    },
    button: "Enregistrer",
    title: "Bienvenue sur Quanthome_",
    repeat_password: "R\xE9p\xE9ter le mot de passe",
    error: {
      repeat_password: "Les mots de passe doivent \xEAtre identiques"
    },
    subtitle: "Configurez votre compte :"
  },
  totp_setup: {
    notification: {
      privileged_session_reached: {
        message: "Session privil\xE9gi\xE9 expir\xE9. Veuillez vous reconnecter."
      }
    }
  }
};
var global = {
  chart: {
    legend: {
      gav: "GAV",
      r_debt_ratio: "Ratio d'endettement",
      r_rental_losses: "Pertes sur loyer",
      total_idc: "\xC9nergie totale",
      market_market_cap: "Capitalisation",
      transport_tram: "Arr\xEAt de tram",
      realised_gains_losses: "Gains/pertes r\xE9alis\xE9s",
      long_term_interest_bearing_mortgages: "Hypoth\xE8ques \xE0 int\xE9r\xEAt \xE0 long terme",
      estimated_co_2_scope_1_2_33: "Total des \xE9missions de CO\u2082 scope 1 + 2 + 3.3",
      market_share_price: "Prix de l'action",
      r_market_value: "Valeur de march\xE9 des b\xE2timents",
      estimated_total_market_value: "Valeur de march\xE9 totale",
      offices: "Bureaux",
      revenues: "Revenus",
      total_net_asset: "Actif net total",
      restaurants: "Restaurants",
      idc_per_m_2: "Intensit\xE9 \xE9nerg\xE9tique",
      r_nav_before_distribution: "VNI avant distribution",
      shops: "Boutiques",
      r_market_cap: "Capitalisation",
      co_2_scope_1_2_33_per_m_2: "CO\u2082 scope 1 + 2 + 3.3",
      r_cost_price: "Prix de revient des b\xE2timents",
      roa: "ROA (Rendement des actifs)",
      other: "Autre",
      estimated_total_net_rent: "Loyer net total",
      reported_total_target_rent: "Loyer cible total",
      co_2_listed: "CO\u2082",
      region_lemanique: "R\xE9gion l\xE9manique",
      total_income: "Revenu total",
      reported_ebit_margin: "Marge op\xE9rationnelle (marge EBIT)",
      short_term_liabilities: "Passifs \xE0 court terme",
      total_properties: "Total des propri\xE9t\xE9s",
      nordwestschweiz: "Nord-Ouest de la Suisse",
      commercial: "Commercial",
      mixed: "Mixte",
      estimated_co_2_scope_1_2_33_per_m_2: "CO\u2082 scope 1 + 2 + 3.3",
      secondary_education: "Enseignement secondaire",
      co_2_scope_2_per_m_2: "CO\u2082 scope 2",
      cultural_venues: "\xC9tablissements culturels",
      r_ebit_margin: "Marge op\xE9rationnelle (marge EBIT)",
      r_total_target_rent: "Loyer cible total",
      public_open_space: "Espace de d\xE9tente public",
      purchased: "B\xE2timents achet\xE9s",
      c_market_value: "Valeur de march\xE9 des b\xE2timents",
      total_co_2_scope_1_2_33: "Total des \xE9missions de CO\u2082 scope 1 + 2 + 3.3",
      reported_rental_losses: "Pertes sur loyer",
      r_total_real_rent: "Loyer r\xE9el total",
      none: "Pas de chauffage",
      nav: "VNI",
      asset: "Actif",
      r_total_cost_price: "Prix de revient total",
      very_low: "Tr\xE8s bas",
      primary_education: "Enseignement primaire",
      medium: "Moyen",
      net_income: "Revenu net",
      r_target_rent: "Revenu locatif cible",
      r_tga_before_distribution: "TGA avant distribution",
      equity: "Capitaux propres",
      r_real_rent: "Loyer r\xE9el",
      legend: "L\xE9gende",
      liabilities: "Passifs",
      r_payout_ratio: "Taux de distribution",
      co_2_scope_1_per_m_2: "CO\u2082 scope 1",
      reported_dividend_yield: "Rendement de dividende",
      rent_listed: "Revenu locatif",
      date: "Date",
      transport_bike: "Stationnement pour v\xE9los",
      r_total_market_value: "Valeur de march\xE9 totale",
      reported_total_cost_price: "Prix de revient total",
      c_net_rent: "Revenu locatif",
      amount: "Montant",
      benchmark_fund: "Fonds de r\xE9f\xE9rence",
      tessin: "Tessin",
      realised_income: "Revenu r\xE9alis\xE9",
      reported_total_market_value: "Valeur de march\xE9 totale",
      rent_expected: "Revenu locatif (pr\xE9vu)",
      intermediate: "Interm\xE9diaire",
      sold: "B\xE2timents vendus",
      ordinary_income_carried_forward: "Revenu ordinaire report\xE9",
      default: "Montant",
      estimated_total_energy: "\xC9nergie totale",
      ostschweiz: "Suisse orientale",
      very_high: "Tr\xE8s haut",
      total_co_2_scope_33: "Total des \xE9missions de CO\u2082 scope 3.3",
      total_co_2_scope_1_2: "Total CO\u2082 scope 1 + 2",
      reported_roe: "ROE (Rentabilit\xE9 des Capitaux Propres)",
      r_dividend_yield: "Rendement de dividende",
      estimated_energy_intensity: "Intensit\xE9 \xE9nerg\xE9tique",
      short_term_interest_bearing_mortgages: "Pr\xEAts hypoth\xE9caires \xE0 int\xE9r\xEAt \xE0 court terme",
      other_long_term_liabilities: "Autres passifs \xE0 long terme",
      sports_recreation: "Sport et loisirs",
      current_building: "B\xE2timent actuel",
      r_roe: "ROE (Rentabilit\xE9 des Capitaux Propres)",
      transport_bus: "Arr\xEAt de bus",
      plots: "Parcelles",
      reported_tga_before_distribution: "TGA avant distribution",
      high: "Haut",
      m_market_cap: "Capitalisation",
      early_years: "Premi\xE8res ann\xE9es",
      estimated_co_2_scope_1_2: "Total CO\u2082 scope 1 + 2",
      reported_total_real_rent: "Loyer r\xE9el total",
      current_fund: "Fonds actuel",
      reported_payout_ratio: "Taux de distribution",
      zentralschweiz: "Suisse centrale",
      healthcare: "Sant\xE9",
      total_co_2_scope_1: "Total CO\u2082 scope 1",
      non_fossil: "Non fossile",
      other_short_term_liabilities: "Autres passifs \xE0 court terme",
      total_co_2_scope_2: "Total des \xE9missions de CO\u2082 scope 2",
      reported_tna_before_distribution: "TNA avant distribution",
      residential: "R\xE9sidentiel",
      fossil: "Fossile",
      reported_nav_before_distribution: "VNI avant distribution",
      r_tna_before_distribution: "TNA avant distribution",
      expenses: "D\xE9penses",
      zurich: "Z\xFCrich",
      co_2_expected: "CO\u2082 (pr\xE9vu)",
      espace_mitelland: "Espace Mittelland",
      co_2_scope_1_2_per_m_2: "CO\u2082 scope 1 + 2",
      m_share_price: "Prix de l'action",
      other_asset: "Autre actif",
      low: "Bas",
      long_term_liabilities: "Passifs \xE0 long terme",
      co_2_scope_33_per_m_2: "CO\u2082 scope 3.3",
      reported_debt_ratio: "Ratio d'endettement",
      cash_holding_and_balances_at_sight: "Liquidit\xE9s et soldes \xE0 vue",
      surface: "Surface",
      r_share_price: "Prix de l'action",
      sustainability: "Durabilit\xE9",
      woman: "Femme",
      unrealised_gains_losses_including_liquidation_taxes_variation: "Gains/pertes non r\xE9alis\xE9s incluant la variation des taxes de liquidation",
      man: "Homme",
      net_income_available_for_distribution: "Revenu net disponible pour distribution",
      estimated_co_2_scope_1_2_per_m_2: "CO\u2082 scope 1 + 2",
      aged_care: "Soins aux personnes \xE2g\xE9es",
      unchanged: "B\xE2timents inchang\xE9s",
      foundation: "Fondation",
      unlisted_fund: "Fonds non c\xF4t\xE9",
      real_estate_firm: "Soci\xE9t\xE9 immobili\xE8re",
      listed_fund: "Fonds c\xF4t\xE9"
    },
    tooltip: {
      potential: "Attendu",
      real: "Cot\xE9"
    },
    export: {
      png: "png",
      excel: "xlsx",
      csv: "csv"
    },
    export_as: "T\xE9l\xE9charger en tant que"
  },
  assets: {
    building: "b\xE2timent",
    lot: "parcelle",
    dwelling: "logement"
  }
};
var status = {
  completed: "Termin\xE9",
  not_complete: "Non compl\xE9t\xE9",
  resend: "Renvoyer"
};
var errors = {
  fii: {
    fii_portfolio_duplicated_dwelling_id: "Tous les logements sont d\xE9j\xE0 dans ce portefeuille.",
    fii_invalid_dwelling_id: "Aucun identifiant de logement valide.",
    fii_portfolio_duplicated_building_id: "Tous les b\xE2timents sont d\xE9j\xE0 dans ce portefeuille.",
    fii_invalid_building_id: "Aucun identifiant de b\xE2timent valide."
  }
};
var double_range_input = {
  error_msg: "La valeur minimale doit \xEAtre inf\xE9rieure \xE0 la valeur maximale.",
  year_error_msg: "Veuillez saisir une ann\xE9e valide",
  clear: "clair",
  start: "date de d\xE9but",
  min: "min",
  max: "max",
  end: "date de fin"
};
var common = {
  connection_lost: {
    message_1: "Vous n'\xEAtes peut-\xEAtre plus connect\xE9 \xE0 Internet.",
    message_2: "L'application ne peut pas fonctionner comme pr\xE9vu",
    message_3: "Veuillez recharger la page.",
    reload_button: "Recharger",
    title: "Connexion perdue"
  },
  funds: {
    pascalcase: "Fonds"
  },
  enterprise_state: {
    exempt: "Exempt",
    unpaid: "Impay\xE9",
    ended: "Termin\xE9",
    subscribed: "Abonn\xE9",
    trial_end: "Fin de l'essai",
    state: "Type de contrat",
    examination: "Examen",
    trial: "Essai"
  },
  real_estate_firm: {
    pascalcase: "Soci\xE9t\xE9 immobili\xE8re"
  },
  lots: {
    lowercase: "Parcelles",
    pascalcase: "Parcelles"
  },
  financials: {
    array: {
      industrial: "Industriel",
      total: "Total",
      commercial: "Commercial",
      office: "Bureau",
      residential: "R\xE9sidentiel"
    }
  },
  keys: "cl\xE9s",
  buildings: {
    pascalcase: "B\xE2timents",
    lowercase: "B\xE2timents"
  },
  comparables: {
    pascalcase: "Comparables"
  },
  delete_user: "Supprimer l'utilisateur",
  portfolios: {
    pascalcase: "Portefeuilles"
  },
  error: "Quelque chose s'est produit",
  developer_mode: {
    deactivated: "D\xE9sactiv\xE9",
    activated: "Activ\xE9",
    state: "Mode d\xE9veloppeur"
  },
  unlisted_fund: {
    pascalcase: "Fonds non cot\xE9"
  },
  warning: "Avertissement",
  role: {
    manager: "Gestionnaire",
    user: "Utilisateur",
    owner: "Propri\xE9taire"
  },
  assign_contact_user: "Attribuer en tant que personne de contact",
  slot: {
    institutional: "Institutionnel",
    investor: "Investisseur",
    consumer: "Consommateur"
  },
  create: "Cr\xE9er",
  removing: "suppression",
  assets: {
    pascalcase: "Actifs"
  },
  transactions: {
    pascalcase: "Transactions"
  },
  warning_msg: "L'op\xE9ration sur {{ failed }} a \xE9chou\xE9.",
  error_message: "Quelque chose s'est produit",
  key: "cl\xE9",
  cancel_button: "Annuler",
  confirm_button: "Confirmer",
  notification: {
    success: {
      title: "Succ\xE8s"
    }
  },
  dwellings: {
    pascalcase: "Logements",
    lowercase: "logements"
  },
  listed_fund: {
    pascalcase: "Fonds cot\xE9"
  },
  foundation: {
    pascalcase: "Fondation d'investissement"
  },
  edit: "Modifier",
  institutions: {
    pascalcase: "REIVs"
  },
  success: "R\xE9ussi"
};
var footer = {
  license_agreement: "Contrat de licence",
  impressum: "Impressum",
  confidential_policy: "Politique de confidentialit\xE9"
};
var source_badge = {
  reported: "Rapport\xE9",
  official: "Officiel",
  expected: "Attendu",
  forecasted: "Pr\xE9visionnel",
  listed: "Cot\xE9",
  market_data: "Donn\xE9es de march\xE9",
  computed: "Calcul\xE9",
  estimated: "Estim\xE9",
  quanthome_data: "Donn\xE9es Quanthome"
};
var dashboard = {
  indicators: {
    title: "Indicateurs",
    switzerland_vacancy_rate: "Taux de vacance suisse",
    reference_interest_rate: "Taux d'int\xE9r\xEAt de r\xE9f\xE9rence",
    ipc_lik: "IPC Indice des Prix \xE0 la Consommation (IPC/LIK)",
    snb_policy_rate: "Taux de politique de la Banque nationale suisse"
  },
  indices: {
    swiss_residential_property_price: "Indice des prix des biens r\xE9sidentiels suisses",
    title: "Indices",
    construction_price_index_building: "Indice de construction suisse - B\xE2timent",
    construction_price_index_total: "Indice de construction suisse - Total",
    construction_price_index_civil_engineering: "Indice de construction suisse - G\xE9nie civil"
  },
  empty: {
    portfolios: "Vous n'avez aucun portefeuille.",
    funds: "Vous n'avez aucun fonds."
  },
  trend: {
    title: "Tendance du march\xE9 suisse : loyer net par m\xB2"
  },
  rent: {
    title: "Loyer par m\xB2 par canton"
  },
  error: {
    feature: {
      rights: "Vous n'avez pas acc\xE8s \xE0 cette fonctionnalit\xE9"
    }
  }
};
var notification = {
  terminated_session: {
    title: "Session termin\xE9e",
    message: "Vous pourriez \xEAtre connect\xE9 sur un autre appareil ou la dur\xE9e  de la session a \xE9t\xE9 atteinte."
  }
};
var administration = {
  companies: {
    actions: {
      delete_company: "Supprimer l'entreprise",
      update_company_slots: "Mettre \xE0 jour des licences de l'entreprise",
      update_company: "Modifier les param\xE8tres de l'entreprise"
    },
    col_name: {
      contact_user: "Personne de contact",
      developer_mode: "Mode d\xE9veloppeur",
      total_consumer_seat: "Nombre total de licences utilisateur-consommateur",
      days_left: "Jours restants",
      free_investor_seat: "Licences utilisateur-investisseur restantes",
      consumer_users: "Utilisateurs-consommateurs",
      contact_user_email: "E-mail de la personne de contact",
      free_institutional_seat: "Licences utilisateur-institutionnel restantes",
      used_investor_seat: "Licences utilisateur-investisseur attribu\xE9es",
      related_am: "Responsable de compte",
      all_users: "Membres de l'\xE9quipe",
      license_use: "Utilisation des licences",
      total_all_seats: "Nombre total de licences",
      state: "Type de contrat",
      subscription_start: "Date d'abonnement",
      free_consumer_seat: "Licences utilisateur-consommateur restantes",
      used_consumer_seat: "Licences utilisateur-consommateur attribu\xE9es",
      name: "Entreprise",
      institutional_users: "Utilisateurs-institutionnels",
      used_institutional_seat: "Licences utilisateur-institutionnel attribu\xE9es",
      used_all_seats: "Nombre total de licences attribu\xE9es",
      investor_users: "Utilisateurs-investisseurs",
      contact_user_phone: "Num\xE9ro de t\xE9l\xE9phone de la personne de contact",
      total_investor_seat: "Nombre total de licences utilisateur-investisseur",
      expiration_date: "Date de fin de contrat",
      total_institutional_seat: "Nombre total de licences utilisateur-institutionnel"
    },
    headers: {
      companies_count: "{{count}} Soci\xE9t\xE9s",
      member_count: "{{ count }} membres"
    },
    cells: {
      user_count: "{{ count }} utilisateurs"
    },
    teams: "\xC9quipes",
    table_title: "Entreprises"
  },
  breadcrumb: {
    edit: "Modifier",
    create_company: "Cr\xE9er",
    details: "D\xE9tails",
    companies: "Entreprises"
  },
  collaborators: {
    headers: {
      members_count: "{{ count }} Membres"
    }
  }
};
var management = {
  nav: {
    profile: {
      title: "Profil",
      subtitle: "Mettez \xE0 jour les param\xE8tres de votre profil."
    },
    connections: {
      title: "API",
      subtitle: "Cr\xE9ez et g\xE9rez des cl\xE9s API pour acc\xE9der aux donn\xE9es de quanthome depuis un syst\xE8me d'exploitation, une application ou un autre service."
    },
    seats: {
      subtitle: "Voici tout ce que vous devez savoir sur les licences et la facturation",
      title: "Licences"
    },
    collaborators: {
      subtitle: "Voici tout ce que vous devez savoir sur les personnes qui acc\xE8dent \xE0 la plateforme dans votre entreprise.",
      title: "Collaborateurs"
    },
    organization: {
      subtitle: "Voici toutes les informations concernant la soci\xE9t\xE9 dans laquelle vous travaillez.",
      title: "Organisation"
    },
    requests: {
      subtitle: "Toutes les demandes seront rassembl\xE9es ici.",
      title: "Demandes"
    },
    edit_company: {
      subtitle: "Mettre \xE0 jour les informations d'une entreprise",
      title: "Mettre \xE0 jour l'entreprise"
    },
    preferences: {
      subtitle: "G\xE9rez vos pr\xE9f\xE9rences",
      title: "Pr\xE9f\xE9rences"
    },
    security: {
      subtitle: "D\xE9finissez votre mot de passe pour acc\xE9der \xE0 la plateforme.",
      title: "S\xE9curit\xE9"
    },
    users: {
      subtitle: "Tous les utilisateurs de toutes les entreprises se rassemblent ici.",
      title: "Utilisateurs"
    },
    companies: {
      subtitle: "Voici toutes les entreprises abonn\xE9es \xE0 la plateforme.",
      title: "Entreprises"
    },
    create_company: {
      subtitle: "Ajoutez une nouvelle entreprise en fournissant la plupart de ses informations.",
      title: "Nouvelle entreprise"
    },
    teams: {
      subtitle: "Voici tout ce que vous devez savoir sur les personnes qui acc\xE8dent \xE0 la plateforme dans votre entreprise.",
      title: "\xC9quipes"
    },
    language: {
      title: "Langue"
    },
    company: {
      title: "Entreprise",
      subtitle: "G\xE9rer les membres et les licences d'une entreprise."
    },
    languages: {
      subtitle: "G\xE9rez vos langues"
    },
    contracts: {
      title: "Contrats"
    }
  },
  email: {
    addresses: {
      description: `Faites-le un par un ou collez une liste d'emails s\xE9par\xE9s par une virgule et validez avec la touche "Enter"`,
      title: "Adresses e-mail",
      empty: "Vos utilisateurs seront affich\xE9s ici"
    }
  },
  header: {
    gotoplatform: "Acc\xE9der \xE0 la plateforme",
    logout: "D\xE9connexion"
  },
  category: {
    administration: {
      title: "Administration"
    },
    team: {
      title: "\xC9quipe"
    },
    company: {
      title: "Entreprise"
    },
    customers: {
      title: "Clients"
    },
    personal: {
      title: "Personnel"
    },
    communication: {
      title: "Communication"
    }
  }
};
var action = {
  portfolios: {
    name: {
      change_success: {
        message: "Vous avez r\xE9ussi \xE0 changer le nom du portefeuille",
        title: "Le nom a \xE9t\xE9 modifi\xE9"
      }
    },
    remove: {
      loading: {
        message: "Retirer {{ asset }}(s) de votre portefeuille"
      },
      confirmation: {
        title: "Retirer du portefeuille",
        question: "\xCAtes-vous s\xFBr de vouloir retirer l'actif de ce portefeuille ?"
      }
    }
  },
  label: {
    create_key: "Cr\xE9er une cl\xE9",
    invite_member: "Ajouter un membre",
    delete: "Supprimer",
    create_user: "Cr\xE9er un utilisateur"
  },
  companies: {},
  users: {
    remove: {
      confirmation: {
        question: "\xCAtes-vous s\xFBr de vouloir supprimer ces utilisateurs ?"
      }
    }
  }
};
var panel_selection = {
  option: {
    computed_road_accessibility_distribution: "Par la route",
    typology: "Typologie",
    market_value: "Valeur de march\xE9",
    rental_space: "Surface",
    actual_rental_status_real: "\xC9tat locatif r\xE9el",
    reported_type: "Type",
    region: "R\xE9gion-Canton",
    type: "Type-Cat\xE9gorie",
    actual_market_value: "Valeur de march\xE9",
    class: "Classe",
    real_rent: "Loyer r\xE9el",
    potential_net_rent: "Loyer net",
    cost_price: "Prix de revient",
    potential_market_value: "Valeur de march\xE9",
    computed_pt_accessibility_distribution: "En transports publics",
    area: "Surface",
    actual_rental_status_target: "\xC9tat locatif cible",
    target_rent: "Loyer cible"
  },
  title: {
    group: "Regroupement",
    weight: "Pond\xE9ration"
  }
};
var watchlist = {
  dwellings: {
    empty: "Aucune liste de suivi des logements"
  },
  buildings: {
    empty: "Aucune liste de suivi des b\xE2timents"
  }
};
var treemap = {
  label: {
    value: "Valeur",
    percentage: "Pourcentage",
    label: "\xC9tiquette"
  },
  unit: {
    percentage: "%"
  }
};
var line_chart = {
  placeholder: {
    no_data_selected: "Veuillez s\xE9lectionner les donn\xE9es \xE0 afficher"
  }
};
var fund = {
  financials: {
    accounting: {
      table_action: {
        download: "T\xE9l\xE9charger le tableau comptable"
      }
    }
  },
  overview: {
    benchmark: {
      delete: "Supprimer l'indice de r\xE9f\xE9rence"
    }
  }
};
var playground = {
  display: {
    map: "Afficher la carte",
    table: "Afficher la table",
    filter: "Afficher le filtre",
    chart: "Afficher le graphique"
  },
  chart: {
    message: {}
  },
  screener: {
    message: {}
  },
  chart_selections: {}
};
var buildings = {
  type: {
    residential: "R\xE9sidentiel",
    mixed: "Mixte",
    commercial: "Commercial"
  },
  social: {
    transport_accessibility: {
      transport_accessibility: {},
      road_accessibility: {}
    }
  }
};
var option = {
  sudo: "Sudo",
  institutional: "Institutionnel",
  am: "Responsable de compte",
  owner: "Propri\xE9taire",
  admin: "Administrateur",
  user: "Utilisateur",
  manager: "Gestionnaire",
  no_plan: "Aucun plan",
  consumer: "Consommateur",
  triage: "Triage",
  investor: "Investisseur"
};
var potfolios = {
  sections: {
    description: {
      title: "Description"
    },
    assets: {
      title: "Inventaire"
    },
    environmental: {
      title: "Environnemental"
    },
    social: {
      title: "Social"
    },
    financials: {
      title: "Finances"
    }
  },
  tiles: {
    revenue: {
      title: "Revenu"
    },
    charges: {
      title: "Charges"
    },
    evolution: {
      title: "\xC9volution"
    }
  },
  widget: {
    charges: {
      title: "Charges"
    },
    revenue: {
      title: "Revenu"
    }
  }
};
var error = {
  something_went_wrong: {
    title: "Une erreur s'est produite"
  },
  notfound: {
    button: "Retour",
    code: "Erreur 404",
    subtitle: "D\xE9sol\xE9, la page que vous recherchez n'existe pas.",
    title: "Page non trouv\xE9e"
  },
  email: {
    format: "Votre e-mail n'est pas bien r\xE9dig\xE9"
  }
};
var screener_bar = {
  main_button: {
    launch: "Lancer",
    screener: "Screener"
  }
};
var traits = {
  contact: {
    office_phone: "Num\xE9ro de t\xE9l\xE9phone professionnel"
  },
  name: {
    last: "Nom de famille",
    first: "Pr\xE9nom"
  },
  email: "Adresse e-mail"
};
var table = {
  empty: "Aucune donn\xE9e (pour l'instant) nous y travaillons \u{1F3C3}",
  fund_type: {
    commercial: "Commercial",
    mixed: "Mixte",
    residential: "R\xE9sidentiel"
  },
  error: "Une erreur est survenue \u{1F647}",
  fund_legal_form: {
    foundation: "Fondation",
    listed_fund: "Fonds cot\xE9",
    real_estate_firm: "Soci\xE9t\xE9 immobili\xE8re",
    unlisted_fund: "Fonds non cot\xE9"
  },
  back_office_empty: "Tableau vide"
};
var users = {
  role: {
    user: "Utilisateur"
  },
  roles: {
    triage: "Triage",
    owner: "Propri\xE9taire"
  }
};
var multiple_select = {
  placeholder: {
    search: "Rechercher"
  },
  clear: "clair",
  not_enough_selected: {}
};
var table_actions = {
  request_download: {
    accounting: "T\xE9l\xE9charger le tableau comptable",
    csv: "T\xE9l\xE9charger les lignes s\xE9lectionn\xE9es sur la page actuelle",
    header: "T\xE9l\xE9charger en tant que"
  },
  watchlist: {
    remove: {
      button: {
        label: "Retirer les assets s\xE9lectionn\xE9s de la liste de suivi"
      }
    },
    add: {
      button: {
        label: "Suivre les actifs s\xE9lectionn\xE9s"
      }
    }
  },
  portfolios: {
    remove: {
      confirmation: {
        title: "Retirer les actifs s\xE9lectionn\xE9s du portefeuille actuel"
      }
    }
  },
  add_to_portfolios: {
    title: "Ajouter les actifs s\xE9lectionn\xE9s au portefeuille"
  }
};
var candle_stick_chart = {
  label: {
    volume: "Volume",
    low: "Bas",
    open: "Prix \xE0 l\u2019ouverture",
    close: "Fermer",
    start_date: "D\xE9but",
    high: "Haut",
    end_date: "Fin",
    turnover: "Chiffre d'affaires",
    date: "Date"
  },
  unit: {
    chf: "CHF",
    units: "Unit\xE9s"
  }
};
var header = {
  dropdown_menu: {
    profile: "Mon Profil",
    logout: "D\xE9connexion",
    settings: "Param\xE8tres",
    my_company: "Mon entreprise",
    back_office: "Administration"
  },
  navbar: {
    funds: "REIVs",
    dashboard: "Tableau de bord",
    playground: "Place de jeux",
    portfolios: "Portefeuilles",
    institutions: "REIVs",
    screener: "Immobilier",
    watchlist: "Liste de suivi",
    map: "Carte"
  }
};
var paywall = {
  subtitle: "Veuillez contacter votre responsable de compte.",
  message: {
    no_slot: "Vous n'avez actuellement aucun droit d'utiliser l'application.",
    end_trial: "Votre essai est termin\xE9.",
    out_of_scope: "Cette fonctionnalit\xE9 n'est pas incluse dans l'abonnement de votre entreprise.",
    error: "Il y a une erreur avec votre abonnement.",
    slot_out_of_scope: "Cette fonctionnalit\xE9 n'est pas incluse dans vos permissions."
  },
  button: {
    logout: "D\xE9connexion"
  }
};
var tile = {
  side_menu: {
    meter: "M\xE8tres",
    country: "Pays",
    minute: "Minutes",
    municipality: "Municipalit\xE9",
    canton: "Canton"
  },
  wrong: {
    message: "Une erreur se produit"
  },
  empty: {
    message: "Donn\xE9es manquantes"
  }
};
var gradient = {
  label: {
    low: "Bas",
    high: "Haut"
  },
  quartile_1: "1er quartile",
  quartile_2: "M\xE9diane",
  chart: {
    no_data: "Aucune donn\xE9e"
  },
  quartile_3: "3\xE8me quartile"
};
var companies = {
  notifications: {
    success_delete_enterprises: "Entreprises supprim\xE9es avec succ\xE8s",
    success_create_users: "Les utilisateurs ont cr\xE9\xE9 avec succ\xE8s",
    no_slot_available: "Aucune licence disponible"
  },
  button: {
    give_am_rights: "Accorder des droits",
    give_default_roles: "Attribuer des r\xF4les par d\xE9faut",
    clear_fund_cache: "Vider le cache de fonds",
    check_states: "V\xE9rifiez les \xE9tats",
    clear_all_cache: "Vider tout le cache",
    clear_cache: "Vider le cache",
    refresh_roles: "Rafra\xEEchir les r\xF4les"
  },
  modal: {
    confirm_delete: {
      text: "\xCAtes-vous s\xFBr de vouloir supprimer cette/ces entreprise(s) ?",
      title: "Confirmer la suppression"
    }
  }
};
var password = " Nouveau mot de passe ";
var unsaved_screener = {
  tooltip: {
    save_button: "Enregistrez vos modifications non enregistr\xE9es avec ce bouton"
  },
  button: {
    leave_page: "Proc\xE9der sans enregistrer",
    back_to_screener: "Retourner au screener"
  },
  warning: {
    content: "Vous avez une vue en cours non enregistr\xE9."
  },
  modal: {
    title: "Vous \xEAtes sur le point de quitter la page de screeener"
  }
};
var profile_train = {
  tooltip: {
    more: "{{count}} de plus"
  }
};
var unit = {
  chf_per_m2: "CHF/m\xB2"
};
var pyramid_chart = {
  label: {
    group: "Groupe",
    unit: "%",
    age: "\xC2ge",
    man: "Homme",
    woman: "Femme",
    percentage: "Pourcentage"
  }
};
var download = {
  action_label: "T\xE9l\xE9charger CSV",
  request_created: "Demande cr\xE9\xE9e."
};
var search = {
  nothing_found: "Aucun r\xE9sultat trouv\xE9",
  placeholder: "Adresses",
  title: "R\xE9sultat de recherche"
};
var overview = {
  property: {
    listed_fund: "Fonds cot\xE9",
    foundation: "Propri\xE9t\xE9 de fondation",
    unlisted_fund: "Fonds non cot\xE9",
    mixed: "Propri\xE9t\xE9 institutionnelle",
    real_estate_firm: "Soci\xE9t\xE9 immobili\xE8re"
  }
};
var valuations = {
  actions: {
    reset: "R\xE9initialiser"
  }
};
var general = {
  app_wall: {
    redirect: {
      message: "Vous n'avez actuellement pas acc\xE8s \xE0 l'application. Nous vous redirigerons vers les param\xE8tres\u2026"
    }
  }
};
var preset = {
  modal: {
    confirm_delete: {
      title: "Supprimer la vue",
      text: "\xCAtes-vous s\xFBr de vouloir supprimer cette vue ?",
      proceed: "Proc\xE9der",
      cancel: "Retour"
    }
  }
};
var time_selector = {
  header: "P\xE9riode"
};
var benchmark_selector = {
  search: {
    placeholder: "Nom de l'institution"
  },
  header: "Comparer avec"
};
var impressum = {
  mail: "Adresse e-mail:",
  text: "Impressum Quanthome SA utilise le site web app.quanthome.com pour fournir des donn\xE9es sur chaque bien immobilier.",
  address: "Adresse postale : Avenue Mon-Repos 24, 1005 Lausanne"
};
var widget = {
  side_menu: {
    municipality: "Municipalit\xE9",
    country: "Pays",
    canton: "Canton"
  }
};
var portfolio = {
  environmental: {
    evolution: {
      title: "\xC9volution"
    }
  }
};
var view = {
  switch: {
    cards: "Voir les cartes",
    table: "Voir le tableau"
  }
};
var input = {
  select: "s\xE9l\xE9ctionner",
  edit: "Modifier"
};
var single_select = {
  clear: "clair"
};
var badge = {
  beta: "Fonctionnalit\xE9 b\xEAta"
};
var boarding = {
  suggested_otp: "Application OTP sugg\xE9r\xE9e :"
};
var items = {
  array: {
    columns: {
      title: {
        potential: "Estim\xE9",
        real: "Rapport\xE9 / List\xE9",
        difference: "Diff\xE9rence"
      }
    }
  },
  charts: {
    gradient: {
      subject: {
        indice: "Indice",
        index: "Indice"
      }
    }
  }
};
var entity_selector = {
  search: "Recherche",
  button: {
    cancel: "Annuler",
    save: "Enregistrer les modifications"
  }
};
var inputs = {
  placeholder: {
    preset_name: "Nom du set de donn\xE9es",
    input_name: "Entrez le nom",
    choose_option: "Choisissez une option"
  }
};
var login = {
  error: "Erreur lors de la connexion"
};
var empty_chart = {
  message: "Aucune donn\xE9e"
};
var chart_selections = {
  chart_type: "Type de graphique",
  timespan: "P\xE9riode",
  y_axis: "Axe Y",
  fields: "Champs",
  x_axis: "Axe X",
  value: "Valeur",
  group_by: "Grouper par",
  base_100: "Base 100",
  color_by: "Colorer par"
};
var number_input = {};
var scatter_chart = {
  filtered_result: "R\xE9sultat filtr\xE9"
};
var histogram_chart = {
  tooltip: {}
};
var chart = {};
var fr_default = {
  setting,
  units,
  license_agreement,
  funds,
  screener,
  actions,
  table_header,
  highlight,
  asset_page,
  modal,
  income_statement,
  balance_sheet,
  portfolios,
  asset,
  policy,
  boarding_page,
  global,
  status,
  errors,
  double_range_input,
  common,
  footer,
  source_badge,
  dashboard,
  notification,
  administration,
  management,
  action,
  panel_selection,
  watchlist,
  treemap,
  line_chart,
  fund,
  playground,
  buildings,
  option,
  potfolios,
  error,
  screener_bar,
  traits,
  table,
  users,
  multiple_select,
  table_actions,
  candle_stick_chart,
  header,
  paywall,
  tile,
  gradient,
  companies,
  password,
  unsaved_screener,
  profile_train,
  unit,
  pyramid_chart,
  download,
  search,
  overview,
  valuations,
  general,
  preset,
  time_selector,
  benchmark_selector,
  impressum,
  widget,
  portfolio,
  view,
  input,
  single_select,
  badge,
  boarding,
  items,
  entity_selector,
  inputs,
  login,
  empty_chart,
  chart_selections,
  number_input,
  scatter_chart,
  histogram_chart,
  chart
};

export {
  setting,
  units,
  license_agreement,
  funds,
  screener,
  actions,
  table_header,
  highlight,
  asset_page,
  modal,
  income_statement,
  balance_sheet,
  portfolios,
  asset,
  policy,
  boarding_page,
  global,
  status,
  errors,
  double_range_input,
  common,
  footer,
  source_badge,
  dashboard,
  notification,
  administration,
  management,
  action,
  panel_selection,
  watchlist,
  treemap,
  line_chart,
  fund,
  playground,
  buildings,
  option,
  potfolios,
  error,
  screener_bar,
  traits,
  table,
  users,
  multiple_select,
  table_actions,
  candle_stick_chart,
  header,
  paywall,
  tile,
  gradient,
  companies,
  password,
  unsaved_screener,
  profile_train,
  unit,
  pyramid_chart,
  download,
  search,
  overview,
  valuations,
  general,
  preset,
  time_selector,
  benchmark_selector,
  impressum,
  widget,
  portfolio,
  view,
  input,
  single_select,
  badge,
  boarding,
  items,
  entity_selector,
  inputs,
  login,
  empty_chart,
  chart_selections,
  number_input,
  scatter_chart,
  histogram_chart,
  chart,
  fr_default
};
